/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date | string; output: Date | string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orderAddress?: Maybe<OrderAddress>;
  phone: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  streetDescription?: Maybe<Scalars['String']['output']>;
  streetLine: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressCountAggregate = {
  __typename?: 'AddressCountAggregate';
  _all: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  postCode: Scalars['Int']['output'];
  streetDescription: Scalars['Int']['output'];
  streetLine: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type AddressCreateInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orderAddress?: InputMaybe<OrderAddressCreateNestedOneWithoutAddressInput>;
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetLine: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddressCreateManyCustomerInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetLine: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddressCreateManyCustomerInputEnvelope = {
  data: Array<AddressCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddressCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AddressCreateManyCustomerInputEnvelope>;
};

export type AddressCreateNestedOneWithoutOrderAddressInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderAddressInput>;
  create?: InputMaybe<AddressCreateWithoutOrderAddressInput>;
};

export type AddressCreateOrConnectWithoutCustomerInput = {
  create: AddressCreateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateOrConnectWithoutOrderAddressInput = {
  create: AddressCreateWithoutOrderAddressInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutCustomerInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orderAddress?: InputMaybe<OrderAddressCreateNestedOneWithoutAddressInput>;
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetLine: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddressCreateWithoutOrderAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetLine: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AddressListRelationFilter = {
  every?: InputMaybe<AddressWhereInput>;
  none?: InputMaybe<AddressWhereInput>;
  some?: InputMaybe<AddressWhereInput>;
};

export type AddressMaxAggregate = {
  __typename?: 'AddressMaxAggregate';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  streetDescription?: Maybe<Scalars['String']['output']>;
  streetLine?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AddressMinAggregate = {
  __typename?: 'AddressMinAggregate';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  streetDescription?: Maybe<Scalars['String']['output']>;
  streetLine?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AddressNullableScalarRelationFilter = {
  is?: InputMaybe<AddressWhereInput>;
  isNot?: InputMaybe<AddressWhereInput>;
};

export type AddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  orderAddress?: InputMaybe<OrderAddressOrderByWithRelationInput>;
  phone?: InputMaybe<SortOrder>;
  postCode?: InputMaybe<SortOrder>;
  streetDescription?: InputMaybe<SortOrderInput>;
  streetLine?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum AddressScalarFieldEnum {
  City = 'city',
  Country = 'country',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  Phone = 'phone',
  PostCode = 'postCode',
  StreetDescription = 'streetDescription',
  StreetLine = 'streetLine',
  UpdatedAt = 'updatedAt'
}

export type AddressScalarWhereInput = {
  AND?: InputMaybe<Array<AddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereInput>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  postCode?: InputMaybe<StringFilter>;
  streetDescription?: InputMaybe<StringNullableFilter>;
  streetLine?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AddressUpdateInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderAddress?: InputMaybe<OrderAddressUpdateOneWithoutAddressNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetLine?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateManyMutationInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetLine?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateManyWithWhereWithoutCustomerInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AddressCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type AddressUpdateOneWithoutOrderAddressNestedInput = {
  connect?: InputMaybe<AddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AddressCreateOrConnectWithoutOrderAddressInput>;
  create?: InputMaybe<AddressCreateWithoutOrderAddressInput>;
  delete?: InputMaybe<AddressWhereInput>;
  disconnect?: InputMaybe<AddressWhereInput>;
  update?: InputMaybe<AddressUpdateToOneWithWhereWithoutOrderAddressInput>;
  upsert?: InputMaybe<AddressUpsertWithoutOrderAddressInput>;
};

export type AddressUpdateToOneWithWhereWithoutOrderAddressInput = {
  data: AddressUpdateWithoutOrderAddressInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressUpdateWithWhereUniqueWithoutCustomerInput = {
  data: AddressUpdateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithoutCustomerInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderAddress?: InputMaybe<OrderAddressUpdateOneWithoutAddressNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetLine?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpdateWithoutOrderAddressInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetLine?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AddressUpsertWithWhereUniqueWithoutCustomerInput = {
  create: AddressCreateWithoutCustomerInput;
  update: AddressUpdateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpsertWithoutOrderAddressInput = {
  create: AddressCreateWithoutOrderAddressInput;
  update: AddressUpdateWithoutOrderAddressInput;
  where?: InputMaybe<AddressWhereInput>;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orderAddress?: InputMaybe<OrderAddressNullableScalarRelationFilter>;
  phone?: InputMaybe<StringFilter>;
  postCode?: InputMaybe<StringFilter>;
  streetDescription?: InputMaybe<StringNullableFilter>;
  streetLine?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type AddressWhereUniqueInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orderAddress?: InputMaybe<OrderAddressNullableScalarRelationFilter>;
  phone?: InputMaybe<StringFilter>;
  postCode?: InputMaybe<StringFilter>;
  streetDescription?: InputMaybe<StringNullableFilter>;
  streetLine?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BroadcastFailedJob = {
  __typename?: 'BroadcastFailedJob';
  failedAt?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type BroadcastQueueStatus = {
  __typename?: 'BroadcastQueueStatus';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  paused: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type BytesNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum CancellationSource {
  Admin = 'ADMIN',
  Customer = 'CUSTOMER'
}

export type Comment = {
  __typename?: 'Comment';
  _count: CommentCount;
  body: Scalars['String']['output'];
  commentId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  parent?: Maybe<Comment>;
  parentId?: Maybe<Scalars['String']['output']>;
  postId: Scalars['String']['output'];
  replies?: Maybe<Array<Comment>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CommentRepliesArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};

export type CommentCount = {
  __typename?: 'CommentCount';
  replies: Scalars['Int']['output'];
};

export type CommentCountAggregate = {
  __typename?: 'CommentCountAggregate';
  _all: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  commentId: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  parentId: Scalars['Int']['output'];
  postId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CommentCreateInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutCommentsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CommentCreateNestedOneWithoutRepliesInput>;
  postId: Scalars['String']['input'];
  replies?: InputMaybe<CommentCreateNestedManyWithoutParentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentCreateManyCustomerInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentCreateManyCustomerInputEnvelope = {
  data: Array<CommentCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentCreateManyParentInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentCreateManyParentInputEnvelope = {
  data: Array<CommentCreateManyParentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommentCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<CommentCreateManyCustomerInputEnvelope>;
};

export type CommentCreateNestedManyWithoutParentInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutParentInput>>;
  createMany?: InputMaybe<CommentCreateManyParentInputEnvelope>;
};

export type CommentCreateNestedOneWithoutRepliesInput = {
  connect?: InputMaybe<CommentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommentCreateOrConnectWithoutRepliesInput>;
  create?: InputMaybe<CommentCreateWithoutRepliesInput>;
};

export type CommentCreateOrConnectWithoutCustomerInput = {
  create: CommentCreateWithoutCustomerInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutParentInput = {
  create: CommentCreateWithoutParentInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateOrConnectWithoutRepliesInput = {
  create: CommentCreateWithoutRepliesInput;
  where: CommentWhereUniqueInput;
};

export type CommentCreateWithoutCustomerInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CommentCreateNestedOneWithoutRepliesInput>;
  postId: Scalars['String']['input'];
  replies?: InputMaybe<CommentCreateNestedManyWithoutParentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentCreateWithoutParentInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutCommentsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['String']['input'];
  replies?: InputMaybe<CommentCreateNestedManyWithoutParentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentCreateWithoutRepliesInput = {
  body: Scalars['String']['input'];
  commentId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutCommentsInput;
  id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CommentCreateNestedOneWithoutRepliesInput>;
  postId: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CommentListRelationFilter = {
  every?: InputMaybe<CommentWhereInput>;
  none?: InputMaybe<CommentWhereInput>;
  some?: InputMaybe<CommentWhereInput>;
};

export type CommentMaxAggregate = {
  __typename?: 'CommentMaxAggregate';
  body?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommentMinAggregate = {
  __typename?: 'CommentMinAggregate';
  body?: Maybe<Scalars['String']['output']>;
  commentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  postId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CommentNullableScalarRelationFilter = {
  is?: InputMaybe<CommentWhereInput>;
  isNot?: InputMaybe<CommentWhereInput>;
};

export type CommentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CommentOrderByWithRelationInput = {
  body?: InputMaybe<SortOrder>;
  commentId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parent?: InputMaybe<CommentOrderByWithRelationInput>;
  parentId?: InputMaybe<SortOrderInput>;
  postId?: InputMaybe<SortOrder>;
  replies?: InputMaybe<CommentOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CommentPage = {
  __typename?: 'CommentPage';
  items: Array<Comment>;
  totalCount: Scalars['Int']['output'];
};

export enum CommentScalarFieldEnum {
  Body = 'body',
  CommentId = 'commentId',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  ParentId = 'parentId',
  PostId = 'postId',
  UpdatedAt = 'updatedAt'
}

export type CommentScalarWhereInput = {
  AND?: InputMaybe<Array<CommentScalarWhereInput>>;
  NOT?: InputMaybe<Array<CommentScalarWhereInput>>;
  OR?: InputMaybe<Array<CommentScalarWhereInput>>;
  body?: InputMaybe<StringFilter>;
  commentId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CommentUpdateInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  commentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutCommentsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<CommentUpdateOneWithoutRepliesNestedInput>;
  postId?: InputMaybe<StringFieldUpdateOperationsInput>;
  replies?: InputMaybe<CommentUpdateManyWithoutParentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CommentUpdateManyMutationInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  commentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  postId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CommentUpdateManyWithWhereWithoutCustomerInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithWhereWithoutParentInput = {
  data: CommentUpdateManyMutationInput;
  where: CommentScalarWhereInput;
};

export type CommentUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<CommentCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type CommentUpdateManyWithoutParentNestedInput = {
  connect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CommentCreateOrConnectWithoutParentInput>>;
  create?: InputMaybe<Array<CommentCreateWithoutParentInput>>;
  createMany?: InputMaybe<CommentCreateManyParentInputEnvelope>;
  delete?: InputMaybe<Array<CommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CommentWhereUniqueInput>>;
  set?: InputMaybe<Array<CommentWhereUniqueInput>>;
  update?: InputMaybe<Array<CommentUpdateWithWhereUniqueWithoutParentInput>>;
  updateMany?: InputMaybe<Array<CommentUpdateManyWithWhereWithoutParentInput>>;
  upsert?: InputMaybe<Array<CommentUpsertWithWhereUniqueWithoutParentInput>>;
};

export type CommentUpdateOneWithoutRepliesNestedInput = {
  connect?: InputMaybe<CommentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CommentCreateOrConnectWithoutRepliesInput>;
  create?: InputMaybe<CommentCreateWithoutRepliesInput>;
  delete?: InputMaybe<CommentWhereInput>;
  disconnect?: InputMaybe<CommentWhereInput>;
  update?: InputMaybe<CommentUpdateToOneWithWhereWithoutRepliesInput>;
  upsert?: InputMaybe<CommentUpsertWithoutRepliesInput>;
};

export type CommentUpdateToOneWithWhereWithoutRepliesInput = {
  data: CommentUpdateWithoutRepliesInput;
  where?: InputMaybe<CommentWhereInput>;
};

export type CommentUpdateWithWhereUniqueWithoutCustomerInput = {
  data: CommentUpdateWithoutCustomerInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithWhereUniqueWithoutParentInput = {
  data: CommentUpdateWithoutParentInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpdateWithoutCustomerInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  commentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<CommentUpdateOneWithoutRepliesNestedInput>;
  postId?: InputMaybe<StringFieldUpdateOperationsInput>;
  replies?: InputMaybe<CommentUpdateManyWithoutParentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CommentUpdateWithoutParentInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  commentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutCommentsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  postId?: InputMaybe<StringFieldUpdateOperationsInput>;
  replies?: InputMaybe<CommentUpdateManyWithoutParentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CommentUpdateWithoutRepliesInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  commentId?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutCommentsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  parent?: InputMaybe<CommentUpdateOneWithoutRepliesNestedInput>;
  postId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CommentUpsertWithWhereUniqueWithoutCustomerInput = {
  create: CommentCreateWithoutCustomerInput;
  update: CommentUpdateWithoutCustomerInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithWhereUniqueWithoutParentInput = {
  create: CommentCreateWithoutParentInput;
  update: CommentUpdateWithoutParentInput;
  where: CommentWhereUniqueInput;
};

export type CommentUpsertWithoutRepliesInput = {
  create: CommentCreateWithoutRepliesInput;
  update: CommentUpdateWithoutRepliesInput;
  where?: InputMaybe<CommentWhereInput>;
};

export type CommentWhereInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  NOT?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  body?: InputMaybe<StringFilter>;
  commentId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  parent?: InputMaybe<CommentNullableScalarRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<StringFilter>;
  replies?: InputMaybe<CommentListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CommentWhereUniqueInput = {
  AND?: InputMaybe<Array<CommentWhereInput>>;
  NOT?: InputMaybe<Array<CommentWhereInput>>;
  OR?: InputMaybe<Array<CommentWhereInput>>;
  body?: InputMaybe<StringFilter>;
  commentId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CommentNullableScalarRelationFilter>;
  parentId?: InputMaybe<StringNullableFilter>;
  postId?: InputMaybe<StringFilter>;
  replies?: InputMaybe<CommentListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Customer = {
  __typename?: 'Customer';
  _count: CustomerCount;
  active: Scalars['Boolean']['output'];
  addresses?: Maybe<Array<Address>>;
  avatar?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Comment>>;
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messages?: Maybe<Array<Message>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  pageId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  refunds?: Maybe<Array<Refund>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type CustomerMessagesArgs = {
  cursor?: InputMaybe<MessageWhereUniqueInput>;
  distinct?: InputMaybe<Array<MessageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MessageOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MessageWhereInput>;
};


export type CustomerOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};

export type CustomerCount = {
  __typename?: 'CustomerCount';
  addresses: Scalars['Int']['output'];
  comments: Scalars['Int']['output'];
  messages: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  refunds: Scalars['Int']['output'];
};

export type CustomerCountAggregate = {
  __typename?: 'CustomerCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  avatar: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  iban: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  pageId: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CustomerCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<MessageCreateNestedManyWithoutCustomerInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  pageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutCustomerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<CustomerCreateWithoutAddressesInput>;
};

export type CustomerCreateNestedOneWithoutCommentsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<CustomerCreateWithoutCommentsInput>;
};

export type CustomerCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CustomerCreateWithoutOrdersInput>;
};

export type CustomerCreateNestedOneWithoutRefundsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<CustomerCreateWithoutRefundsInput>;
};

export type CustomerCreateOrConnectWithoutAddressesInput = {
  create: CustomerCreateWithoutAddressesInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutCommentsInput = {
  create: CustomerCreateWithoutCommentsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutOrdersInput = {
  create: CustomerCreateWithoutOrdersInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutRefundsInput = {
  create: CustomerCreateWithoutRefundsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateWithoutAddressesInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<MessageCreateNestedManyWithoutCustomerInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  pageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutCustomerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerCreateWithoutCommentsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<MessageCreateNestedManyWithoutCustomerInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  pageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutCustomerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerCreateWithoutOrdersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<MessageCreateNestedManyWithoutCustomerInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  refunds?: InputMaybe<RefundCreateNestedManyWithoutCustomerInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerCreateWithoutRefundsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<CommentCreateNestedManyWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<MessageCreateNestedManyWithoutCustomerInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  pageId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CustomerMaxAggregate = {
  __typename?: 'CustomerMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerMinAggregate = {
  __typename?: 'CustomerMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pageId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  avatar?: InputMaybe<SortOrderInput>;
  comments?: InputMaybe<CommentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  iban?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  pageId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrderInput>;
  refunds?: InputMaybe<RefundOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum CustomerScalarFieldEnum {
  Active = 'active',
  Avatar = 'avatar',
  CreatedAt = 'createdAt',
  Email = 'email',
  Iban = 'iban',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  PageId = 'pageId',
  Reason = 'reason',
  UpdatedAt = 'updatedAt'
}

export type CustomerScalarRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCustomerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<MessageUpdateManyWithoutCustomerNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutCustomerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateOneRequiredWithoutAddressesNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<CustomerCreateWithoutAddressesInput>;
  update?: InputMaybe<CustomerUpdateToOneWithWhereWithoutAddressesInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutAddressesInput>;
};

export type CustomerUpdateOneRequiredWithoutCommentsNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutCommentsInput>;
  create?: InputMaybe<CustomerCreateWithoutCommentsInput>;
  update?: InputMaybe<CustomerUpdateToOneWithWhereWithoutCommentsInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutCommentsInput>;
};

export type CustomerUpdateOneRequiredWithoutOrdersNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CustomerCreateWithoutOrdersInput>;
  update?: InputMaybe<CustomerUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutOrdersInput>;
};

export type CustomerUpdateOneRequiredWithoutRefundsNestedInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutRefundsInput>;
  create?: InputMaybe<CustomerCreateWithoutRefundsInput>;
  update?: InputMaybe<CustomerUpdateToOneWithWhereWithoutRefundsInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutRefundsInput>;
};

export type CustomerUpdateToOneWithWhereWithoutAddressesInput = {
  data: CustomerUpdateWithoutAddressesInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateToOneWithWhereWithoutCommentsInput = {
  data: CustomerUpdateWithoutCommentsInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateToOneWithWhereWithoutOrdersInput = {
  data: CustomerUpdateWithoutOrdersInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateToOneWithWhereWithoutRefundsInput = {
  data: CustomerUpdateWithoutRefundsInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpdateWithoutAddressesInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCustomerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<MessageUpdateManyWithoutCustomerNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutCustomerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutCommentsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<MessageUpdateManyWithoutCustomerNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutCustomerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutOrdersInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCustomerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<MessageUpdateManyWithoutCustomerNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  refunds?: InputMaybe<RefundUpdateManyWithoutCustomerNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutRefundsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerNestedInput>;
  avatar?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<CommentUpdateManyWithoutCustomerNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  messages?: InputMaybe<MessageUpdateManyWithoutCustomerNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  pageId?: InputMaybe<StringFieldUpdateOperationsInput>;
  reason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpsertWithoutAddressesInput = {
  create: CustomerCreateWithoutAddressesInput;
  update: CustomerUpdateWithoutAddressesInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpsertWithoutCommentsInput = {
  create: CustomerCreateWithoutCommentsInput;
  update: CustomerUpdateWithoutCommentsInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpsertWithoutOrdersInput = {
  create: CustomerCreateWithoutOrdersInput;
  update: CustomerUpdateWithoutOrdersInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerUpsertWithoutRefundsInput = {
  create: CustomerCreateWithoutRefundsInput;
  update: CustomerUpdateWithoutRefundsInput;
  where?: InputMaybe<CustomerWhereInput>;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  messages?: InputMaybe<MessageListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  pageId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringNullableFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerWhereUniqueInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  avatar?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<CommentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<MessageListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  pageId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<StringNullableFilter>;
  refunds?: InputMaybe<RefundListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type EnumOrderLineStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderLineStatus>;
};

export type EnumOrderLineStatusFilter = {
  equals?: InputMaybe<OrderLineStatus>;
  in?: InputMaybe<Array<OrderLineStatus>>;
  not?: InputMaybe<NestedEnumOrderLineStatusFilter>;
  notIn?: InputMaybe<Array<OrderLineStatus>>;
};

export type EnumOrderLineTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderLineType>;
};

export type EnumOrderLineTypeFilter = {
  equals?: InputMaybe<OrderLineType>;
  in?: InputMaybe<Array<OrderLineType>>;
  not?: InputMaybe<NestedEnumOrderLineTypeFilter>;
  notIn?: InputMaybe<Array<OrderLineType>>;
};

export type EnumOrderStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderStatus>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumPaymentStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentStatus>;
};

export type EnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type EnumRefundStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<RefundStatus>;
};

export type EnumRefundStatusFilter = {
  equals?: InputMaybe<RefundStatus>;
  in?: InputMaybe<Array<RefundStatus>>;
  not?: InputMaybe<NestedEnumRefundStatusFilter>;
  notIn?: InputMaybe<Array<RefundStatus>>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<Role>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type Expense = {
  __typename?: 'Expense';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  type: ExpenseType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ExpenseAvgAggregate = {
  __typename?: 'ExpenseAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type ExpenseCountAggregate = {
  __typename?: 'ExpenseCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ExpenseMaxAggregate = {
  __typename?: 'ExpenseMaxAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExpenseType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseMinAggregate = {
  __typename?: 'ExpenseMinAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ExpenseType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExpenseSumAggregate = {
  __typename?: 'ExpenseSumAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
};

export enum ExpenseType {
  OneOff = 'ONE_OFF',
  Regular = 'REGULAR'
}

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Invoice = {
  __typename?: 'Invoice';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  number: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type InvoiceCountAggregate = {
  __typename?: 'InvoiceCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  number: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  url: Scalars['Int']['output'];
};

export type InvoiceCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InvoiceCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<InvoiceCreateWithoutOrderInput>;
};

export type InvoiceCreateOrConnectWithoutOrderInput = {
  create: InvoiceCreateWithoutOrderInput;
  where: InvoiceWhereUniqueInput;
};

export type InvoiceCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  number: Scalars['String']['input'];
  sent?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceMaxAggregate = {
  __typename?: 'InvoiceMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InvoiceMinAggregate = {
  __typename?: 'InvoiceMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  sent?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type InvoiceNullableScalarRelationFilter = {
  is?: InputMaybe<InvoiceWhereInput>;
  isNot?: InputMaybe<InvoiceWhereInput>;
};

export type InvoiceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  number?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  sent?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrderInput>;
};

export type InvoiceUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<InvoiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InvoiceCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<InvoiceCreateWithoutOrderInput>;
  delete?: InputMaybe<InvoiceWhereInput>;
  disconnect?: InputMaybe<InvoiceWhereInput>;
  update?: InputMaybe<InvoiceUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<InvoiceUpsertWithoutOrderInput>;
};

export type InvoiceUpdateToOneWithWhereWithoutOrderInput = {
  data: InvoiceUpdateWithoutOrderInput;
  where?: InputMaybe<InvoiceWhereInput>;
};

export type InvoiceUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  number?: InputMaybe<StringFieldUpdateOperationsInput>;
  sent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type InvoiceUpsertWithoutOrderInput = {
  create: InvoiceCreateWithoutOrderInput;
  update: InvoiceUpdateWithoutOrderInput;
  where?: InputMaybe<InvoiceWhereInput>;
};

export type InvoiceWhereInput = {
  AND?: InputMaybe<Array<InvoiceWhereInput>>;
  NOT?: InputMaybe<Array<InvoiceWhereInput>>;
  OR?: InputMaybe<Array<InvoiceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  number?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  sent?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type InvoiceWhereUniqueInput = {
  AND?: InputMaybe<Array<InvoiceWhereInput>>;
  NOT?: InputMaybe<Array<InvoiceWhereInput>>;
  OR?: InputMaybe<Array<InvoiceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  number?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  sent?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']['input']>;
  array_ends_with?: InputMaybe<Scalars['JSON']['input']>;
  array_starts_with?: InputMaybe<Scalars['JSON']['input']>;
  equals?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  string_contains?: InputMaybe<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export type Live = {
  __typename?: 'Live';
  _count: LiveCount;
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  products?: Maybe<Array<Product>>;
  updatedAt: Scalars['DateTime']['output'];
};


export type LiveOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type LiveProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};

export type LiveBreakdown = {
  __typename?: 'LiveBreakdown';
  liveDate?: Maybe<Scalars['DateTime']['output']>;
  liveId: Scalars['String']['output'];
  liveName: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  productRevenue: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type LiveCount = {
  __typename?: 'LiveCount';
  orders: Scalars['Int']['output'];
  products: Scalars['Int']['output'];
};

export type LiveCountAggregate = {
  __typename?: 'LiveCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  date: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type LiveCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutLiveInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutLiveInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LiveCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<LiveWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LiveCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<LiveCreateWithoutOrdersInput>;
};

export type LiveCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<LiveWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LiveCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<LiveCreateWithoutProductsInput>;
};

export type LiveCreateOrConnectWithoutOrdersInput = {
  create: LiveCreateWithoutOrdersInput;
  where: LiveWhereUniqueInput;
};

export type LiveCreateOrConnectWithoutProductsInput = {
  create: LiveCreateWithoutProductsInput;
  where: LiveWhereUniqueInput;
};

export type LiveCreateWithoutOrdersInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  products?: InputMaybe<ProductCreateNestedManyWithoutLiveInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LiveCreateWithoutProductsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutLiveInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LiveMaxAggregate = {
  __typename?: 'LiveMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LiveMinAggregate = {
  __typename?: 'LiveMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LiveOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LiveOrdersSummary = {
  __typename?: 'LiveOrdersSummary';
  all: OrderBucket;
  bank: OrderBucket;
  card: OrderBucket;
  cash: OrderBucket;
  cod: OrderBucket;
  confirmed: OrderBucket;
  created: OrderBucket;
  delivered: OrderBucket;
  leftBank: OrderBucket;
  leftCard: OrderBucket;
  leftCods: OrderBucket;
  leftPersonal: OrderBucket;
  packed: OrderBucket;
  paymentProblems: OrderBucket;
  processed: OrderBucket;
  reserved: OrderBucket;
  reviewing: OrderBucket;
  shipped: OrderBucket;
  unpaidBank: OrderBucket;
  unpaidCard: OrderBucket;
  unpaidCods: OrderBucket;
};

export enum LiveScalarFieldEnum {
  Active = 'active',
  CreatedAt = 'createdAt',
  Date = 'date',
  Description = 'description',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type LiveScalarRelationFilter = {
  is?: InputMaybe<LiveWhereInput>;
  isNot?: InputMaybe<LiveWhereInput>;
};

export type LiveStatisticsInterval = {
  __typename?: 'LiveStatisticsInterval';
  cancelledCount: Scalars['Int']['output'];
  cancelledTotal: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  interval: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type LiveStatisticsProduct = {
  __typename?: 'LiveStatisticsProduct';
  cancelledCount: Scalars['Int']['output'];
  cancelledTotal: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export type LiveStatisticsResult = {
  __typename?: 'LiveStatisticsResult';
  adminCancelledCount: Scalars['Int']['output'];
  adminCancelledCustomerCount: Scalars['Int']['output'];
  adminCancelledTotal: Scalars['Float']['output'];
  cancelledCount: Scalars['Int']['output'];
  cancelledTotal: Scalars['Float']['output'];
  intervals: Array<LiveStatisticsInterval>;
  products: Array<LiveStatisticsProduct>;
  realLostCustomerCount: Scalars['Int']['output'];
  realLostTotal: Scalars['Float']['output'];
  swapCustomerCount: Scalars['Int']['output'];
  swapTotal: Scalars['Float']['output'];
};

export type LiveUnpackedLinesResponse = {
  __typename?: 'LiveUnpackedLinesResponse';
  lines: Array<OrderLine>;
  total: Scalars['Int']['output'];
};

export type LiveUnprintedLabelsResponse = {
  __typename?: 'LiveUnprintedLabelsResponse';
  orders: Array<Order>;
  total: Scalars['Int']['output'];
};

export type LiveUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutLiveNestedInput>;
  products?: InputMaybe<ProductUpdateManyWithoutLiveNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LiveUpdateOneRequiredWithoutOrdersNestedInput = {
  connect?: InputMaybe<LiveWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LiveCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<LiveCreateWithoutOrdersInput>;
  update?: InputMaybe<LiveUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<LiveUpsertWithoutOrdersInput>;
};

export type LiveUpdateOneRequiredWithoutProductsNestedInput = {
  connect?: InputMaybe<LiveWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LiveCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<LiveCreateWithoutProductsInput>;
  update?: InputMaybe<LiveUpdateToOneWithWhereWithoutProductsInput>;
  upsert?: InputMaybe<LiveUpsertWithoutProductsInput>;
};

export type LiveUpdateToOneWithWhereWithoutOrdersInput = {
  data: LiveUpdateWithoutOrdersInput;
  where?: InputMaybe<LiveWhereInput>;
};

export type LiveUpdateToOneWithWhereWithoutProductsInput = {
  data: LiveUpdateWithoutProductsInput;
  where?: InputMaybe<LiveWhereInput>;
};

export type LiveUpdateWithoutOrdersInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductUpdateManyWithoutLiveNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LiveUpdateWithoutProductsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutLiveNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LiveUpsertWithoutOrdersInput = {
  create: LiveCreateWithoutOrdersInput;
  update: LiveUpdateWithoutOrdersInput;
  where?: InputMaybe<LiveWhereInput>;
};

export type LiveUpsertWithoutProductsInput = {
  create: LiveCreateWithoutProductsInput;
  update: LiveUpdateWithoutProductsInput;
  where?: InputMaybe<LiveWhereInput>;
};

export type LiveWhereInput = {
  AND?: InputMaybe<Array<LiveWhereInput>>;
  NOT?: InputMaybe<Array<LiveWhereInput>>;
  OR?: InputMaybe<Array<LiveWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LiveWhereUniqueInput = {
  AND?: InputMaybe<Array<LiveWhereInput>>;
  NOT?: InputMaybe<Array<LiveWhereInput>>;
  OR?: InputMaybe<Array<LiveWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Message = {
  __typename?: 'Message';
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEcho: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MessageCountAggregate = {
  __typename?: 'MessageCountAggregate';
  _all: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isEcho: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type MessageCreateManyCustomerInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEcho?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageCreateManyCustomerInputEnvelope = {
  data: Array<MessageCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<MessageCreateManyCustomerInputEnvelope>;
};

export type MessageCreateOrConnectWithoutCustomerInput = {
  create: MessageCreateWithoutCustomerInput;
  where: MessageWhereUniqueInput;
};

export type MessageCreateWithoutCustomerInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEcho?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MessageListRelationFilter = {
  every?: InputMaybe<MessageWhereInput>;
  none?: InputMaybe<MessageWhereInput>;
  some?: InputMaybe<MessageWhereInput>;
};

export type MessageMaxAggregate = {
  __typename?: 'MessageMaxAggregate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEcho?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageMinAggregate = {
  __typename?: 'MessageMinAggregate';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isEcho?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MessageOrderByWithRelationInput = {
  body?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isEcho?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum MessageScalarFieldEnum {
  Body = 'body',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  IsEcho = 'isEcho',
  Metadata = 'metadata',
  UpdatedAt = 'updatedAt'
}

export type MessageScalarWhereInput = {
  AND?: InputMaybe<Array<MessageScalarWhereInput>>;
  NOT?: InputMaybe<Array<MessageScalarWhereInput>>;
  OR?: InputMaybe<Array<MessageScalarWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isEcho?: InputMaybe<BoolFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageUpdateManyMutationInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEcho?: InputMaybe<BoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpdateManyWithWhereWithoutCustomerInput = {
  data: MessageUpdateManyMutationInput;
  where: MessageScalarWhereInput;
};

export type MessageUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<MessageCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<MessageCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<MessageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MessageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>;
  set?: InputMaybe<Array<MessageWhereUniqueInput>>;
  update?: InputMaybe<Array<MessageUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<MessageUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<MessageUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type MessageUpdateWithWhereUniqueWithoutCustomerInput = {
  data: MessageUpdateWithoutCustomerInput;
  where: MessageWhereUniqueInput;
};

export type MessageUpdateWithoutCustomerInput = {
  body?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isEcho?: InputMaybe<BoolFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type MessageUpsertWithWhereUniqueWithoutCustomerInput = {
  create: MessageCreateWithoutCustomerInput;
  update: MessageUpdateWithoutCustomerInput;
  where: MessageWhereUniqueInput;
};

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isEcho?: InputMaybe<BoolFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type MessageWhereUniqueInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  body?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  isEcho?: InputMaybe<BoolFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addVariantToProduct: ProductVariant;
  bulkUpdateProductDetails: Scalars['Int']['output'];
  bulkUpdateProductPrice: Scalars['Int']['output'];
  cancelOrder: Order;
  clearShippingAndPaymentMethodOnCheckoutOrder: Order;
  confirmCheckoutOrder: Order;
  createAddress: Address;
  createComment: Comment;
  createCustomer: Customer;
  createExpense: Expense;
  createLive: Live;
  createOrder: Order;
  createProduct: Product;
  createRefund: Refund;
  createShipment: Order;
  createShipmentDPD: Order;
  createUser: User;
  decrementVariantStock: ProductVariant;
  deleteAddress: Address;
  deleteComment: Comment;
  deleteCustomer: Customer;
  deleteExpense: Expense;
  deleteLive: Live;
  deleteOrder: Order;
  deletePayment: Payment;
  deleteProduct: Product;
  deleteRefund: Refund;
  deleteShipment: Order;
  deleteUser: User;
  incrementVariantStock: ProductVariant;
  issueInvoice: Invoice;
  issueInvoices: Scalars['Float']['output'];
  processOrder: Order;
  recalculateOrderTotal: Order;
  removeLineFromCheckout: OrderLine;
  removeLineFromOrder: Order;
  removeProductVariantFromOrders: Scalars['Boolean']['output'];
  removeProductVariantOrderLine: Scalars['Boolean']['output'];
  replyCommentTo: Scalars['String']['output'];
  sendBroadcast: Scalars['Int']['output'];
  sendCheckoutLinks: Scalars['Int']['output'];
  sendMessage: Scalars['Boolean']['output'];
  sendMessages: Scalars['Boolean']['output'];
  sendProductAttachment: Scalars['Float']['output'];
  sendProductMessage: Scalars['Float']['output'];
  setAddressOnCheckoutOrder: Order;
  setIbanType: Order;
  setLiveMotto: Scalars['String']['output'];
  setNoteOnCheckoutOrder: Order;
  setPaymentMethodOnCheckoutOrder: Order;
  setPaymentMethodOnOrder: Order;
  setShippingMethodOnCheckoutOrder: Order;
  setShippingMethodOnOrder: Order;
  signIn: SignInResponse;
  signOut: SignOutResponse;
  signUp: SignUpResponse;
  testPreorders: Scalars['Float']['output'];
  toggleLiveActive: Live;
  updateAddress: Address;
  updateComment: Comment;
  updateCustomer: Customer;
  updateExpense: Expense;
  updateLineOnOrder: OrderLine;
  updateLive: Live;
  updateOrder: Order;
  updateOrderCustomer: Order;
  updatePayment: Payment;
  updateProduct: Product;
  updateRefund: Refund;
  updateShippingMethod: ShippingMethod;
  updateUser: User;
  upsertAddress: Address;
  upsertAddressOnCheckoutOrder: Order;
  upsertComment: Comment;
  upsertCustomer: Customer;
  upsertLineOnOrder: Order;
  upsertLive: Live;
  upsertOrder: Order;
  upsertOrderAddress: Order;
  upsertProduct: Product;
  upsertRefund: Refund;
  upsertSetting: Setting;
  upsertUser: User;
};


export type MutationAddVariantToProductArgs = {
  attributes: Array<ProductVariantAttributeCreateWithoutVariantInput>;
  productId: Scalars['String']['input'];
  stock: Scalars['Int']['input'];
};


export type MutationBulkUpdateProductDetailsArgs = {
  newDescription?: InputMaybe<Scalars['String']['input']>;
  newName: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationBulkUpdateProductPriceArgs = {
  message: Scalars['String']['input'];
  newPrice: Scalars['Int']['input'];
  productId: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClearShippingAndPaymentMethodOnCheckoutOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationConfirmCheckoutOrderArgs = {
  isPersonal: Scalars['Boolean']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateAddressArgs = {
  data: AddressCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateCommentArgs = {
  data: CommentCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateCustomerArgs = {
  data: CustomerCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateExpenseArgs = {
  amount: Scalars['Int']['input'];
  date?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  type?: ExpenseType;
};


export type MutationCreateLiveArgs = {
  data: LiveCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateOrderArgs = {
  data: OrderCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateProductArgs = {
  data: ProductCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateRefundArgs = {
  data: RefundCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationCreateShipmentArgs = {
  count: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateShipmentDpdArgs = {
  count: Scalars['Int']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
};


export type MutationDecrementVariantStockArgs = {
  decrement: Scalars['Int']['input'];
  productVariantId: Scalars['String']['input'];
};


export type MutationDeleteAddressArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: AddressWhereUniqueInput;
};


export type MutationDeleteCommentArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: CommentWhereUniqueInput;
};


export type MutationDeleteCustomerArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: CustomerWhereUniqueInput;
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLiveArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: LiveWhereUniqueInput;
};


export type MutationDeleteOrderArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: OrderWhereUniqueInput;
};


export type MutationDeletePaymentArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: PaymentWhereUniqueInput;
};


export type MutationDeleteProductArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: ProductWhereUniqueInput;
};


export type MutationDeleteRefundArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: RefundWhereUniqueInput;
};


export type MutationDeleteShipmentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: UserWhereUniqueInput;
};


export type MutationIncrementVariantStockArgs = {
  increment: Scalars['Int']['input'];
  productVariantId: Scalars['String']['input'];
};


export type MutationIssueInvoiceArgs = {
  orderId: Scalars['String']['input'];
  shouldSend: Scalars['Boolean']['input'];
};


export type MutationIssueInvoicesArgs = {
  orderIds: Array<Scalars['String']['input']>;
};


export type MutationProcessOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationRecalculateOrderTotalArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationRemoveLineFromCheckoutArgs = {
  lineId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationRemoveLineFromOrderArgs = {
  lineId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveProductVariantFromOrdersArgs = {
  message: Scalars['String']['input'];
  productVarianId: Scalars['String']['input'];
};


export type MutationRemoveProductVariantOrderLineArgs = {
  lineId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationReplyCommentToArgs = {
  message: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
};


export type MutationSendBroadcastArgs = {
  limit: Scalars['Int']['input'];
  message: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip: Scalars['Int']['input'];
  url: Scalars['String']['input'];
  where: CustomerWhereInput;
};


export type MutationSendCheckoutLinksArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: LiveWhereUniqueInput;
};


export type MutationSendMessageArgs = {
  message: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationSendMessagesArgs = {
  message: Scalars['String']['input'];
  orderIds: Array<Scalars['String']['input']>;
};


export type MutationSendProductAttachmentArgs = {
  productVariantId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationSendProductMessageArgs = {
  message: Scalars['String']['input'];
  productVariantId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};


export type MutationSetAddressOnCheckoutOrderArgs = {
  addressId: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationSetIbanTypeArgs = {
  ibanType: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationSetLiveMottoArgs = {
  motto: Scalars['String']['input'];
};


export type MutationSetNoteOnCheckoutOrderArgs = {
  note: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
};


export type MutationSetPaymentMethodOnCheckoutOrderArgs = {
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationSetPaymentMethodOnOrderArgs = {
  orderId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationSetShippingMethodOnCheckoutOrderArgs = {
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['String']['input'];
  shippingMethodId: Scalars['String']['input'];
};


export type MutationSetShippingMethodOnOrderArgs = {
  orderId: Scalars['String']['input'];
  shippingMethodId: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  data: SignInInput;
};


export type MutationSignUpArgs = {
  data: SignUpInput;
};


export type MutationTestPreordersArgs = {
  json: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationToggleLiveActiveArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: LiveWhereUniqueInput;
};


export type MutationUpdateAddressArgs = {
  data: AddressUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: AddressWhereUniqueInput;
};


export type MutationUpdateCommentArgs = {
  data: CommentUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: CommentWhereUniqueInput;
};


export type MutationUpdateCustomerArgs = {
  data: CustomerUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: CustomerWhereUniqueInput;
};


export type MutationUpdateExpenseArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ExpenseType>;
};


export type MutationUpdateLineOnOrderArgs = {
  input: OrderLineUpdateWithoutOrderInput;
  lineId: Scalars['String']['input'];
};


export type MutationUpdateLiveArgs = {
  data: LiveUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: LiveWhereUniqueInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOrderCustomerArgs = {
  input: CustomerCreateInput;
  orderId: Scalars['String']['input'];
};


export type MutationUpdatePaymentArgs = {
  data: PaymentUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: PaymentWhereUniqueInput;
};


export type MutationUpdateProductArgs = {
  data: ProductUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: ProductWhereUniqueInput;
};


export type MutationUpdateRefundArgs = {
  data: RefundUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: RefundWhereUniqueInput;
};


export type MutationUpdateShippingMethodArgs = {
  data: ShippingMethodUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: ShippingMethodWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: UserWhereUniqueInput;
};


export type MutationUpsertAddressArgs = {
  create: AddressCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpsertAddressOnCheckoutOrderArgs = {
  address: AddressCreateWithoutCustomerInput;
  orderId: Scalars['String']['input'];
};


export type MutationUpsertCommentArgs = {
  create: CommentCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: CommentUpdateInput;
  where: CommentWhereUniqueInput;
};


export type MutationUpsertCustomerArgs = {
  create: CustomerCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpsertLineOnOrderArgs = {
  input: OrderLineCreateManyOrderInput;
  orderId: Scalars['String']['input'];
};


export type MutationUpsertLiveArgs = {
  create: LiveCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: LiveUpdateInput;
  where: LiveWhereUniqueInput;
};


export type MutationUpsertOrderArgs = {
  create: OrderCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpsertOrderAddressArgs = {
  input: OrderAddressCreateWithoutOrderInput;
  orderId: Scalars['String']['input'];
};


export type MutationUpsertProductArgs = {
  create: ProductCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpsertRefundArgs = {
  create: RefundCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: RefundUpdateInput;
  where: RefundWhereUniqueInput;
};


export type MutationUpsertSettingArgs = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpsertUserArgs = {
  create: UserCreateInput;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBytesNullableFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedEnumOrderLineStatusFilter = {
  equals?: InputMaybe<OrderLineStatus>;
  in?: InputMaybe<Array<OrderLineStatus>>;
  not?: InputMaybe<NestedEnumOrderLineStatusFilter>;
  notIn?: InputMaybe<Array<OrderLineStatus>>;
};

export type NestedEnumOrderLineTypeFilter = {
  equals?: InputMaybe<OrderLineType>;
  in?: InputMaybe<Array<OrderLineType>>;
  not?: InputMaybe<NestedEnumOrderLineTypeFilter>;
  notIn?: InputMaybe<Array<OrderLineType>>;
};

export type NestedEnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumPaymentStatusFilter = {
  equals?: InputMaybe<PaymentStatus>;
  in?: InputMaybe<Array<PaymentStatus>>;
  not?: InputMaybe<NestedEnumPaymentStatusFilter>;
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type NestedEnumRefundStatusFilter = {
  equals?: InputMaybe<RefundStatus>;
  in?: InputMaybe<Array<RefundStatus>>;
  not?: InputMaybe<NestedEnumRefundStatusFilter>;
  notIn?: InputMaybe<Array<RefundStatus>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBytesFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>;
  divide?: InputMaybe<Scalars['Float']['input']>;
  increment?: InputMaybe<Scalars['Float']['input']>;
  multiply?: InputMaybe<Scalars['Float']['input']>;
  set?: InputMaybe<Scalars['Float']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Order = {
  __typename?: 'Order';
  _count: OrderCount;
  address?: Maybe<OrderAddress>;
  availablePaymentMethods: Array<PaymentMethod>;
  availableShippingMethods: Array<ShippingMethod>;
  cancellations: Array<OrderLineCancellation>;
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  lines?: Maybe<Array<OrderLine>>;
  live: Live;
  liveId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  package: Scalars['Int']['output'];
  packedBy?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  shipment?: Maybe<Shipment>;
  shippingMethod?: Maybe<ShippingMethod>;
  shippingMethodId?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  total: Scalars['Int']['output'];
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type OrderLinesArgs = {
  cursor?: InputMaybe<OrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderLineOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderLineWhereInput>;
};


export type OrderPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentWhereInput>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['ID']['output'];
  phone: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
  streetDescription?: Maybe<Scalars['String']['output']>;
  streetLine: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderAddressCountAggregate = {
  __typename?: 'OrderAddressCountAggregate';
  _all: Scalars['Int']['output'];
  addressId: Scalars['Int']['output'];
  city: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  phone: Scalars['Int']['output'];
  postCode: Scalars['Int']['output'];
  streetDescription: Scalars['Int']['output'];
  streetLine: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderAddressCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<OrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderAddressCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<OrderAddressCreateWithoutAddressInput>;
};

export type OrderAddressCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<OrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderAddressCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<OrderAddressCreateWithoutOrderInput>;
};

export type OrderAddressCreateOrConnectWithoutAddressInput = {
  create: OrderAddressCreateWithoutAddressInput;
  where: OrderAddressWhereUniqueInput;
};

export type OrderAddressCreateOrConnectWithoutOrderInput = {
  create: OrderAddressCreateWithoutOrderInput;
  where: OrderAddressWhereUniqueInput;
};

export type OrderAddressCreateWithoutAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutAddressInput;
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetLine: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderAddressCreateWithoutOrderInput = {
  address?: InputMaybe<AddressCreateNestedOneWithoutOrderAddressInput>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  streetDescription?: InputMaybe<Scalars['String']['input']>;
  streetLine: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderAddressMaxAggregate = {
  __typename?: 'OrderAddressMaxAggregate';
  addressId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  streetDescription?: Maybe<Scalars['String']['output']>;
  streetLine?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderAddressMinAggregate = {
  __typename?: 'OrderAddressMinAggregate';
  addressId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  streetDescription?: Maybe<Scalars['String']['output']>;
  streetLine?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderAddressNullableScalarRelationFilter = {
  is?: InputMaybe<OrderAddressWhereInput>;
  isNot?: InputMaybe<OrderAddressWhereInput>;
};

export type OrderAddressOrderByWithRelationInput = {
  address?: InputMaybe<AddressOrderByWithRelationInput>;
  addressId?: InputMaybe<SortOrderInput>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  postCode?: InputMaybe<SortOrder>;
  streetDescription?: InputMaybe<SortOrderInput>;
  streetLine?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type OrderAddressUpdateOneWithoutAddressNestedInput = {
  connect?: InputMaybe<OrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderAddressCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<OrderAddressCreateWithoutAddressInput>;
  delete?: InputMaybe<OrderAddressWhereInput>;
  disconnect?: InputMaybe<OrderAddressWhereInput>;
  update?: InputMaybe<OrderAddressUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<OrderAddressUpsertWithoutAddressInput>;
};

export type OrderAddressUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<OrderAddressWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderAddressCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<OrderAddressCreateWithoutOrderInput>;
  delete?: InputMaybe<OrderAddressWhereInput>;
  disconnect?: InputMaybe<OrderAddressWhereInput>;
  update?: InputMaybe<OrderAddressUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<OrderAddressUpsertWithoutOrderInput>;
};

export type OrderAddressUpdateToOneWithWhereWithoutAddressInput = {
  data: OrderAddressUpdateWithoutAddressInput;
  where?: InputMaybe<OrderAddressWhereInput>;
};

export type OrderAddressUpdateToOneWithWhereWithoutOrderInput = {
  data: OrderAddressUpdateWithoutOrderInput;
  where?: InputMaybe<OrderAddressWhereInput>;
};

export type OrderAddressUpdateWithoutAddressInput = {
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutAddressNestedInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetLine?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderAddressUpdateWithoutOrderInput = {
  address?: InputMaybe<AddressUpdateOneWithoutOrderAddressNestedInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  phone?: InputMaybe<StringFieldUpdateOperationsInput>;
  postCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  streetDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  streetLine?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderAddressUpsertWithoutAddressInput = {
  create: OrderAddressCreateWithoutAddressInput;
  update: OrderAddressUpdateWithoutAddressInput;
  where?: InputMaybe<OrderAddressWhereInput>;
};

export type OrderAddressUpsertWithoutOrderInput = {
  create: OrderAddressCreateWithoutOrderInput;
  update: OrderAddressUpdateWithoutOrderInput;
  where?: InputMaybe<OrderAddressWhereInput>;
};

export type OrderAddressWhereInput = {
  AND?: InputMaybe<Array<OrderAddressWhereInput>>;
  NOT?: InputMaybe<Array<OrderAddressWhereInput>>;
  OR?: InputMaybe<Array<OrderAddressWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  postCode?: InputMaybe<StringFilter>;
  streetDescription?: InputMaybe<StringNullableFilter>;
  streetLine?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderAddressWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderAddressWhereInput>>;
  NOT?: InputMaybe<Array<OrderAddressWhereInput>>;
  OR?: InputMaybe<Array<OrderAddressWhereInput>>;
  address?: InputMaybe<AddressNullableScalarRelationFilter>;
  addressId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<StringFilter>;
  postCode?: InputMaybe<StringFilter>;
  streetDescription?: InputMaybe<StringNullableFilter>;
  streetLine?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  package?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type OrderBucket = {
  __typename?: 'OrderBucket';
  count: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type OrderCount = {
  __typename?: 'OrderCount';
  lines: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  liveId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  package: Scalars['Int']['output'];
  packedBy: Scalars['Int']['output'];
  paymentMethodId: Scalars['Int']['output'];
  shippingMethodId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  trackingNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderCreateInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateManyCustomerInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  liveId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateManyCustomerInputEnvelope = {
  data: Array<OrderCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyLiveInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateManyLiveInputEnvelope = {
  data: Array<OrderCreateManyLiveInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyPaymentMethodInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  liveId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateManyPaymentMethodInputEnvelope = {
  data: Array<OrderCreateManyPaymentMethodInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyShippingMethodInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  liveId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateManyShippingMethodInputEnvelope = {
  data: Array<OrderCreateManyShippingMethodInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
};

export type OrderCreateNestedManyWithoutLiveInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutLiveInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutLiveInput>>;
  createMany?: InputMaybe<OrderCreateManyLiveInputEnvelope>;
};

export type OrderCreateNestedManyWithoutPaymentMethodInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutPaymentMethodInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutPaymentMethodInput>>;
  createMany?: InputMaybe<OrderCreateManyPaymentMethodInputEnvelope>;
};

export type OrderCreateNestedManyWithoutShippingMethodInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutShippingMethodInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutShippingMethodInput>>;
  createMany?: InputMaybe<OrderCreateManyShippingMethodInputEnvelope>;
};

export type OrderCreateNestedOneWithoutAddressInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<OrderCreateWithoutAddressInput>;
};

export type OrderCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<OrderCreateWithoutLinesInput>;
};

export type OrderCreateOrConnectWithoutAddressInput = {
  create: OrderCreateWithoutAddressInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutLinesInput = {
  create: OrderCreateWithoutLinesInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutLiveInput = {
  create: OrderCreateWithoutLiveInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPaymentMethodInput = {
  create: OrderCreateWithoutPaymentMethodInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPaymentsInput = {
  create: OrderCreateWithoutPaymentsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutShippingMethodInput = {
  create: OrderCreateWithoutShippingMethodInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutAddressInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateWithoutCustomerInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateWithoutLinesInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateWithoutLiveInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateWithoutPaymentMethodInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateWithoutPaymentsInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutOrdersInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderCreateWithoutShippingMethodInput = {
  address?: InputMaybe<OrderAddressCreateNestedOneWithoutOrderInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceCreateNestedOneWithoutOrderInput>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutOrderInput>;
  live: LiveCreateNestedOneWithoutOrdersInput;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  package: Scalars['Int']['input'];
  packedBy?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutOrdersInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutOrderInput>;
  shipment?: InputMaybe<ShipmentCreateNestedOneWithoutOrderInput>;
  status?: InputMaybe<OrderStatus>;
  total?: InputMaybe<Scalars['Int']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLine = {
  __typename?: 'OrderLine';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  order: Order;
  orderId: Scalars['String']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  productVariant?: Maybe<ProductVariant>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  refund?: Maybe<Refund>;
  refundId?: Maybe<Scalars['String']['output']>;
  shippingMethod?: Maybe<ShippingMethod>;
  shippingMethodId?: Maybe<Scalars['String']['output']>;
  status: OrderLineStatus;
  type: OrderLineType;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderLineAvgAggregate = {
  __typename?: 'OrderLineAvgAggregate';
  price?: Maybe<Scalars['Float']['output']>;
};

export type OrderLineCancellation = {
  __typename?: 'OrderLineCancellation';
  cancelledAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineCode: Scalars['String']['output'];
  lineName: Scalars['String']['output'];
  linePrice: Scalars['Int']['output'];
  liveId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderLineId: Scalars['String']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source: CancellationSource;
};

export type OrderLineCancellationAvgAggregate = {
  __typename?: 'OrderLineCancellationAvgAggregate';
  linePrice?: Maybe<Scalars['Float']['output']>;
};

export type OrderLineCancellationCountAggregate = {
  __typename?: 'OrderLineCancellationCountAggregate';
  _all: Scalars['Int']['output'];
  cancelledAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lineCode: Scalars['Int']['output'];
  lineName: Scalars['Int']['output'];
  linePrice: Scalars['Int']['output'];
  liveId: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  orderLineId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  productVariantId: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  source: Scalars['Int']['output'];
};

export type OrderLineCancellationMaxAggregate = {
  __typename?: 'OrderLineCancellationMaxAggregate';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineCode?: Maybe<Scalars['String']['output']>;
  lineName?: Maybe<Scalars['String']['output']>;
  linePrice?: Maybe<Scalars['Int']['output']>;
  liveId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderLineId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CancellationSource>;
};

export type OrderLineCancellationMinAggregate = {
  __typename?: 'OrderLineCancellationMinAggregate';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lineCode?: Maybe<Scalars['String']['output']>;
  lineName?: Maybe<Scalars['String']['output']>;
  linePrice?: Maybe<Scalars['Int']['output']>;
  liveId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  orderLineId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<CancellationSource>;
};

export type OrderLineCancellationSumAggregate = {
  __typename?: 'OrderLineCancellationSumAggregate';
  linePrice?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineCountAggregate = {
  __typename?: 'OrderLineCountAggregate';
  _all: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  paymentMethodId: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  productVariantId: Scalars['Int']['output'];
  refundId: Scalars['Int']['output'];
  shippingMethodId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  type: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderLineCreateManyOrderInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateManyOrderInputEnvelope = {
  data: Array<OrderLineCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderLineCreateManyPaymentMethodInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateManyPaymentMethodInputEnvelope = {
  data: Array<OrderLineCreateManyPaymentMethodInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderLineCreateManyProductVariantInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  refundId?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateManyProductVariantInputEnvelope = {
  data: Array<OrderLineCreateManyProductVariantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderLineCreateManyRefundInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['String']['input']>;
  shippingMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateManyRefundInputEnvelope = {
  data: Array<OrderLineCreateManyRefundInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderLineCreateManyShippingMethodInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['String']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateManyShippingMethodInputEnvelope = {
  data: Array<OrderLineCreateManyShippingMethodInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderLineCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderLineCreateManyOrderInputEnvelope>;
};

export type OrderLineCreateNestedManyWithoutPaymentMethodInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutPaymentMethodInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutPaymentMethodInput>>;
  createMany?: InputMaybe<OrderLineCreateManyPaymentMethodInputEnvelope>;
};

export type OrderLineCreateNestedManyWithoutProductVariantInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutProductVariantInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutProductVariantInput>>;
  createMany?: InputMaybe<OrderLineCreateManyProductVariantInputEnvelope>;
};

export type OrderLineCreateNestedManyWithoutRefundInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutRefundInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutRefundInput>>;
  createMany?: InputMaybe<OrderLineCreateManyRefundInputEnvelope>;
};

export type OrderLineCreateNestedManyWithoutShippingMethodInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutShippingMethodInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutShippingMethodInput>>;
  createMany?: InputMaybe<OrderLineCreateManyShippingMethodInputEnvelope>;
};

export type OrderLineCreateOrConnectWithoutOrderInput = {
  create: OrderLineCreateWithoutOrderInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineCreateOrConnectWithoutPaymentMethodInput = {
  create: OrderLineCreateWithoutPaymentMethodInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineCreateOrConnectWithoutProductVariantInput = {
  create: OrderLineCreateWithoutProductVariantInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineCreateOrConnectWithoutRefundInput = {
  create: OrderLineCreateWithoutRefundInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineCreateOrConnectWithoutShippingMethodInput = {
  create: OrderLineCreateWithoutShippingMethodInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineCreateWithoutOrderInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutLinesInput>;
  price: Scalars['Int']['input'];
  productVariant?: InputMaybe<ProductVariantCreateNestedOneWithoutLinesInput>;
  refund?: InputMaybe<RefundCreateNestedOneWithoutLinesInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutLinesInput>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateWithoutPaymentMethodInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutLinesInput;
  price: Scalars['Int']['input'];
  productVariant?: InputMaybe<ProductVariantCreateNestedOneWithoutLinesInput>;
  refund?: InputMaybe<RefundCreateNestedOneWithoutLinesInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutLinesInput>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateWithoutProductVariantInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutLinesInput;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutLinesInput>;
  price: Scalars['Int']['input'];
  refund?: InputMaybe<RefundCreateNestedOneWithoutLinesInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutLinesInput>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateWithoutRefundInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutLinesInput;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutLinesInput>;
  price: Scalars['Int']['input'];
  productVariant?: InputMaybe<ProductVariantCreateNestedOneWithoutLinesInput>;
  shippingMethod?: InputMaybe<ShippingMethodCreateNestedOneWithoutLinesInput>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineCreateWithoutShippingMethodInput = {
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutLinesInput;
  paymentMethod?: InputMaybe<PaymentMethodCreateNestedOneWithoutLinesInput>;
  price: Scalars['Int']['input'];
  productVariant?: InputMaybe<ProductVariantCreateNestedOneWithoutLinesInput>;
  refund?: InputMaybe<RefundCreateNestedOneWithoutLinesInput>;
  status?: InputMaybe<OrderLineStatus>;
  type?: InputMaybe<OrderLineType>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderLineListRelationFilter = {
  every?: InputMaybe<OrderLineWhereInput>;
  none?: InputMaybe<OrderLineWhereInput>;
  some?: InputMaybe<OrderLineWhereInput>;
};

export type OrderLineMaxAggregate = {
  __typename?: 'OrderLineMaxAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  shippingMethodId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderLineStatus>;
  type?: Maybe<OrderLineType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderLineMinAggregate = {
  __typename?: 'OrderLineMinAggregate';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  productVariantId?: Maybe<Scalars['String']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  shippingMethodId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderLineStatus>;
  type?: Maybe<OrderLineType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderLineOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderLineOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  paymentMethod?: InputMaybe<PaymentMethodOrderByWithRelationInput>;
  paymentMethodId?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrder>;
  productVariant?: InputMaybe<ProductVariantOrderByWithRelationInput>;
  productVariantId?: InputMaybe<SortOrderInput>;
  refund?: InputMaybe<RefundOrderByWithRelationInput>;
  refundId?: InputMaybe<SortOrderInput>;
  shippingMethod?: InputMaybe<ShippingMethodOrderByWithRelationInput>;
  shippingMethodId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum OrderLineScalarFieldEnum {
  Code = 'code',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  OrderId = 'orderId',
  PaymentMethodId = 'paymentMethodId',
  Price = 'price',
  ProductVariantId = 'productVariantId',
  RefundId = 'refundId',
  ShippingMethodId = 'shippingMethodId',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type OrderLineScalarWhereInput = {
  AND?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  paymentMethodId?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<IntFilter>;
  productVariantId?: InputMaybe<StringNullableFilter>;
  refundId?: InputMaybe<StringNullableFilter>;
  shippingMethodId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderLineStatusFilter>;
  type?: InputMaybe<EnumOrderLineTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum OrderLineStatus {
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Packed = 'PACKED',
  Returned = 'RETURNED',
  Reviewing = 'REVIEWING'
}

export type OrderLineSumAggregate = {
  __typename?: 'OrderLineSumAggregate';
  price?: Maybe<Scalars['Int']['output']>;
};

export enum OrderLineType {
  Custom = 'CUSTOM',
  Payment = 'PAYMENT',
  Product = 'PRODUCT',
  Shipping = 'SHIPPING'
}

export type OrderLineUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderLineStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderLineTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderLineUpdateManyWithWhereWithoutOrderInput = {
  data: OrderLineUpdateManyMutationInput;
  where: OrderLineScalarWhereInput;
};

export type OrderLineUpdateManyWithWhereWithoutPaymentMethodInput = {
  data: OrderLineUpdateManyMutationInput;
  where: OrderLineScalarWhereInput;
};

export type OrderLineUpdateManyWithWhereWithoutProductVariantInput = {
  data: OrderLineUpdateManyMutationInput;
  where: OrderLineScalarWhereInput;
};

export type OrderLineUpdateManyWithWhereWithoutRefundInput = {
  data: OrderLineUpdateManyMutationInput;
  where: OrderLineScalarWhereInput;
};

export type OrderLineUpdateManyWithWhereWithoutShippingMethodInput = {
  data: OrderLineUpdateManyMutationInput;
  where: OrderLineScalarWhereInput;
};

export type OrderLineUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderLineCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderLineUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderLineUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderLineUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderLineUpdateManyWithoutPaymentMethodNestedInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutPaymentMethodInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutPaymentMethodInput>>;
  createMany?: InputMaybe<OrderLineCreateManyPaymentMethodInputEnvelope>;
  delete?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderLineUpdateWithWhereUniqueWithoutPaymentMethodInput>>;
  updateMany?: InputMaybe<Array<OrderLineUpdateManyWithWhereWithoutPaymentMethodInput>>;
  upsert?: InputMaybe<Array<OrderLineUpsertWithWhereUniqueWithoutPaymentMethodInput>>;
};

export type OrderLineUpdateManyWithoutProductVariantNestedInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutProductVariantInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutProductVariantInput>>;
  createMany?: InputMaybe<OrderLineCreateManyProductVariantInputEnvelope>;
  delete?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderLineUpdateWithWhereUniqueWithoutProductVariantInput>>;
  updateMany?: InputMaybe<Array<OrderLineUpdateManyWithWhereWithoutProductVariantInput>>;
  upsert?: InputMaybe<Array<OrderLineUpsertWithWhereUniqueWithoutProductVariantInput>>;
};

export type OrderLineUpdateManyWithoutRefundNestedInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutRefundInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutRefundInput>>;
  createMany?: InputMaybe<OrderLineCreateManyRefundInputEnvelope>;
  delete?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderLineUpdateWithWhereUniqueWithoutRefundInput>>;
  updateMany?: InputMaybe<Array<OrderLineUpdateManyWithWhereWithoutRefundInput>>;
  upsert?: InputMaybe<Array<OrderLineUpsertWithWhereUniqueWithoutRefundInput>>;
};

export type OrderLineUpdateManyWithoutShippingMethodNestedInput = {
  connect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderLineCreateOrConnectWithoutShippingMethodInput>>;
  create?: InputMaybe<Array<OrderLineCreateWithoutShippingMethodInput>>;
  createMany?: InputMaybe<OrderLineCreateManyShippingMethodInputEnvelope>;
  delete?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderLineScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderLineWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderLineUpdateWithWhereUniqueWithoutShippingMethodInput>>;
  updateMany?: InputMaybe<Array<OrderLineUpdateManyWithWhereWithoutShippingMethodInput>>;
  upsert?: InputMaybe<Array<OrderLineUpsertWithWhereUniqueWithoutShippingMethodInput>>;
};

export type OrderLineUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderLineUpdateWithoutOrderInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpdateWithWhereUniqueWithoutPaymentMethodInput = {
  data: OrderLineUpdateWithoutPaymentMethodInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpdateWithWhereUniqueWithoutProductVariantInput = {
  data: OrderLineUpdateWithoutProductVariantInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpdateWithWhereUniqueWithoutRefundInput = {
  data: OrderLineUpdateWithoutRefundInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpdateWithWhereUniqueWithoutShippingMethodInput = {
  data: OrderLineUpdateWithoutShippingMethodInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpdateWithoutOrderInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutLinesNestedInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  productVariant?: InputMaybe<ProductVariantUpdateOneWithoutLinesNestedInput>;
  refund?: InputMaybe<RefundUpdateOneWithoutLinesNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutLinesNestedInput>;
  status?: InputMaybe<EnumOrderLineStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderLineTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderLineUpdateWithoutPaymentMethodInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutLinesNestedInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  productVariant?: InputMaybe<ProductVariantUpdateOneWithoutLinesNestedInput>;
  refund?: InputMaybe<RefundUpdateOneWithoutLinesNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutLinesNestedInput>;
  status?: InputMaybe<EnumOrderLineStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderLineTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderLineUpdateWithoutProductVariantInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutLinesNestedInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutLinesNestedInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  refund?: InputMaybe<RefundUpdateOneWithoutLinesNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutLinesNestedInput>;
  status?: InputMaybe<EnumOrderLineStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderLineTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderLineUpdateWithoutRefundInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutLinesNestedInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutLinesNestedInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  productVariant?: InputMaybe<ProductVariantUpdateOneWithoutLinesNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutLinesNestedInput>;
  status?: InputMaybe<EnumOrderLineStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderLineTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderLineUpdateWithoutShippingMethodInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutLinesNestedInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutLinesNestedInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  productVariant?: InputMaybe<ProductVariantUpdateOneWithoutLinesNestedInput>;
  refund?: InputMaybe<RefundUpdateOneWithoutLinesNestedInput>;
  status?: InputMaybe<EnumOrderLineStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumOrderLineTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderLineUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderLineCreateWithoutOrderInput;
  update: OrderLineUpdateWithoutOrderInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpsertWithWhereUniqueWithoutPaymentMethodInput = {
  create: OrderLineCreateWithoutPaymentMethodInput;
  update: OrderLineUpdateWithoutPaymentMethodInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpsertWithWhereUniqueWithoutProductVariantInput = {
  create: OrderLineCreateWithoutProductVariantInput;
  update: OrderLineUpdateWithoutProductVariantInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpsertWithWhereUniqueWithoutRefundInput = {
  create: OrderLineCreateWithoutRefundInput;
  update: OrderLineUpdateWithoutRefundInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineUpsertWithWhereUniqueWithoutShippingMethodInput = {
  create: OrderLineCreateWithoutShippingMethodInput;
  update: OrderLineUpdateWithoutShippingMethodInput;
  where: OrderLineWhereUniqueInput;
};

export type OrderLineWhereInput = {
  AND?: InputMaybe<Array<OrderLineWhereInput>>;
  NOT?: InputMaybe<Array<OrderLineWhereInput>>;
  OR?: InputMaybe<Array<OrderLineWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  paymentMethod?: InputMaybe<PaymentMethodNullableScalarRelationFilter>;
  paymentMethodId?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<IntFilter>;
  productVariant?: InputMaybe<ProductVariantNullableScalarRelationFilter>;
  productVariantId?: InputMaybe<StringNullableFilter>;
  refund?: InputMaybe<RefundNullableScalarRelationFilter>;
  refundId?: InputMaybe<StringNullableFilter>;
  shippingMethod?: InputMaybe<ShippingMethodNullableScalarRelationFilter>;
  shippingMethodId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderLineStatusFilter>;
  type?: InputMaybe<EnumOrderLineTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderLineWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderLineWhereInput>>;
  NOT?: InputMaybe<Array<OrderLineWhereInput>>;
  OR?: InputMaybe<Array<OrderLineWhereInput>>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  paymentMethod?: InputMaybe<PaymentMethodNullableScalarRelationFilter>;
  paymentMethodId?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<IntFilter>;
  productVariant?: InputMaybe<ProductVariantNullableScalarRelationFilter>;
  productVariantId?: InputMaybe<StringNullableFilter>;
  refund?: InputMaybe<RefundNullableScalarRelationFilter>;
  refundId?: InputMaybe<StringNullableFilter>;
  shippingMethod?: InputMaybe<ShippingMethodNullableScalarRelationFilter>;
  shippingMethodId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderLineStatusFilter>;
  type?: InputMaybe<EnumOrderLineTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderLiveIdCustomerIdCompoundUniqueInput = {
  customerId: Scalars['String']['input'];
  liveId: Scalars['String']['input'];
};

export type OrderLiveIdPackageCompoundUniqueInput = {
  liveId: Scalars['String']['input'];
  package: Scalars['Int']['input'];
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  liveId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['Int']['output']>;
  packedBy?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  shippingMethodId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
  total?: Maybe<Scalars['Int']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  liveId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['Int']['output']>;
  packedBy?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  shippingMethodId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
  total?: Maybe<Scalars['Int']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderNullableScalarRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  address?: InputMaybe<OrderAddressOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoice?: InputMaybe<InvoiceOrderByWithRelationInput>;
  lines?: InputMaybe<OrderLineOrderByRelationAggregateInput>;
  live?: InputMaybe<LiveOrderByWithRelationInput>;
  liveId?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  note?: InputMaybe<SortOrderInput>;
  package?: InputMaybe<SortOrder>;
  packedBy?: InputMaybe<SortOrderInput>;
  paymentMethod?: InputMaybe<PaymentMethodOrderByWithRelationInput>;
  paymentMethodId?: InputMaybe<SortOrderInput>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shippingMethod?: InputMaybe<ShippingMethodOrderByWithRelationInput>;
  shippingMethodId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  trackingNumber?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum OrderScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  LiveId = 'liveId',
  Metadata = 'metadata',
  Note = 'note',
  Package = 'package',
  PackedBy = 'packedBy',
  PaymentMethodId = 'paymentMethodId',
  ShippingMethodId = 'shippingMethodId',
  Status = 'status',
  Total = 'total',
  TrackingNumber = 'trackingNumber',
  UpdatedAt = 'updatedAt'
}

export type OrderScalarRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  liveId?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  package?: InputMaybe<IntFilter>;
  packedBy?: InputMaybe<StringNullableFilter>;
  paymentMethodId?: InputMaybe<StringNullableFilter>;
  shippingMethodId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  total?: InputMaybe<IntFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Internal = 'INTERNAL',
  Processed = 'PROCESSED',
  Reserved = 'RESERVED',
  Returned = 'RETURNED',
  Reviewing = 'REVIEWING',
  Shipped = 'SHIPPED'
}

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  package?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type OrderUpdateInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutCustomerInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutLiveInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutPaymentMethodInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutShippingMethodInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type OrderUpdateManyWithoutLiveNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutLiveInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutLiveInput>>;
  createMany?: InputMaybe<OrderCreateManyLiveInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutLiveInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutLiveInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutLiveInput>>;
};

export type OrderUpdateManyWithoutPaymentMethodNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutPaymentMethodInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutPaymentMethodInput>>;
  createMany?: InputMaybe<OrderCreateManyPaymentMethodInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutPaymentMethodInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutPaymentMethodInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutPaymentMethodInput>>;
};

export type OrderUpdateManyWithoutShippingMethodNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutShippingMethodInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutShippingMethodInput>>;
  createMany?: InputMaybe<OrderCreateManyShippingMethodInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutShippingMethodInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutShippingMethodInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutShippingMethodInput>>;
};

export type OrderUpdateOneRequiredWithoutAddressNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutAddressInput>;
  create?: InputMaybe<OrderCreateWithoutAddressInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutAddressInput>;
  upsert?: InputMaybe<OrderUpsertWithoutAddressInput>;
};

export type OrderUpdateOneRequiredWithoutLinesNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<OrderCreateWithoutLinesInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<OrderUpsertWithoutLinesInput>;
};

export type OrderUpdateOneWithoutPaymentsNestedInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<OrderCreateWithoutPaymentsInput>;
  delete?: InputMaybe<OrderWhereInput>;
  disconnect?: InputMaybe<OrderWhereInput>;
  update?: InputMaybe<OrderUpdateToOneWithWhereWithoutPaymentsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutPaymentsInput>;
};

export type OrderUpdateToOneWithWhereWithoutAddressInput = {
  data: OrderUpdateWithoutAddressInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutLinesInput = {
  data: OrderUpdateWithoutLinesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateToOneWithWhereWithoutPaymentsInput = {
  data: OrderUpdateWithoutPaymentsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpdateWithWhereUniqueWithoutCustomerInput = {
  data: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutLiveInput = {
  data: OrderUpdateWithoutLiveInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutPaymentMethodInput = {
  data: OrderUpdateWithoutPaymentMethodInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutShippingMethodInput = {
  data: OrderUpdateWithoutShippingMethodInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutAddressInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutCustomerInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutLinesInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutLiveInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutPaymentMethodInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutPaymentsInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  shippingMethod?: InputMaybe<ShippingMethodUpdateOneWithoutOrdersNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutShippingMethodInput = {
  address?: InputMaybe<OrderAddressUpdateOneWithoutOrderNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoice?: InputMaybe<InvoiceUpdateOneWithoutOrderNestedInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutOrderNestedInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutOrdersNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  package?: InputMaybe<IntFieldUpdateOperationsInput>;
  packedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentMethod?: InputMaybe<PaymentMethodUpdateOneWithoutOrdersNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutOrderNestedInput>;
  shipment?: InputMaybe<ShipmentUpdateOneWithoutOrderNestedInput>;
  status?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  total?: InputMaybe<IntFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type OrderUpsertWithWhereUniqueWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  update: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutLiveInput = {
  create: OrderCreateWithoutLiveInput;
  update: OrderUpdateWithoutLiveInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutPaymentMethodInput = {
  create: OrderCreateWithoutPaymentMethodInput;
  update: OrderUpdateWithoutPaymentMethodInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutShippingMethodInput = {
  create: OrderCreateWithoutShippingMethodInput;
  update: OrderUpdateWithoutShippingMethodInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithoutAddressInput = {
  create: OrderCreateWithoutAddressInput;
  update: OrderUpdateWithoutAddressInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutLinesInput = {
  create: OrderCreateWithoutLinesInput;
  update: OrderUpdateWithoutLinesInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderUpsertWithoutPaymentsInput = {
  create: OrderCreateWithoutPaymentsInput;
  update: OrderUpdateWithoutPaymentsInput;
  where?: InputMaybe<OrderWhereInput>;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  address?: InputMaybe<OrderAddressNullableScalarRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  invoice?: InputMaybe<InvoiceNullableScalarRelationFilter>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  live?: InputMaybe<LiveScalarRelationFilter>;
  liveId?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  package?: InputMaybe<IntFilter>;
  packedBy?: InputMaybe<StringNullableFilter>;
  paymentMethod?: InputMaybe<PaymentMethodNullableScalarRelationFilter>;
  paymentMethodId?: InputMaybe<StringNullableFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableScalarRelationFilter>;
  shippingMethod?: InputMaybe<ShippingMethodNullableScalarRelationFilter>;
  shippingMethodId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  total?: InputMaybe<IntFilter>;
  trackingNumber?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrderWhereUniqueInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  address?: InputMaybe<OrderAddressNullableScalarRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  invoice?: InputMaybe<InvoiceNullableScalarRelationFilter>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  live?: InputMaybe<LiveScalarRelationFilter>;
  liveId?: InputMaybe<StringFilter>;
  liveId_customerId?: InputMaybe<OrderLiveIdCustomerIdCompoundUniqueInput>;
  liveId_package?: InputMaybe<OrderLiveIdPackageCompoundUniqueInput>;
  metadata?: InputMaybe<JsonNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  package?: InputMaybe<IntFilter>;
  packedBy?: InputMaybe<StringNullableFilter>;
  paymentMethod?: InputMaybe<PaymentMethodNullableScalarRelationFilter>;
  paymentMethodId?: InputMaybe<StringNullableFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  shipment?: InputMaybe<ShipmentNullableScalarRelationFilter>;
  shippingMethod?: InputMaybe<ShippingMethodNullableScalarRelationFilter>;
  shippingMethodId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumOrderStatusFilter>;
  total?: InputMaybe<IntFilter>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type OrdersTabletSummary = {
  __typename?: 'OrdersTabletSummary';
  count: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Parcel = {
  __typename?: 'Parcel';
  _count: ParcelCount;
  createdAt: Scalars['DateTime']['output'];
  deliveryCountryCode?: Maybe<Scalars['String']['output']>;
  deliveryZipCode?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  shipment: Shipment;
  shipmentId: Scalars['String']['output'];
  statuses?: Maybe<Array<ParcelStatus>>;
  trackingNumber: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParcelAvgAggregate = {
  __typename?: 'ParcelAvgAggregate';
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParcelCount = {
  __typename?: 'ParcelCount';
  statuses: Scalars['Int']['output'];
};

export type ParcelCountAggregate = {
  __typename?: 'ParcelCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  deliveryCountryCode: Scalars['Int']['output'];
  deliveryZipCode: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  pod: Scalars['Int']['output'];
  shipmentId: Scalars['Int']['output'];
  trackingNumber: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type ParcelCreateManyShipmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryCountryCode?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  trackingNumber: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ParcelCreateManyShipmentInputEnvelope = {
  data: Array<ParcelCreateManyShipmentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParcelCreateNestedManyWithoutShipmentInput = {
  connect?: InputMaybe<Array<ParcelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParcelCreateOrConnectWithoutShipmentInput>>;
  create?: InputMaybe<Array<ParcelCreateWithoutShipmentInput>>;
  createMany?: InputMaybe<ParcelCreateManyShipmentInputEnvelope>;
};

export type ParcelCreateOrConnectWithoutShipmentInput = {
  create: ParcelCreateWithoutShipmentInput;
  where: ParcelWhereUniqueInput;
};

export type ParcelCreateWithoutShipmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryCountryCode?: InputMaybe<Scalars['String']['input']>;
  deliveryZipCode?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ParcelStatusCreateNestedManyWithoutParcelInput>;
  trackingNumber: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ParcelListRelationFilter = {
  every?: InputMaybe<ParcelWhereInput>;
  none?: InputMaybe<ParcelWhereInput>;
  some?: InputMaybe<ParcelWhereInput>;
};

export type ParcelMaxAggregate = {
  __typename?: 'ParcelMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryCountryCode?: Maybe<Scalars['String']['output']>;
  deliveryZipCode?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParcelMinAggregate = {
  __typename?: 'ParcelMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deliveryCountryCode?: Maybe<Scalars['String']['output']>;
  deliveryZipCode?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pod?: Maybe<Scalars['String']['output']>;
  shipmentId?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParcelOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ParcelOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deliveryCountryCode?: InputMaybe<SortOrderInput>;
  deliveryZipCode?: InputMaybe<SortOrderInput>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  pod?: InputMaybe<SortOrderInput>;
  shipment?: InputMaybe<ShipmentOrderByWithRelationInput>;
  shipmentId?: InputMaybe<SortOrder>;
  statuses?: InputMaybe<ParcelStatusOrderByRelationAggregateInput>;
  trackingNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrderInput>;
};

export enum ParcelScalarFieldEnum {
  CreatedAt = 'createdAt',
  DeliveryCountryCode = 'deliveryCountryCode',
  DeliveryZipCode = 'deliveryZipCode',
  ExternalId = 'externalId',
  Id = 'id',
  Metadata = 'metadata',
  Pod = 'pod',
  ShipmentId = 'shipmentId',
  TrackingNumber = 'trackingNumber',
  UpdatedAt = 'updatedAt',
  Weight = 'weight'
}

export type ParcelScalarRelationFilter = {
  is?: InputMaybe<ParcelWhereInput>;
  isNot?: InputMaybe<ParcelWhereInput>;
};

export type ParcelScalarWhereInput = {
  AND?: InputMaybe<Array<ParcelScalarWhereInput>>;
  NOT?: InputMaybe<Array<ParcelScalarWhereInput>>;
  OR?: InputMaybe<Array<ParcelScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deliveryCountryCode?: InputMaybe<StringNullableFilter>;
  deliveryZipCode?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  pod?: InputMaybe<BytesNullableFilter>;
  shipmentId?: InputMaybe<StringFilter>;
  trackingNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type ParcelShipmentIdExternalIdCompoundUniqueInput = {
  externalId: Scalars['String']['input'];
  shipmentId: Scalars['String']['input'];
};

export type ParcelShipmentIdTrackingNumberCompoundUniqueInput = {
  shipmentId: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};

export type ParcelStatus = {
  __typename?: 'ParcelStatus';
  createdAt: Scalars['DateTime']['output'];
  depotCity?: Maybe<Scalars['String']['output']>;
  depotNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  parcel: Parcel;
  parcelId: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  statusDate: Scalars['DateTime']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusInfo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParcelStatusCountAggregate = {
  __typename?: 'ParcelStatusCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  depotCity: Scalars['Int']['output'];
  depotNumber: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  parcelId: Scalars['Int']['output'];
  statusCode: Scalars['Int']['output'];
  statusDate: Scalars['Int']['output'];
  statusDescription: Scalars['Int']['output'];
  statusInfo: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ParcelStatusCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  depotCity?: InputMaybe<Scalars['Boolean']['input']>;
  depotNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  parcelId?: InputMaybe<Scalars['Boolean']['input']>;
  statusCode?: InputMaybe<Scalars['Boolean']['input']>;
  statusDate?: InputMaybe<Scalars['Boolean']['input']>;
  statusDescription?: InputMaybe<Scalars['Boolean']['input']>;
  statusInfo?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParcelStatusCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  depotCity?: InputMaybe<SortOrder>;
  depotNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parcelId?: InputMaybe<SortOrder>;
  statusCode?: InputMaybe<SortOrder>;
  statusDate?: InputMaybe<SortOrder>;
  statusDescription?: InputMaybe<SortOrder>;
  statusInfo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ParcelStatusCreateManyParcelInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  depotCity?: InputMaybe<Scalars['String']['input']>;
  depotNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  statusCode: Scalars['String']['input'];
  statusDate: Scalars['DateTime']['input'];
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  statusInfo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ParcelStatusCreateManyParcelInputEnvelope = {
  data: Array<ParcelStatusCreateManyParcelInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParcelStatusCreateNestedManyWithoutParcelInput = {
  connect?: InputMaybe<Array<ParcelStatusWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParcelStatusCreateOrConnectWithoutParcelInput>>;
  create?: InputMaybe<Array<ParcelStatusCreateWithoutParcelInput>>;
  createMany?: InputMaybe<ParcelStatusCreateManyParcelInputEnvelope>;
};

export type ParcelStatusCreateOrConnectWithoutParcelInput = {
  create: ParcelStatusCreateWithoutParcelInput;
  where: ParcelStatusWhereUniqueInput;
};

export type ParcelStatusCreateWithoutParcelInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  depotCity?: InputMaybe<Scalars['String']['input']>;
  depotNumber?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  statusCode: Scalars['String']['input'];
  statusDate: Scalars['DateTime']['input'];
  statusDescription?: InputMaybe<Scalars['String']['input']>;
  statusInfo?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ParcelStatusGroupBy = {
  __typename?: 'ParcelStatusGroupBy';
  _count?: Maybe<ParcelStatusCountAggregate>;
  _max?: Maybe<ParcelStatusMaxAggregate>;
  _min?: Maybe<ParcelStatusMinAggregate>;
  createdAt: Scalars['DateTime']['output'];
  depotCity?: Maybe<Scalars['String']['output']>;
  depotNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parcelId: Scalars['String']['output'];
  statusCode: Scalars['String']['output'];
  statusDate: Scalars['DateTime']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusInfo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ParcelStatusListRelationFilter = {
  every?: InputMaybe<ParcelStatusWhereInput>;
  none?: InputMaybe<ParcelStatusWhereInput>;
  some?: InputMaybe<ParcelStatusWhereInput>;
};

export type ParcelStatusMaxAggregate = {
  __typename?: 'ParcelStatusMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  depotCity?: Maybe<Scalars['String']['output']>;
  depotNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  parcelId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusDate?: Maybe<Scalars['DateTime']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ParcelStatusMaxAggregateInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  depotCity?: InputMaybe<Scalars['Boolean']['input']>;
  depotNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  parcelId?: InputMaybe<Scalars['Boolean']['input']>;
  statusCode?: InputMaybe<Scalars['Boolean']['input']>;
  statusDate?: InputMaybe<Scalars['Boolean']['input']>;
  statusDescription?: InputMaybe<Scalars['Boolean']['input']>;
  statusInfo?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParcelStatusMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  depotCity?: InputMaybe<SortOrder>;
  depotNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parcelId?: InputMaybe<SortOrder>;
  statusCode?: InputMaybe<SortOrder>;
  statusDate?: InputMaybe<SortOrder>;
  statusDescription?: InputMaybe<SortOrder>;
  statusInfo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ParcelStatusMinAggregate = {
  __typename?: 'ParcelStatusMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  depotCity?: Maybe<Scalars['String']['output']>;
  depotNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  parcelId?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  statusDate?: Maybe<Scalars['DateTime']['output']>;
  statusDescription?: Maybe<Scalars['String']['output']>;
  statusInfo?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ParcelStatusMinAggregateInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  depotCity?: InputMaybe<Scalars['Boolean']['input']>;
  depotNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  parcelId?: InputMaybe<Scalars['Boolean']['input']>;
  statusCode?: InputMaybe<Scalars['Boolean']['input']>;
  statusDate?: InputMaybe<Scalars['Boolean']['input']>;
  statusDescription?: InputMaybe<Scalars['Boolean']['input']>;
  statusInfo?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParcelStatusMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  depotCity?: InputMaybe<SortOrder>;
  depotNumber?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  parcelId?: InputMaybe<SortOrder>;
  statusCode?: InputMaybe<SortOrder>;
  statusDate?: InputMaybe<SortOrder>;
  statusDescription?: InputMaybe<SortOrder>;
  statusInfo?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ParcelStatusOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ParcelStatusOrderByWithAggregationInput = {
  _count?: InputMaybe<ParcelStatusCountOrderByAggregateInput>;
  _max?: InputMaybe<ParcelStatusMaxOrderByAggregateInput>;
  _min?: InputMaybe<ParcelStatusMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  depotCity?: InputMaybe<SortOrderInput>;
  depotNumber?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  parcelId?: InputMaybe<SortOrder>;
  statusCode?: InputMaybe<SortOrder>;
  statusDate?: InputMaybe<SortOrder>;
  statusDescription?: InputMaybe<SortOrderInput>;
  statusInfo?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ParcelStatusOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  depotCity?: InputMaybe<SortOrderInput>;
  depotNumber?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  parcel?: InputMaybe<ParcelOrderByWithRelationInput>;
  parcelId?: InputMaybe<SortOrder>;
  statusCode?: InputMaybe<SortOrder>;
  statusDate?: InputMaybe<SortOrder>;
  statusDescription?: InputMaybe<SortOrderInput>;
  statusInfo?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ParcelStatusParcelIdStatusCodeStatusDateCompoundUniqueInput = {
  parcelId: Scalars['String']['input'];
  statusCode: Scalars['String']['input'];
  statusDate: Scalars['DateTime']['input'];
};

export enum ParcelStatusScalarFieldEnum {
  CreatedAt = 'createdAt',
  DepotCity = 'depotCity',
  DepotNumber = 'depotNumber',
  Id = 'id',
  ParcelId = 'parcelId',
  StatusCode = 'statusCode',
  StatusDate = 'statusDate',
  StatusDescription = 'statusDescription',
  StatusInfo = 'statusInfo',
  UpdatedAt = 'updatedAt'
}

export type ParcelStatusScalarWhereInput = {
  AND?: InputMaybe<Array<ParcelStatusScalarWhereInput>>;
  NOT?: InputMaybe<Array<ParcelStatusScalarWhereInput>>;
  OR?: InputMaybe<Array<ParcelStatusScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  depotCity?: InputMaybe<StringNullableFilter>;
  depotNumber?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  parcelId?: InputMaybe<StringFilter>;
  statusCode?: InputMaybe<StringFilter>;
  statusDate?: InputMaybe<DateTimeFilter>;
  statusDescription?: InputMaybe<StringNullableFilter>;
  statusInfo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParcelStatusScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ParcelStatusScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ParcelStatusScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ParcelStatusScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  depotCity?: InputMaybe<StringNullableWithAggregatesFilter>;
  depotNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  parcelId?: InputMaybe<StringWithAggregatesFilter>;
  statusCode?: InputMaybe<StringWithAggregatesFilter>;
  statusDate?: InputMaybe<DateTimeWithAggregatesFilter>;
  statusDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  statusInfo?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ParcelStatusUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depotCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  depotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  statusDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  statusInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParcelStatusUpdateManyWithWhereWithoutParcelInput = {
  data: ParcelStatusUpdateManyMutationInput;
  where: ParcelStatusScalarWhereInput;
};

export type ParcelStatusUpdateManyWithoutParcelNestedInput = {
  connect?: InputMaybe<Array<ParcelStatusWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParcelStatusCreateOrConnectWithoutParcelInput>>;
  create?: InputMaybe<Array<ParcelStatusCreateWithoutParcelInput>>;
  createMany?: InputMaybe<ParcelStatusCreateManyParcelInputEnvelope>;
  delete?: InputMaybe<Array<ParcelStatusWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParcelStatusScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParcelStatusWhereUniqueInput>>;
  set?: InputMaybe<Array<ParcelStatusWhereUniqueInput>>;
  update?: InputMaybe<Array<ParcelStatusUpdateWithWhereUniqueWithoutParcelInput>>;
  updateMany?: InputMaybe<Array<ParcelStatusUpdateManyWithWhereWithoutParcelInput>>;
  upsert?: InputMaybe<Array<ParcelStatusUpsertWithWhereUniqueWithoutParcelInput>>;
};

export type ParcelStatusUpdateWithWhereUniqueWithoutParcelInput = {
  data: ParcelStatusUpdateWithoutParcelInput;
  where: ParcelStatusWhereUniqueInput;
};

export type ParcelStatusUpdateWithoutParcelInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  depotCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  depotNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  statusDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  statusDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  statusInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ParcelStatusUpsertWithWhereUniqueWithoutParcelInput = {
  create: ParcelStatusCreateWithoutParcelInput;
  update: ParcelStatusUpdateWithoutParcelInput;
  where: ParcelStatusWhereUniqueInput;
};

export type ParcelStatusWhereInput = {
  AND?: InputMaybe<Array<ParcelStatusWhereInput>>;
  NOT?: InputMaybe<Array<ParcelStatusWhereInput>>;
  OR?: InputMaybe<Array<ParcelStatusWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  depotCity?: InputMaybe<StringNullableFilter>;
  depotNumber?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  parcel?: InputMaybe<ParcelScalarRelationFilter>;
  parcelId?: InputMaybe<StringFilter>;
  statusCode?: InputMaybe<StringFilter>;
  statusDate?: InputMaybe<DateTimeFilter>;
  statusDescription?: InputMaybe<StringNullableFilter>;
  statusInfo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParcelStatusWhereUniqueInput = {
  AND?: InputMaybe<Array<ParcelStatusWhereInput>>;
  NOT?: InputMaybe<Array<ParcelStatusWhereInput>>;
  OR?: InputMaybe<Array<ParcelStatusWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  depotCity?: InputMaybe<StringNullableFilter>;
  depotNumber?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  parcel?: InputMaybe<ParcelScalarRelationFilter>;
  parcelId?: InputMaybe<StringFilter>;
  parcelId_statusCode_statusDate?: InputMaybe<ParcelStatusParcelIdStatusCodeStatusDateCompoundUniqueInput>;
  statusCode?: InputMaybe<StringFilter>;
  statusDate?: InputMaybe<DateTimeFilter>;
  statusDescription?: InputMaybe<StringNullableFilter>;
  statusInfo?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ParcelSumAggregate = {
  __typename?: 'ParcelSumAggregate';
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ParcelUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deliveryCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryZipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pod?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ParcelUpdateManyWithWhereWithoutShipmentInput = {
  data: ParcelUpdateManyMutationInput;
  where: ParcelScalarWhereInput;
};

export type ParcelUpdateManyWithoutShipmentNestedInput = {
  connect?: InputMaybe<Array<ParcelWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ParcelCreateOrConnectWithoutShipmentInput>>;
  create?: InputMaybe<Array<ParcelCreateWithoutShipmentInput>>;
  createMany?: InputMaybe<ParcelCreateManyShipmentInputEnvelope>;
  delete?: InputMaybe<Array<ParcelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ParcelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ParcelWhereUniqueInput>>;
  set?: InputMaybe<Array<ParcelWhereUniqueInput>>;
  update?: InputMaybe<Array<ParcelUpdateWithWhereUniqueWithoutShipmentInput>>;
  updateMany?: InputMaybe<Array<ParcelUpdateManyWithWhereWithoutShipmentInput>>;
  upsert?: InputMaybe<Array<ParcelUpsertWithWhereUniqueWithoutShipmentInput>>;
};

export type ParcelUpdateWithWhereUniqueWithoutShipmentInput = {
  data: ParcelUpdateWithoutShipmentInput;
  where: ParcelWhereUniqueInput;
};

export type ParcelUpdateWithoutShipmentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deliveryCountryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryZipCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  pod?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  statuses?: InputMaybe<ParcelStatusUpdateManyWithoutParcelNestedInput>;
  trackingNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
};

export type ParcelUpsertWithWhereUniqueWithoutShipmentInput = {
  create: ParcelCreateWithoutShipmentInput;
  update: ParcelUpdateWithoutShipmentInput;
  where: ParcelWhereUniqueInput;
};

export type ParcelWhereInput = {
  AND?: InputMaybe<Array<ParcelWhereInput>>;
  NOT?: InputMaybe<Array<ParcelWhereInput>>;
  OR?: InputMaybe<Array<ParcelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deliveryCountryCode?: InputMaybe<StringNullableFilter>;
  deliveryZipCode?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  pod?: InputMaybe<BytesNullableFilter>;
  shipment?: InputMaybe<ShipmentScalarRelationFilter>;
  shipmentId?: InputMaybe<StringFilter>;
  statuses?: InputMaybe<ParcelStatusListRelationFilter>;
  trackingNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type ParcelWhereUniqueInput = {
  AND?: InputMaybe<Array<ParcelWhereInput>>;
  NOT?: InputMaybe<Array<ParcelWhereInput>>;
  OR?: InputMaybe<Array<ParcelWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deliveryCountryCode?: InputMaybe<StringNullableFilter>;
  deliveryZipCode?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  pod?: InputMaybe<BytesNullableFilter>;
  shipment?: InputMaybe<ShipmentScalarRelationFilter>;
  shipmentId?: InputMaybe<StringFilter>;
  shipmentId_externalId?: InputMaybe<ParcelShipmentIdExternalIdCompoundUniqueInput>;
  shipmentId_trackingNumber?: InputMaybe<ParcelShipmentIdTrackingNumberCompoundUniqueInput>;
  statuses?: InputMaybe<ParcelStatusListRelationFilter>;
  trackingNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  method: Scalars['String']['output'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentAvgAggregate = {
  __typename?: 'PaymentAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type PaymentCountAggregate = {
  __typename?: 'PaymentCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  method: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  referenceId: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PaymentCreateManyOrderInput = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentCreateManyOrderInputEnvelope = {
  data: Array<PaymentCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaymentCreateManyOrderInputEnvelope>;
};

export type PaymentCreateOrConnectWithoutOrderInput = {
  create: PaymentCreateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateWithoutOrderInput = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentListRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentMaxAggregate = {
  __typename?: 'PaymentMaxAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  _count: PaymentMethodCount;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lines?: Maybe<Array<OrderLine>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  shippingMethods?: Maybe<Array<ShippingMethod>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodAvgAggregate = {
  __typename?: 'PaymentMethodAvgAggregate';
  fee?: Maybe<Scalars['Float']['output']>;
};

export type PaymentMethodBreakdown = {
  __typename?: 'PaymentMethodBreakdown';
  method: Scalars['String']['output'];
  orderCount: Scalars['Int']['output'];
  paidOrderCount: Scalars['Int']['output'];
  paidTotal: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  unpaidOrderCount: Scalars['Int']['output'];
  unpaidTotal: Scalars['Float']['output'];
};

export type PaymentMethodCount = {
  __typename?: 'PaymentMethodCount';
  lines: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  shippingMethods: Scalars['Int']['output'];
};

export type PaymentMethodCountAggregate = {
  __typename?: 'PaymentMethodCountAggregate';
  _all: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  fee: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type PaymentMethodCreateNestedManyWithoutShippingMethodsInput = {
  connect?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentMethodCreateOrConnectWithoutShippingMethodsInput>>;
  create?: InputMaybe<Array<PaymentMethodCreateWithoutShippingMethodsInput>>;
};

export type PaymentMethodCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<PaymentMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentMethodCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<PaymentMethodCreateWithoutLinesInput>;
};

export type PaymentMethodCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<PaymentMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentMethodCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<PaymentMethodCreateWithoutOrdersInput>;
};

export type PaymentMethodCreateOrConnectWithoutLinesInput = {
  create: PaymentMethodCreateWithoutLinesInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodCreateOrConnectWithoutOrdersInput = {
  create: PaymentMethodCreateWithoutOrdersInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodCreateOrConnectWithoutShippingMethodsInput = {
  create: PaymentMethodCreateWithoutShippingMethodsInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodCreateWithoutLinesInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutPaymentMethodInput>;
  shippingMethods?: InputMaybe<ShippingMethodCreateNestedManyWithoutPaymentMethodsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentMethodCreateWithoutOrdersInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutPaymentMethodInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  shippingMethods?: InputMaybe<ShippingMethodCreateNestedManyWithoutPaymentMethodsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentMethodCreateWithoutShippingMethodsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutPaymentMethodInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutPaymentMethodInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PaymentMethodListRelationFilter = {
  every?: InputMaybe<PaymentMethodWhereInput>;
  none?: InputMaybe<PaymentMethodWhereInput>;
  some?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodMaxAggregate = {
  __typename?: 'PaymentMethodMaxAggregate';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentMethodMinAggregate = {
  __typename?: 'PaymentMethodMinAggregate';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentMethodNameCountryCompoundUniqueInput = {
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PaymentMethodNullableScalarRelationFilter = {
  is?: InputMaybe<PaymentMethodWhereInput>;
  isNot?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentMethodOrderByWithRelationInput = {
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  fee?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lines?: InputMaybe<OrderLineOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  shippingMethods?: InputMaybe<ShippingMethodOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentMethodScalarFieldEnum {
  Country = 'country',
  CreatedAt = 'createdAt',
  Description = 'description',
  Fee = 'fee',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type PaymentMethodScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fee?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentMethodSumAggregate = {
  __typename?: 'PaymentMethodSumAggregate';
  fee?: Maybe<Scalars['Int']['output']>;
};

export type PaymentMethodUpdateManyMutationInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentMethodUpdateManyWithWhereWithoutShippingMethodsInput = {
  data: PaymentMethodUpdateManyMutationInput;
  where: PaymentMethodScalarWhereInput;
};

export type PaymentMethodUpdateManyWithoutShippingMethodsNestedInput = {
  connect?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentMethodCreateOrConnectWithoutShippingMethodsInput>>;
  create?: InputMaybe<Array<PaymentMethodCreateWithoutShippingMethodsInput>>;
  delete?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentMethodScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentMethodWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentMethodUpdateWithWhereUniqueWithoutShippingMethodsInput>>;
  updateMany?: InputMaybe<Array<PaymentMethodUpdateManyWithWhereWithoutShippingMethodsInput>>;
  upsert?: InputMaybe<Array<PaymentMethodUpsertWithWhereUniqueWithoutShippingMethodsInput>>;
};

export type PaymentMethodUpdateOneWithoutLinesNestedInput = {
  connect?: InputMaybe<PaymentMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentMethodCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<PaymentMethodCreateWithoutLinesInput>;
  delete?: InputMaybe<PaymentMethodWhereInput>;
  disconnect?: InputMaybe<PaymentMethodWhereInput>;
  update?: InputMaybe<PaymentMethodUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<PaymentMethodUpsertWithoutLinesInput>;
};

export type PaymentMethodUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<PaymentMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentMethodCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<PaymentMethodCreateWithoutOrdersInput>;
  delete?: InputMaybe<PaymentMethodWhereInput>;
  disconnect?: InputMaybe<PaymentMethodWhereInput>;
  update?: InputMaybe<PaymentMethodUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<PaymentMethodUpsertWithoutOrdersInput>;
};

export type PaymentMethodUpdateToOneWithWhereWithoutLinesInput = {
  data: PaymentMethodUpdateWithoutLinesInput;
  where?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodUpdateToOneWithWhereWithoutOrdersInput = {
  data: PaymentMethodUpdateWithoutOrdersInput;
  where?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodUpdateWithWhereUniqueWithoutShippingMethodsInput = {
  data: PaymentMethodUpdateWithoutShippingMethodsInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodUpdateWithoutLinesInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPaymentMethodNestedInput>;
  shippingMethods?: InputMaybe<ShippingMethodUpdateManyWithoutPaymentMethodsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentMethodUpdateWithoutOrdersInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutPaymentMethodNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shippingMethods?: InputMaybe<ShippingMethodUpdateManyWithoutPaymentMethodsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentMethodUpdateWithoutShippingMethodsInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutPaymentMethodNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutPaymentMethodNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentMethodUpsertWithWhereUniqueWithoutShippingMethodsInput = {
  create: PaymentMethodCreateWithoutShippingMethodsInput;
  update: PaymentMethodUpdateWithoutShippingMethodsInput;
  where: PaymentMethodWhereUniqueInput;
};

export type PaymentMethodUpsertWithoutLinesInput = {
  create: PaymentMethodCreateWithoutLinesInput;
  update: PaymentMethodUpdateWithoutLinesInput;
  where?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodUpsertWithoutOrdersInput = {
  create: PaymentMethodCreateWithoutOrdersInput;
  update: PaymentMethodUpdateWithoutOrdersInput;
  where?: InputMaybe<PaymentMethodWhereInput>;
};

export type PaymentMethodWhereInput = {
  AND?: InputMaybe<Array<PaymentMethodWhereInput>>;
  NOT?: InputMaybe<Array<PaymentMethodWhereInput>>;
  OR?: InputMaybe<Array<PaymentMethodWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fee?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  shippingMethods?: InputMaybe<ShippingMethodListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentMethodWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentMethodWhereInput>>;
  NOT?: InputMaybe<Array<PaymentMethodWhereInput>>;
  OR?: InputMaybe<Array<PaymentMethodWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fee?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  name_country?: InputMaybe<PaymentMethodNameCountryCompoundUniqueInput>;
  orders?: InputMaybe<OrderListRelationFilter>;
  shippingMethods?: InputMaybe<ShippingMethodListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentMinAggregate = {
  __typename?: 'PaymentMinAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  method?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrderInput>;
  referenceId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  Method = 'method',
  OrderId = 'orderId',
  ReferenceId = 'referenceId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type PaymentScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  method?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  referenceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum PaymentStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Review = 'REVIEW'
}

export type PaymentSumAggregate = {
  __typename?: 'PaymentSumAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
};

export type PaymentUpdateInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneWithoutPaymentsNestedInput>;
  referenceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyMutationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method?: InputMaybe<StringFieldUpdateOperationsInput>;
  referenceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyWithWhereWithoutOrderInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutOrderInput>>;
  createMany?: InputMaybe<PaymentCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type PaymentUpdateWithWhereUniqueWithoutOrderInput = {
  data: PaymentUpdateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithoutOrderInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  method?: InputMaybe<StringFieldUpdateOperationsInput>;
  referenceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpsertWithWhereUniqueWithoutOrderInput = {
  create: PaymentCreateWithoutOrderInput;
  update: PaymentUpdateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  method?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  referenceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentWhereUniqueInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  method?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderNullableScalarRelationFilter>;
  orderId?: InputMaybe<StringNullableFilter>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumPaymentStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PersonalPickupOrders = {
  __typename?: 'PersonalPickupOrders';
  count: Scalars['Int']['output'];
  orders: Array<Order>;
  total: Scalars['Float']['output'];
};

export type PersonalPickupSearch = {
  name?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<Scalars['Int']['input']>;
};

export type Product = {
  __typename?: 'Product';
  _count: ProductCount;
  active: Scalars['Boolean']['output'];
  canRemove: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  live: Live;
  liveId: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  reservations: Array<Customer>;
  updatedAt: Scalars['DateTime']['output'];
  variants?: Maybe<Array<ProductVariant>>;
};


export type ProductReservationsArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type ProductVariantsArgs = {
  cursor?: InputMaybe<ProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductVariantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductAvgAggregate = {
  __typename?: 'ProductAvgAggregate';
  price?: Maybe<Scalars['Float']['output']>;
};

export type ProductBreakdown = {
  __typename?: 'ProductBreakdown';
  productId: Scalars['String']['output'];
  productName: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  units: Scalars['Int']['output'];
};

export type ProductCount = {
  __typename?: 'ProductCount';
  variants: Scalars['Int']['output'];
};

export type ProductCountAggregate = {
  __typename?: 'ProductCountAggregate';
  _all: Scalars['Int']['output'];
  active: Scalars['Int']['output'];
  canRemove: Scalars['Int']['output'];
  code: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  image: Scalars['Int']['output'];
  liveId: Scalars['Int']['output'];
  location: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProductCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  canRemove?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  live: LiveCreateNestedOneWithoutProductsInput;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variants?: InputMaybe<ProductVariantCreateNestedManyWithoutProductInput>;
};

export type ProductCreateManyLiveInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  canRemove?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductCreateManyLiveInputEnvelope = {
  data: Array<ProductCreateManyLiveInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCreateNestedManyWithoutLiveInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutLiveInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutLiveInput>>;
  createMany?: InputMaybe<ProductCreateManyLiveInputEnvelope>;
};

export type ProductCreateNestedOneWithoutVariantsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutVariantsInput>;
  create?: InputMaybe<ProductCreateWithoutVariantsInput>;
};

export type ProductCreateOrConnectWithoutLiveInput = {
  create: ProductCreateWithoutLiveInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutVariantsInput = {
  create: ProductCreateWithoutVariantsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutLiveInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  canRemove?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  variants?: InputMaybe<ProductVariantCreateNestedManyWithoutProductInput>;
};

export type ProductCreateWithoutVariantsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  canRemove?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  live: LiveCreateNestedOneWithoutProductsInput;
  location?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductListRelationFilter = {
  every?: InputMaybe<ProductWhereInput>;
  none?: InputMaybe<ProductWhereInput>;
  some?: InputMaybe<ProductWhereInput>;
};

export type ProductLiveIdCodeCompoundUniqueInput = {
  code: Scalars['String']['input'];
  liveId: Scalars['String']['input'];
};

export type ProductMaxAggregate = {
  __typename?: 'ProductMaxAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  canRemove?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  liveId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductMinAggregate = {
  __typename?: 'ProductMinAggregate';
  active?: Maybe<Scalars['Boolean']['output']>;
  canRemove?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  liveId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  canRemove?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrderInput>;
  live?: InputMaybe<LiveOrderByWithRelationInput>;
  liveId?: InputMaybe<SortOrder>;
  location?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  variants?: InputMaybe<ProductVariantOrderByRelationAggregateInput>;
};

export enum ProductScalarFieldEnum {
  Active = 'active',
  CanRemove = 'canRemove',
  Code = 'code',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Image = 'image',
  LiveId = 'liveId',
  Location = 'location',
  Metadata = 'metadata',
  Name = 'name',
  Price = 'price',
  UpdatedAt = 'updatedAt'
}

export type ProductScalarRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export type ProductScalarWhereInput = {
  AND?: InputMaybe<Array<ProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  canRemove?: InputMaybe<BoolFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  image?: InputMaybe<StringNullableFilter>;
  liveId?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  price?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductSumAggregate = {
  __typename?: 'ProductSumAggregate';
  price?: Maybe<Scalars['Int']['output']>;
};

export type ProductUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canRemove?: InputMaybe<BoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutProductsNestedInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  variants?: InputMaybe<ProductVariantUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canRemove?: InputMaybe<BoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpdateManyWithWhereWithoutLiveInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithoutLiveNestedInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutLiveInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutLiveInput>>;
  createMany?: InputMaybe<ProductCreateManyLiveInputEnvelope>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutLiveInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutLiveInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutLiveInput>>;
};

export type ProductUpdateOneRequiredWithoutVariantsNestedInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutVariantsInput>;
  create?: InputMaybe<ProductCreateWithoutVariantsInput>;
  update?: InputMaybe<ProductUpdateToOneWithWhereWithoutVariantsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutVariantsInput>;
};

export type ProductUpdateToOneWithWhereWithoutVariantsInput = {
  data: ProductUpdateWithoutVariantsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductUpdateWithWhereUniqueWithoutLiveInput = {
  data: ProductUpdateWithoutLiveInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithoutLiveInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canRemove?: InputMaybe<BoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  variants?: InputMaybe<ProductVariantUpdateManyWithoutProductNestedInput>;
};

export type ProductUpdateWithoutVariantsInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  canRemove?: InputMaybe<BoolFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  live?: InputMaybe<LiveUpdateOneRequiredWithoutProductsNestedInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductUpsertWithWhereUniqueWithoutLiveInput = {
  create: ProductCreateWithoutLiveInput;
  update: ProductUpdateWithoutLiveInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithoutVariantsInput = {
  create: ProductCreateWithoutVariantsInput;
  update: ProductUpdateWithoutVariantsInput;
  where?: InputMaybe<ProductWhereInput>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  _count: ProductVariantCount;
  attributes?: Maybe<Array<ProductVariantAttribute>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lines?: Maybe<Array<OrderLine>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  product: Product;
  productId: Scalars['String']['output'];
  reservations: Array<Customer>;
  stock: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type ProductVariantAttributesArgs = {
  cursor?: InputMaybe<ProductVariantAttributeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductVariantAttributeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductVariantAttributeOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductVariantAttributeWhereInput>;
};


export type ProductVariantLinesArgs = {
  cursor?: InputMaybe<OrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderLineOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderLineWhereInput>;
};


export type ProductVariantReservationsArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};

export type ProductVariantAttribute = {
  __typename?: 'ProductVariantAttribute';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
  variant: ProductVariant;
  variantId: Scalars['String']['output'];
};

export type ProductVariantAttributeCountAggregate = {
  __typename?: 'ProductVariantAttributeCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
  variantId: Scalars['Int']['output'];
};

export type ProductVariantAttributeCreateManyVariantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type ProductVariantAttributeCreateManyVariantInputEnvelope = {
  data: Array<ProductVariantAttributeCreateManyVariantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductVariantAttributeCreateNestedManyWithoutVariantInput = {
  connect?: InputMaybe<Array<ProductVariantAttributeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductVariantAttributeCreateOrConnectWithoutVariantInput>>;
  create?: InputMaybe<Array<ProductVariantAttributeCreateWithoutVariantInput>>;
  createMany?: InputMaybe<ProductVariantAttributeCreateManyVariantInputEnvelope>;
};

export type ProductVariantAttributeCreateOrConnectWithoutVariantInput = {
  create: ProductVariantAttributeCreateWithoutVariantInput;
  where: ProductVariantAttributeWhereUniqueInput;
};

export type ProductVariantAttributeCreateWithoutVariantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type ProductVariantAttributeListRelationFilter = {
  every?: InputMaybe<ProductVariantAttributeWhereInput>;
  none?: InputMaybe<ProductVariantAttributeWhereInput>;
  some?: InputMaybe<ProductVariantAttributeWhereInput>;
};

export type ProductVariantAttributeMaxAggregate = {
  __typename?: 'ProductVariantAttributeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantAttributeMinAggregate = {
  __typename?: 'ProductVariantAttributeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  variantId?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantAttributeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductVariantAttributeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  variant?: InputMaybe<ProductVariantOrderByWithRelationInput>;
  variantId?: InputMaybe<SortOrder>;
};

export enum ProductVariantAttributeScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  VariantId = 'variantId'
}

export type ProductVariantAttributeScalarWhereInput = {
  AND?: InputMaybe<Array<ProductVariantAttributeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantAttributeScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantAttributeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringFilter>;
  variantId?: InputMaybe<StringFilter>;
};

export type ProductVariantAttributeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductVariantAttributeUpdateManyWithWhereWithoutVariantInput = {
  data: ProductVariantAttributeUpdateManyMutationInput;
  where: ProductVariantAttributeScalarWhereInput;
};

export type ProductVariantAttributeUpdateManyWithoutVariantNestedInput = {
  connect?: InputMaybe<Array<ProductVariantAttributeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductVariantAttributeCreateOrConnectWithoutVariantInput>>;
  create?: InputMaybe<Array<ProductVariantAttributeCreateWithoutVariantInput>>;
  createMany?: InputMaybe<ProductVariantAttributeCreateManyVariantInputEnvelope>;
  delete?: InputMaybe<Array<ProductVariantAttributeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductVariantAttributeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductVariantAttributeWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductVariantAttributeWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductVariantAttributeUpdateWithWhereUniqueWithoutVariantInput>>;
  updateMany?: InputMaybe<Array<ProductVariantAttributeUpdateManyWithWhereWithoutVariantInput>>;
  upsert?: InputMaybe<Array<ProductVariantAttributeUpsertWithWhereUniqueWithoutVariantInput>>;
};

export type ProductVariantAttributeUpdateWithWhereUniqueWithoutVariantInput = {
  data: ProductVariantAttributeUpdateWithoutVariantInput;
  where: ProductVariantAttributeWhereUniqueInput;
};

export type ProductVariantAttributeUpdateWithoutVariantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductVariantAttributeUpsertWithWhereUniqueWithoutVariantInput = {
  create: ProductVariantAttributeCreateWithoutVariantInput;
  update: ProductVariantAttributeUpdateWithoutVariantInput;
  where: ProductVariantAttributeWhereUniqueInput;
};

export type ProductVariantAttributeVariantIdNameCompoundUniqueInput = {
  name: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};

export type ProductVariantAttributeWhereInput = {
  AND?: InputMaybe<Array<ProductVariantAttributeWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantAttributeWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantAttributeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringFilter>;
  variant?: InputMaybe<ProductVariantScalarRelationFilter>;
  variantId?: InputMaybe<StringFilter>;
};

export type ProductVariantAttributeWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductVariantAttributeWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantAttributeWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantAttributeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  value?: InputMaybe<StringFilter>;
  variant?: InputMaybe<ProductVariantScalarRelationFilter>;
  variantId?: InputMaybe<StringFilter>;
  variantId_name?: InputMaybe<ProductVariantAttributeVariantIdNameCompoundUniqueInput>;
};

export type ProductVariantAvgAggregate = {
  __typename?: 'ProductVariantAvgAggregate';
  stock?: Maybe<Scalars['Float']['output']>;
};

export type ProductVariantCount = {
  __typename?: 'ProductVariantCount';
  attributes: Scalars['Int']['output'];
  lines: Scalars['Int']['output'];
};

export type ProductVariantCountAggregate = {
  __typename?: 'ProductVariantCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  stock: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ProductVariantCreateManyProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductVariantCreateManyProductInputEnvelope = {
  data: Array<ProductVariantCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductVariantCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductVariantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductVariantCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductVariantCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductVariantCreateManyProductInputEnvelope>;
};

export type ProductVariantCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<ProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductVariantCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<ProductVariantCreateWithoutLinesInput>;
};

export type ProductVariantCreateOrConnectWithoutLinesInput = {
  create: ProductVariantCreateWithoutLinesInput;
  where: ProductVariantWhereUniqueInput;
};

export type ProductVariantCreateOrConnectWithoutProductInput = {
  create: ProductVariantCreateWithoutProductInput;
  where: ProductVariantWhereUniqueInput;
};

export type ProductVariantCreateWithoutLinesInput = {
  attributes?: InputMaybe<ProductVariantAttributeCreateNestedManyWithoutVariantInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  product: ProductCreateNestedOneWithoutVariantsInput;
  stock?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductVariantCreateWithoutProductInput = {
  attributes?: InputMaybe<ProductVariantAttributeCreateNestedManyWithoutVariantInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutProductVariantInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  stock?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProductVariantListRelationFilter = {
  every?: InputMaybe<ProductVariantWhereInput>;
  none?: InputMaybe<ProductVariantWhereInput>;
  some?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductVariantMaxAggregate = {
  __typename?: 'ProductVariantMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductVariantMinAggregate = {
  __typename?: 'ProductVariantMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  stock?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ProductVariantNullableScalarRelationFilter = {
  is?: InputMaybe<ProductVariantWhereInput>;
  isNot?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductVariantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductVariantOrderByWithRelationInput = {
  attributes?: InputMaybe<ProductVariantAttributeOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lines?: InputMaybe<OrderLineOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  stock?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductVariantScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  ProductId = 'productId',
  Stock = 'stock',
  UpdatedAt = 'updatedAt'
}

export type ProductVariantScalarRelationFilter = {
  is?: InputMaybe<ProductVariantWhereInput>;
  isNot?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductVariantScalarWhereInput = {
  AND?: InputMaybe<Array<ProductVariantScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  productId?: InputMaybe<StringFilter>;
  stock?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductVariantSumAggregate = {
  __typename?: 'ProductVariantSumAggregate';
  stock?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  stock?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductVariantUpdateManyWithWhereWithoutProductInput = {
  data: ProductVariantUpdateManyMutationInput;
  where: ProductVariantScalarWhereInput;
};

export type ProductVariantUpdateManyWithoutProductNestedInput = {
  connect?: InputMaybe<Array<ProductVariantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductVariantCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductVariantCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductVariantCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductVariantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductVariantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductVariantWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductVariantWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductVariantUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductVariantUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductVariantUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductVariantUpdateOneWithoutLinesNestedInput = {
  connect?: InputMaybe<ProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductVariantCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<ProductVariantCreateWithoutLinesInput>;
  delete?: InputMaybe<ProductVariantWhereInput>;
  disconnect?: InputMaybe<ProductVariantWhereInput>;
  update?: InputMaybe<ProductVariantUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<ProductVariantUpsertWithoutLinesInput>;
};

export type ProductVariantUpdateToOneWithWhereWithoutLinesInput = {
  data: ProductVariantUpdateWithoutLinesInput;
  where?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductVariantUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductVariantUpdateWithoutProductInput;
  where: ProductVariantWhereUniqueInput;
};

export type ProductVariantUpdateWithoutLinesInput = {
  attributes?: InputMaybe<ProductVariantAttributeUpdateManyWithoutVariantNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutVariantsNestedInput>;
  stock?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductVariantUpdateWithoutProductInput = {
  attributes?: InputMaybe<ProductVariantAttributeUpdateManyWithoutVariantNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutProductVariantNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  stock?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductVariantUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductVariantCreateWithoutProductInput;
  update: ProductVariantUpdateWithoutProductInput;
  where: ProductVariantWhereUniqueInput;
};

export type ProductVariantUpsertWithoutLinesInput = {
  create: ProductVariantCreateWithoutLinesInput;
  update: ProductVariantUpdateWithoutLinesInput;
  where?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductVariantWhereInput = {
  AND?: InputMaybe<Array<ProductVariantWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantWhereInput>>;
  attributes?: InputMaybe<ProductVariantAttributeListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  stock?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductVariantWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductVariantWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantWhereInput>>;
  attributes?: InputMaybe<ProductVariantAttributeListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  product?: InputMaybe<ProductScalarRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  stock?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  canRemove?: InputMaybe<BoolFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  image?: InputMaybe<StringNullableFilter>;
  live?: InputMaybe<LiveScalarRelationFilter>;
  liveId?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  price?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variants?: InputMaybe<ProductVariantListRelationFilter>;
};

export type ProductWhereUniqueInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  canRemove?: InputMaybe<BoolFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<StringNullableFilter>;
  live?: InputMaybe<LiveScalarRelationFilter>;
  liveId?: InputMaybe<StringFilter>;
  liveId_code?: InputMaybe<ProductLiveIdCodeCompoundUniqueInput>;
  location?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  price?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  variants?: InputMaybe<ProductVariantListRelationFilter>;
};

export type Query = {
  __typename?: 'Query';
  activeProductsStock: Array<Product>;
  address?: Maybe<Address>;
  addresses: Array<Address>;
  broadcastFailedJobs: Array<BroadcastFailedJob>;
  broadcastQueueStatus: BroadcastQueueStatus;
  checkoutOrder: Order;
  comment?: Maybe<Comment>;
  comments: Array<Comment>;
  commentsByLastKrajPage: CommentPage;
  commentsListPage: CommentPage;
  countAddresses: Scalars['Float']['output'];
  countComments: Scalars['Float']['output'];
  countCustomers: Scalars['Float']['output'];
  countLives: Scalars['Float']['output'];
  countOrders: Scalars['Float']['output'];
  countParcels: Scalars['Float']['output'];
  countProducts: Scalars['Float']['output'];
  countRefunds: Scalars['Float']['output'];
  countUsers: Scalars['Float']['output'];
  customer?: Maybe<Customer>;
  customers: Array<Customer>;
  expenses: Array<Expense>;
  firstAddress?: Maybe<Address>;
  firstComment?: Maybe<Comment>;
  firstCustomer?: Maybe<Customer>;
  firstLive?: Maybe<Live>;
  firstOrder?: Maybe<Order>;
  firstProduct?: Maybe<Product>;
  firstRefund?: Maybe<Refund>;
  firstUser?: Maybe<User>;
  latestActiveProduct?: Maybe<Product>;
  live?: Maybe<Live>;
  liveMotto: Scalars['String']['output'];
  liveOrdersSummary: LiveOrdersSummary;
  liveStatistics: LiveStatisticsResult;
  liveUnpackedLines: LiveUnpackedLinesResponse;
  liveUnprintedLabels: LiveUnprintedLabelsResponse;
  lives: Array<Live>;
  me: User;
  order?: Maybe<Order>;
  orders: Array<Order>;
  ordersTabletSummary: OrdersTabletSummary;
  parcelStatusGroupBy: Array<ParcelStatusGroupBy>;
  parcelStatuses: Array<ParcelStatus>;
  parcels: Array<Parcel>;
  paymentMethods: Array<PaymentMethod>;
  payments: Array<Payment>;
  personalPickupDeliveredOrders: PersonalPickupOrders;
  personalPickupOrders: PersonalPickupOrders;
  product?: Maybe<Product>;
  productTabletSummary?: Maybe<TabletProductStat>;
  productVariant: ProductVariant;
  products: Array<Product>;
  refund?: Maybe<Refund>;
  refunds: Array<Refund>;
  revenueStatistics: RevenueStatisticsResult;
  setting?: Maybe<Setting>;
  shippingMethods: Array<ShippingMethod>;
  sumupOrder: Order;
  user?: Maybe<User>;
  users: Array<User>;
};


export type QueryAddressArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: AddressWhereUniqueInput;
};


export type QueryAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryBroadcastFailedJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckoutOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryCommentArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: CommentWhereUniqueInput;
};


export type QueryCommentsArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryCommentsByLastKrajPageArgs = {
  direction?: InputMaybe<SortOrder>;
  filterKraj?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortByKraj?: InputMaybe<Scalars['Boolean']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryCommentsListPageArgs = {
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryCountAddressesArgs = {
  where: AddressWhereInput;
};


export type QueryCountCommentsArgs = {
  where: CommentWhereInput;
};


export type QueryCountCustomersArgs = {
  where: CustomerWhereInput;
};


export type QueryCountLivesArgs = {
  where: LiveWhereInput;
};


export type QueryCountOrdersArgs = {
  where: OrderWhereInput;
};


export type QueryCountParcelsArgs = {
  where: ParcelWhereInput;
};


export type QueryCountProductsArgs = {
  where: ProductWhereInput;
};


export type QueryCountRefundsArgs = {
  where: RefundWhereInput;
};


export type QueryCountUsersArgs = {
  where: UserWhereInput;
};


export type QueryCustomerArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: CustomerWhereUniqueInput;
};


export type QueryCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryFirstAddressArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryFirstCommentArgs = {
  cursor?: InputMaybe<CommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CommentWhereInput>;
};


export type QueryFirstCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryFirstLiveArgs = {
  cursor?: InputMaybe<LiveWhereUniqueInput>;
  distinct?: InputMaybe<Array<LiveScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LiveOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LiveWhereInput>;
};


export type QueryFirstOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFirstProductArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryFirstRefundArgs = {
  cursor?: InputMaybe<RefundWhereUniqueInput>;
  distinct?: InputMaybe<Array<RefundScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RefundOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RefundWhereInput>;
};


export type QueryFirstUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryLiveArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: LiveWhereUniqueInput;
};


export type QueryLiveOrdersSummaryArgs = {
  where: OrderWhereInput;
};


export type QueryLiveStatisticsArgs = {
  liveId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveUnpackedLinesArgs = {
  live: LiveWhereInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLiveUnprintedLabelsArgs = {
  live: LiveWhereInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLivesArgs = {
  cursor?: InputMaybe<LiveWhereUniqueInput>;
  distinct?: InputMaybe<Array<LiveScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LiveOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LiveWhereInput>;
};


export type QueryOrderArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: OrderWhereUniqueInput;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryOrdersTabletSummaryArgs = {
  where: OrderWhereInput;
};


export type QueryParcelStatusGroupByArgs = {
  _count?: InputMaybe<ParcelStatusCountAggregateInput>;
  _max?: InputMaybe<ParcelStatusMaxAggregateInput>;
  _min?: InputMaybe<ParcelStatusMinAggregateInput>;
  by: Array<ParcelStatusScalarFieldEnum>;
  having?: InputMaybe<ParcelStatusScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ParcelStatusOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ParcelStatusWhereInput>;
};


export type QueryParcelStatusesArgs = {
  cursor?: InputMaybe<ParcelStatusWhereUniqueInput>;
  distinct?: InputMaybe<Array<ParcelStatusScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ParcelStatusOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ParcelStatusWhereInput>;
};


export type QueryParcelsArgs = {
  cursor?: InputMaybe<ParcelWhereUniqueInput>;
  distinct?: InputMaybe<Array<ParcelScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ParcelOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ParcelWhereInput>;
};


export type QueryPaymentMethodsArgs = {
  cursor?: InputMaybe<PaymentMethodWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentMethodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentMethodOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentMethodWhereInput>;
};


export type QueryPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryPersonalPickupOrdersArgs = {
  search?: InputMaybe<PersonalPickupSearch>;
};


export type QueryProductArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: ProductWhereUniqueInput;
};


export type QueryProductTabletSummaryArgs = {
  variantsOrderBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput>>;
  where: ProductWhereUniqueInput;
};


export type QueryProductVariantArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: ProductVariantWhereUniqueInput;
};


export type QueryProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryRefundArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: RefundWhereUniqueInput;
};


export type QueryRefundsArgs = {
  cursor?: InputMaybe<RefundWhereUniqueInput>;
  distinct?: InputMaybe<Array<RefundScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RefundOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RefundWhereInput>;
};


export type QueryRevenueStatisticsArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


export type QuerySettingArgs = {
  key: Scalars['String']['input'];
};


export type QueryShippingMethodsArgs = {
  cursor?: InputMaybe<ShippingMethodWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShippingMethodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShippingMethodOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShippingMethodWhereInput>;
};


export type QuerySumupOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryUserArgs = {
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Refund = {
  __typename?: 'Refund';
  _count: RefundCount;
  amount: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  customer: Customer;
  customerId: Scalars['String']['output'];
  exportedAt?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lines?: Maybe<Array<OrderLine>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reason: Scalars['String']['output'];
  status: RefundStatus;
  updatedAt: Scalars['DateTime']['output'];
};


export type RefundLinesArgs = {
  cursor?: InputMaybe<OrderLineWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderLineScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderLineOrderByWithRelationInput>>;
  relationLoadStrategy?: InputMaybe<RelationLoadStrategy>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderLineWhereInput>;
};

export type RefundAvgAggregate = {
  __typename?: 'RefundAvgAggregate';
  amount?: Maybe<Scalars['Float']['output']>;
};

export type RefundCount = {
  __typename?: 'RefundCount';
  lines: Scalars['Int']['output'];
};

export type RefundCountAggregate = {
  __typename?: 'RefundCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  exportedAt: Scalars['Int']['output'];
  iban: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  note: Scalars['Int']['output'];
  processedAt: Scalars['Int']['output'];
  reason: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type RefundCreateInput = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutRefundsInput;
  exportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutRefundInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason: Scalars['String']['input'];
  status?: InputMaybe<RefundStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundCreateManyCustomerInput = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  exportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason: Scalars['String']['input'];
  status?: InputMaybe<RefundStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundCreateManyCustomerInputEnvelope = {
  data: Array<RefundCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RefundCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<RefundCreateManyCustomerInputEnvelope>;
};

export type RefundCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<RefundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RefundCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<RefundCreateWithoutLinesInput>;
};

export type RefundCreateOrConnectWithoutCustomerInput = {
  create: RefundCreateWithoutCustomerInput;
  where: RefundWhereUniqueInput;
};

export type RefundCreateOrConnectWithoutLinesInput = {
  create: RefundCreateWithoutLinesInput;
  where: RefundWhereUniqueInput;
};

export type RefundCreateWithoutCustomerInput = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  exportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutRefundInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason: Scalars['String']['input'];
  status?: InputMaybe<RefundStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundCreateWithoutLinesInput = {
  amount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutRefundsInput;
  exportedAt?: InputMaybe<Scalars['DateTime']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason: Scalars['String']['input'];
  status?: InputMaybe<RefundStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RefundListRelationFilter = {
  every?: InputMaybe<RefundWhereInput>;
  none?: InputMaybe<RefundWhereInput>;
  some?: InputMaybe<RefundWhereInput>;
};

export type RefundMaxAggregate = {
  __typename?: 'RefundMaxAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RefundStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RefundMinAggregate = {
  __typename?: 'RefundMinAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  exportedAt?: Maybe<Scalars['DateTime']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RefundStatus>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RefundNullableScalarRelationFilter = {
  is?: InputMaybe<RefundWhereInput>;
  isNot?: InputMaybe<RefundWhereInput>;
};

export type RefundOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RefundOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  exportedAt?: InputMaybe<SortOrderInput>;
  iban?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lines?: InputMaybe<OrderLineOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  note?: InputMaybe<SortOrderInput>;
  processedAt?: InputMaybe<SortOrderInput>;
  reason?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum RefundScalarFieldEnum {
  Amount = 'amount',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  ExportedAt = 'exportedAt',
  Iban = 'iban',
  Id = 'id',
  Metadata = 'metadata',
  Note = 'note',
  ProcessedAt = 'processedAt',
  Reason = 'reason',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type RefundScalarWhereInput = {
  AND?: InputMaybe<Array<RefundScalarWhereInput>>;
  NOT?: InputMaybe<Array<RefundScalarWhereInput>>;
  OR?: InputMaybe<Array<RefundScalarWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  exportedAt?: InputMaybe<DateTimeNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  reason?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumRefundStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum RefundStatus {
  Created = 'CREATED',
  Exported = 'EXPORTED',
  Processed = 'PROCESSED'
}

export type RefundSumAggregate = {
  __typename?: 'RefundSumAggregate';
  amount?: Maybe<Scalars['Int']['output']>;
};

export type RefundUpdateInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutRefundsNestedInput>;
  exportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutRefundNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRefundStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RefundUpdateManyMutationInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  exportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRefundStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RefundUpdateManyWithWhereWithoutCustomerInput = {
  data: RefundUpdateManyMutationInput;
  where: RefundScalarWhereInput;
};

export type RefundUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RefundCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<RefundCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<RefundCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<RefundWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RefundScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RefundWhereUniqueInput>>;
  set?: InputMaybe<Array<RefundWhereUniqueInput>>;
  update?: InputMaybe<Array<RefundUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<RefundUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<RefundUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type RefundUpdateOneWithoutLinesNestedInput = {
  connect?: InputMaybe<RefundWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RefundCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<RefundCreateWithoutLinesInput>;
  delete?: InputMaybe<RefundWhereInput>;
  disconnect?: InputMaybe<RefundWhereInput>;
  update?: InputMaybe<RefundUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<RefundUpsertWithoutLinesInput>;
};

export type RefundUpdateToOneWithWhereWithoutLinesInput = {
  data: RefundUpdateWithoutLinesInput;
  where?: InputMaybe<RefundWhereInput>;
};

export type RefundUpdateWithWhereUniqueWithoutCustomerInput = {
  data: RefundUpdateWithoutCustomerInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpdateWithoutCustomerInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  exportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutRefundNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRefundStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RefundUpdateWithoutLinesInput = {
  amount?: InputMaybe<IntFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutRefundsNestedInput>;
  exportedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  iban?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  note?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRefundStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RefundUpsertWithWhereUniqueWithoutCustomerInput = {
  create: RefundCreateWithoutCustomerInput;
  update: RefundUpdateWithoutCustomerInput;
  where: RefundWhereUniqueInput;
};

export type RefundUpsertWithoutLinesInput = {
  create: RefundCreateWithoutLinesInput;
  update: RefundUpdateWithoutLinesInput;
  where?: InputMaybe<RefundWhereInput>;
};

export type RefundWhereInput = {
  AND?: InputMaybe<Array<RefundWhereInput>>;
  NOT?: InputMaybe<Array<RefundWhereInput>>;
  OR?: InputMaybe<Array<RefundWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  exportedAt?: InputMaybe<DateTimeNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  reason?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumRefundStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RefundWhereUniqueInput = {
  AND?: InputMaybe<Array<RefundWhereInput>>;
  NOT?: InputMaybe<Array<RefundWhereInput>>;
  OR?: InputMaybe<Array<RefundWhereInput>>;
  amount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerScalarRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  exportedAt?: InputMaybe<DateTimeNullableFilter>;
  iban?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  note?: InputMaybe<StringNullableFilter>;
  processedAt?: InputMaybe<DateTimeNullableFilter>;
  reason?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumRefundStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum RelationLoadStrategy {
  Join = 'join',
  Query = 'query'
}

export type RevenueStatisticsDay = {
  __typename?: 'RevenueStatisticsDay';
  date: Scalars['String']['output'];
  paidTotal: Scalars['Float']['output'];
  productRevenue: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type RevenueStatisticsResult = {
  __typename?: 'RevenueStatisticsResult';
  byLive: Array<LiveBreakdown>;
  byPaymentMethod: Array<PaymentMethodBreakdown>;
  customRevenue: Scalars['Float']['output'];
  days: Array<RevenueStatisticsDay>;
  grossInflow: Scalars['Float']['output'];
  newCustomerCount: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  paidOrderCount: Scalars['Int']['output'];
  paidTotal: Scalars['Float']['output'];
  paymentRevenue: Scalars['Float']['output'];
  productRevenue: Scalars['Float']['output'];
  refundsTotal: Scalars['Float']['output'];
  shippingRevenue: Scalars['Float']['output'];
  topProducts: Array<ProductBreakdown>;
  uniqueCustomerCount: Scalars['Int']['output'];
  unitsSold: Scalars['Int']['output'];
  unpaidOrderCount: Scalars['Int']['output'];
  unpaidTotal: Scalars['Float']['output'];
};

export enum Role {
  Administrator = 'ADMINISTRATOR',
  Employee = 'EMPLOYEE'
}

export type Setting = {
  __typename?: 'Setting';
  key: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type SettingCountAggregate = {
  __typename?: 'SettingCountAggregate';
  _all: Scalars['Int']['output'];
  key: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type SettingMaxAggregate = {
  __typename?: 'SettingMaxAggregate';
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SettingMinAggregate = {
  __typename?: 'SettingMinAggregate';
  key?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Shipment = {
  __typename?: 'Shipment';
  _count: ShipmentCount;
  createdAt: Scalars['DateTime']['output'];
  externalId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderId: Scalars['String']['output'];
  parcels?: Maybe<Array<Parcel>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShipmentCount = {
  __typename?: 'ShipmentCount';
  parcels: Scalars['Int']['output'];
};

export type ShipmentCountAggregate = {
  __typename?: 'ShipmentCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  externalId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ShipmentCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutOrderInput>;
};

export type ShipmentCreateOrConnectWithoutOrderInput = {
  create: ShipmentCreateWithoutOrderInput;
  where: ShipmentWhereUniqueInput;
};

export type ShipmentCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parcels?: InputMaybe<ParcelCreateNestedManyWithoutShipmentInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShipmentMaxAggregate = {
  __typename?: 'ShipmentMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShipmentMinAggregate = {
  __typename?: 'ShipmentMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShipmentNullableScalarRelationFilter = {
  is?: InputMaybe<ShipmentWhereInput>;
  isNot?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrderInput>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  parcels?: InputMaybe<ParcelOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShipmentScalarRelationFilter = {
  is?: InputMaybe<ShipmentWhereInput>;
  isNot?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateOneWithoutOrderNestedInput = {
  connect?: InputMaybe<ShipmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShipmentCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<ShipmentCreateWithoutOrderInput>;
  delete?: InputMaybe<ShipmentWhereInput>;
  disconnect?: InputMaybe<ShipmentWhereInput>;
  update?: InputMaybe<ShipmentUpdateToOneWithWhereWithoutOrderInput>;
  upsert?: InputMaybe<ShipmentUpsertWithoutOrderInput>;
};

export type ShipmentUpdateToOneWithWhereWithoutOrderInput = {
  data: ShipmentUpdateWithoutOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableBytesFieldUpdateOperationsInput>;
  parcels?: InputMaybe<ParcelUpdateManyWithoutShipmentNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShipmentUpsertWithoutOrderInput = {
  create: ShipmentCreateWithoutOrderInput;
  update: ShipmentUpdateWithoutOrderInput;
  where?: InputMaybe<ShipmentWhereInput>;
};

export type ShipmentWhereInput = {
  AND?: InputMaybe<Array<ShipmentWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentWhereInput>>;
  OR?: InputMaybe<Array<ShipmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  label?: InputMaybe<BytesNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  parcels?: InputMaybe<ParcelListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ShipmentWhereUniqueInput = {
  AND?: InputMaybe<Array<ShipmentWhereInput>>;
  NOT?: InputMaybe<Array<ShipmentWhereInput>>;
  OR?: InputMaybe<Array<ShipmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<BytesNullableFilter>;
  order?: InputMaybe<OrderScalarRelationFilter>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  parcels?: InputMaybe<ParcelListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ShippingMethod = {
  __typename?: 'ShippingMethod';
  _count: ShippingMethodCount;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fee: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lines?: Maybe<Array<OrderLine>>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  orders?: Maybe<Array<Order>>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodAvgAggregate = {
  __typename?: 'ShippingMethodAvgAggregate';
  fee?: Maybe<Scalars['Float']['output']>;
};

export type ShippingMethodCount = {
  __typename?: 'ShippingMethodCount';
  lines: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  paymentMethods: Scalars['Int']['output'];
};

export type ShippingMethodCountAggregate = {
  __typename?: 'ShippingMethodCountAggregate';
  _all: Scalars['Int']['output'];
  country: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  fee: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type ShippingMethodCreateNestedManyWithoutPaymentMethodsInput = {
  connect?: InputMaybe<Array<ShippingMethodWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingMethodCreateOrConnectWithoutPaymentMethodsInput>>;
  create?: InputMaybe<Array<ShippingMethodCreateWithoutPaymentMethodsInput>>;
};

export type ShippingMethodCreateNestedOneWithoutLinesInput = {
  connect?: InputMaybe<ShippingMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingMethodCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<ShippingMethodCreateWithoutLinesInput>;
};

export type ShippingMethodCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<ShippingMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingMethodCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<ShippingMethodCreateWithoutOrdersInput>;
};

export type ShippingMethodCreateOrConnectWithoutLinesInput = {
  create: ShippingMethodCreateWithoutLinesInput;
  where: ShippingMethodWhereUniqueInput;
};

export type ShippingMethodCreateOrConnectWithoutOrdersInput = {
  create: ShippingMethodCreateWithoutOrdersInput;
  where: ShippingMethodWhereUniqueInput;
};

export type ShippingMethodCreateOrConnectWithoutPaymentMethodsInput = {
  create: ShippingMethodCreateWithoutPaymentMethodsInput;
  where: ShippingMethodWhereUniqueInput;
};

export type ShippingMethodCreateWithoutLinesInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutShippingMethodInput>;
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutShippingMethodsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShippingMethodCreateWithoutOrdersInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutShippingMethodInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  paymentMethods?: InputMaybe<PaymentMethodCreateNestedManyWithoutShippingMethodsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShippingMethodCreateWithoutPaymentMethodsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineCreateNestedManyWithoutShippingMethodInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutShippingMethodInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShippingMethodListRelationFilter = {
  every?: InputMaybe<ShippingMethodWhereInput>;
  none?: InputMaybe<ShippingMethodWhereInput>;
  some?: InputMaybe<ShippingMethodWhereInput>;
};

export type ShippingMethodMaxAggregate = {
  __typename?: 'ShippingMethodMaxAggregate';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShippingMethodMinAggregate = {
  __typename?: 'ShippingMethodMinAggregate';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShippingMethodNameCountryCompoundUniqueInput = {
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ShippingMethodNullableScalarRelationFilter = {
  is?: InputMaybe<ShippingMethodWhereInput>;
  isNot?: InputMaybe<ShippingMethodWhereInput>;
};

export type ShippingMethodOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShippingMethodOrderByWithRelationInput = {
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  fee?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lines?: InputMaybe<OrderLineOrderByRelationAggregateInput>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  paymentMethods?: InputMaybe<PaymentMethodOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ShippingMethodScalarFieldEnum {
  Country = 'country',
  CreatedAt = 'createdAt',
  Description = 'description',
  Fee = 'fee',
  Id = 'id',
  Metadata = 'metadata',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type ShippingMethodScalarWhereInput = {
  AND?: InputMaybe<Array<ShippingMethodScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShippingMethodScalarWhereInput>>;
  OR?: InputMaybe<Array<ShippingMethodScalarWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fee?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ShippingMethodSumAggregate = {
  __typename?: 'ShippingMethodSumAggregate';
  fee?: Maybe<Scalars['Int']['output']>;
};

export type ShippingMethodUpdateInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutShippingMethodNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutShippingMethodNestedInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutShippingMethodsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShippingMethodUpdateManyMutationInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShippingMethodUpdateManyWithWhereWithoutPaymentMethodsInput = {
  data: ShippingMethodUpdateManyMutationInput;
  where: ShippingMethodScalarWhereInput;
};

export type ShippingMethodUpdateManyWithoutPaymentMethodsNestedInput = {
  connect?: InputMaybe<Array<ShippingMethodWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShippingMethodCreateOrConnectWithoutPaymentMethodsInput>>;
  create?: InputMaybe<Array<ShippingMethodCreateWithoutPaymentMethodsInput>>;
  delete?: InputMaybe<Array<ShippingMethodWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShippingMethodScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShippingMethodWhereUniqueInput>>;
  set?: InputMaybe<Array<ShippingMethodWhereUniqueInput>>;
  update?: InputMaybe<Array<ShippingMethodUpdateWithWhereUniqueWithoutPaymentMethodsInput>>;
  updateMany?: InputMaybe<Array<ShippingMethodUpdateManyWithWhereWithoutPaymentMethodsInput>>;
  upsert?: InputMaybe<Array<ShippingMethodUpsertWithWhereUniqueWithoutPaymentMethodsInput>>;
};

export type ShippingMethodUpdateOneWithoutLinesNestedInput = {
  connect?: InputMaybe<ShippingMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingMethodCreateOrConnectWithoutLinesInput>;
  create?: InputMaybe<ShippingMethodCreateWithoutLinesInput>;
  delete?: InputMaybe<ShippingMethodWhereInput>;
  disconnect?: InputMaybe<ShippingMethodWhereInput>;
  update?: InputMaybe<ShippingMethodUpdateToOneWithWhereWithoutLinesInput>;
  upsert?: InputMaybe<ShippingMethodUpsertWithoutLinesInput>;
};

export type ShippingMethodUpdateOneWithoutOrdersNestedInput = {
  connect?: InputMaybe<ShippingMethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShippingMethodCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<ShippingMethodCreateWithoutOrdersInput>;
  delete?: InputMaybe<ShippingMethodWhereInput>;
  disconnect?: InputMaybe<ShippingMethodWhereInput>;
  update?: InputMaybe<ShippingMethodUpdateToOneWithWhereWithoutOrdersInput>;
  upsert?: InputMaybe<ShippingMethodUpsertWithoutOrdersInput>;
};

export type ShippingMethodUpdateToOneWithWhereWithoutLinesInput = {
  data: ShippingMethodUpdateWithoutLinesInput;
  where?: InputMaybe<ShippingMethodWhereInput>;
};

export type ShippingMethodUpdateToOneWithWhereWithoutOrdersInput = {
  data: ShippingMethodUpdateWithoutOrdersInput;
  where?: InputMaybe<ShippingMethodWhereInput>;
};

export type ShippingMethodUpdateWithWhereUniqueWithoutPaymentMethodsInput = {
  data: ShippingMethodUpdateWithoutPaymentMethodsInput;
  where: ShippingMethodWhereUniqueInput;
};

export type ShippingMethodUpdateWithoutLinesInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutShippingMethodNestedInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutShippingMethodsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShippingMethodUpdateWithoutOrdersInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutShippingMethodNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentMethods?: InputMaybe<PaymentMethodUpdateManyWithoutShippingMethodsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShippingMethodUpdateWithoutPaymentMethodsInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fee?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lines?: InputMaybe<OrderLineUpdateManyWithoutShippingMethodNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutShippingMethodNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ShippingMethodUpsertWithWhereUniqueWithoutPaymentMethodsInput = {
  create: ShippingMethodCreateWithoutPaymentMethodsInput;
  update: ShippingMethodUpdateWithoutPaymentMethodsInput;
  where: ShippingMethodWhereUniqueInput;
};

export type ShippingMethodUpsertWithoutLinesInput = {
  create: ShippingMethodCreateWithoutLinesInput;
  update: ShippingMethodUpdateWithoutLinesInput;
  where?: InputMaybe<ShippingMethodWhereInput>;
};

export type ShippingMethodUpsertWithoutOrdersInput = {
  create: ShippingMethodCreateWithoutOrdersInput;
  update: ShippingMethodUpdateWithoutOrdersInput;
  where?: InputMaybe<ShippingMethodWhereInput>;
};

export type ShippingMethodWhereInput = {
  AND?: InputMaybe<Array<ShippingMethodWhereInput>>;
  NOT?: InputMaybe<Array<ShippingMethodWhereInput>>;
  OR?: InputMaybe<Array<ShippingMethodWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fee?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  paymentMethods?: InputMaybe<PaymentMethodListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ShippingMethodWhereUniqueInput = {
  AND?: InputMaybe<Array<ShippingMethodWhereInput>>;
  NOT?: InputMaybe<Array<ShippingMethodWhereInput>>;
  OR?: InputMaybe<Array<ShippingMethodWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fee?: InputMaybe<IntFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  lines?: InputMaybe<OrderLineListRelationFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  name_country?: InputMaybe<ShippingMethodNameCountryCompoundUniqueInput>;
  orders?: InputMaybe<OrderListRelationFilter>;
  paymentMethods?: InputMaybe<PaymentMethodListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type SignInInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignInResponse = {
  __typename?: 'SignInResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type SignOutResponse = {
  __typename?: 'SignOutResponse';
  success: Scalars['Boolean']['output'];
};

export type SignUpInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignUpResponse = {
  __typename?: 'SignUpResponse';
  token: Scalars['String']['output'];
  user: User;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  commentCreated: Comment;
};

export type TabletProductStat = {
  __typename?: 'TabletProductStat';
  prevLinesCount: Scalars['Int']['output'];
  recentLinesCount: Scalars['Int']['output'];
  reservationsCount: Scalars['Int']['output'];
  secondsSinceLastSale?: Maybe<Scalars['Int']['output']>;
  variants: Array<TabletVariantStat>;
};

export type TabletVariantStat = {
  __typename?: 'TabletVariantStat';
  attributes: Array<ProductVariantAttribute>;
  id: Scalars['String']['output'];
  linesCount: Scalars['Int']['output'];
  linesSum: Scalars['Int']['output'];
  reservationsCount: Scalars['Int']['output'];
  stock: Scalars['Int']['output'];
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  password: Scalars['String']['output'];
  role: Role;
  updatedAt: Scalars['DateTime']['output'];
};

export type UserCountAggregate = {
  __typename?: 'UserCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['Int']['output'];
  password: Scalars['Int']['output'];
  role: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type UserCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  password: Scalars['String']['input'];
  role?: InputMaybe<Role>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserMaxAggregate = {
  __typename?: 'UserMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserMinAggregate = {
  __typename?: 'UserMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum UserScalarFieldEnum {
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Metadata = 'metadata',
  Password = 'password',
  Role = 'role',
  UpdatedAt = 'updatedAt'
}

export type UserUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  password?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type UserWhereUniqueInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<JsonNullableFilter>;
  password?: InputMaybe<StringFilter>;
  role?: InputMaybe<EnumRoleFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ReplyCommentToMutationVariables = Exact<{
  objectId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type ReplyCommentToMutation = { __typename?: 'Mutation', replyCommentTo: string };

export type CommentsQueryVariables = Exact<{
  where?: InputMaybe<CommentWhereInput>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<CommentWhereUniqueInput>;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, commentId: string, body: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null, active: boolean, reason?: string | null, orders?: Array<{ __typename?: 'Order', id: string, package: number, total: number }> | null }, parent?: { __typename?: 'Comment', id: string, body: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null } } | null }> };

export type CommentCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type CommentCreatedSubscription = { __typename?: 'Subscription', commentCreated: { __typename?: 'Comment', id: string, commentId: string, body: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null, active: boolean, reason?: string | null, orders?: Array<{ __typename?: 'Order', id: string, package: number, total: number }> | null }, parent?: { __typename?: 'Comment', id: string, body: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null } } | null } };

export type SignInMutationVariables = Exact<{
  data: SignInInput;
}>;


export type SignInMutation = { __typename?: 'Mutation', signIn: { __typename?: 'SignInResponse', token: string, user: { __typename?: 'User', id: string, email: string, role: Role } } };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', signOut: { __typename?: 'SignOutResponse', success: boolean } };

export type BroadcastQueueStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type BroadcastQueueStatusQuery = { __typename?: 'Query', broadcastQueueStatus: { __typename?: 'BroadcastQueueStatus', waiting: number, active: number, completed: number, failed: number, delayed: number, paused: number } };

export type BroadcastFailedJobsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BroadcastFailedJobsQuery = { __typename?: 'Query', broadcastFailedJobs: Array<{ __typename?: 'BroadcastFailedJob', id: string, pageId: string, name: string, reason?: string | null, failedAt?: number | null }> };

export type RemoveLineFromCheckoutMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  lineId: Scalars['String']['input'];
}>;


export type RemoveLineFromCheckoutMutation = { __typename?: 'Mutation', removeLineFromCheckout: { __typename?: 'OrderLine', id: string } };

export type ClearShippingAndPaymentMethodOnCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ClearShippingAndPaymentMethodOnCheckoutOrderMutation = { __typename?: 'Mutation', clearShippingAndPaymentMethodOnCheckoutOrder: { __typename?: 'Order', id: string } };

export type SetShippingMethodOnCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  shippingMethodId: Scalars['String']['input'];
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetShippingMethodOnCheckoutOrderMutation = { __typename?: 'Mutation', setShippingMethodOnCheckoutOrder: { __typename?: 'Order', id: string } };

export type SetPaymentMethodOnCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetPaymentMethodOnCheckoutOrderMutation = { __typename?: 'Mutation', setPaymentMethodOnCheckoutOrder: { __typename?: 'Order', id: string } };

export type SetAddressOnCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  addressId: Scalars['String']['input'];
}>;


export type SetAddressOnCheckoutOrderMutation = { __typename?: 'Mutation', setAddressOnCheckoutOrder: { __typename?: 'Order', id: string } };

export type UpsertAddressOnCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  address: AddressCreateWithoutCustomerInput;
}>;


export type UpsertAddressOnCheckoutOrderMutation = { __typename?: 'Mutation', upsertAddressOnCheckoutOrder: { __typename?: 'Order', id: string } };

export type ConfirmCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  isPersonal: Scalars['Boolean']['input'];
}>;


export type ConfirmCheckoutOrderMutation = { __typename?: 'Mutation', confirmCheckoutOrder: { __typename?: 'Order', id: string, status: OrderStatus, package: number, total: number } };

export type SetNoteOnCheckoutOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  note: Scalars['String']['input'];
}>;


export type SetNoteOnCheckoutOrderMutation = { __typename?: 'Mutation', setNoteOnCheckoutOrder: { __typename?: 'Order', id: string } };

export type CheckoutOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type CheckoutOrderQuery = { __typename?: 'Query', checkoutOrder: { __typename?: 'Order', id: string, package: number, status: OrderStatus, total: number, paymentMethodId?: string | null, shippingMethodId?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, email?: string | null, avatar?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, name: string, streetLine: string, streetDescription?: string | null, city: string, postCode: string, country: string, phone: string }> | null }, address?: { __typename?: 'OrderAddress', name: string, streetLine: string, streetDescription?: string | null, city: string, postCode: string, country: string, phone: string, addressId?: string | null } | null, lines?: Array<{ __typename?: 'OrderLine', id: string, type: OrderLineType, code: string, name: string, description?: string | null, price: number, productVariantId?: string | null }> | null, live: { __typename?: 'Live', id: string, name: string, description?: string | null, date: Date | string }, availableShippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, description?: string | null, fee: number }>, availablePaymentMethods: Array<{ __typename?: 'PaymentMethod', id: string, name: string, description?: string | null, fee: number }> } };

export type SumUpOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type SumUpOrderQuery = { __typename?: 'Query', sumupOrder: { __typename?: 'Order', id: string, payments: Array<{ __typename?: 'Payment', id: string, amount: number, status: PaymentStatus, referenceId?: string | null }> } };

export type CommentListQueryVariables = Exact<{
  where?: InputMaybe<CommentWhereInput>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommentListQuery = { __typename?: 'Query', comments: Array<{ __typename?: 'Comment', id: string, commentId: string, body: string, postId: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, _count: { __typename?: 'CustomerCount', orders: number }, addresses?: Array<{ __typename?: 'Address', country: string, postCode: string }> | null } }> };

export type CommentsListPageQueryVariables = Exact<{
  where?: InputMaybe<CommentWhereInput>;
  orderBy?: InputMaybe<Array<CommentOrderByWithRelationInput> | CommentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CommentsListPageQuery = { __typename?: 'Query', commentsListPage: { __typename?: 'CommentPage', totalCount: number, items: Array<{ __typename?: 'Comment', id: string, commentId: string, body: string, postId: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, _count: { __typename?: 'CustomerCount', orders: number }, addresses?: Array<{ __typename?: 'Address', country: string, postCode: string }> | null } }> } };

export type CommentsByLastKrajPageQueryVariables = Exact<{
  where?: InputMaybe<CommentWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<SortOrder>;
  filterKraj?: InputMaybe<Scalars['String']['input']>;
  sortByKraj?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommentsByLastKrajPageQuery = { __typename?: 'Query', commentsByLastKrajPage: { __typename?: 'CommentPage', totalCount: number, items: Array<{ __typename?: 'Comment', id: string, commentId: string, body: string, postId: string, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, _count: { __typename?: 'CustomerCount', orders: number }, addresses?: Array<{ __typename?: 'Address', country: string, postCode: string }> | null } }> } };

export type CountCommentsQueryVariables = Exact<{
  where: CommentWhereInput;
}>;


export type CountCommentsQuery = { __typename?: 'Query', countComments: number };

export type CustomerQueryVariables = Exact<{
  where: CustomerWhereUniqueInput;
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, pageId: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, updatedAt: Date | string, _count: { __typename?: 'CustomerCount', orders: number, messages: number, addresses: number }, messages?: Array<{ __typename?: 'Message', id: string, body: string, isEcho: boolean, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null } }> | null } | null };

export type DeleteCustomerMutationVariables = Exact<{
  where: CustomerWhereUniqueInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer: { __typename?: 'Customer', id: string, pageId: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, updatedAt: Date | string } };

export type CustomersQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
}>;


export type CustomersQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', id: string, pageId: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, reason?: string | null, _count: { __typename?: 'CustomerCount', orders: number, messages: number, addresses: number, refunds: number } }> };

export type CountCustomersQueryVariables = Exact<{
  where: CustomerWhereInput;
}>;


export type CountCustomersQuery = { __typename?: 'Query', countCustomers: number };

export type BroadcastCustomersQueryVariables = Exact<{
  where: CustomerWhereInput;
  skip: Scalars['Int']['input'];
  take: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
}>;


export type BroadcastCustomersQuery = { __typename?: 'Query', countCustomers: number, customers: Array<{ __typename?: 'Customer', id: string, name: string, avatar?: string | null, active: boolean, reason?: string | null, createdAt: Date | string, updatedAt: Date | string }> };

export type SendBroadcastMutationVariables = Exact<{
  message: Scalars['String']['input'];
  url: Scalars['String']['input'];
  where: CustomerWhereInput;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  limit: Scalars['Int']['input'];
  skip: Scalars['Int']['input'];
}>;


export type SendBroadcastMutation = { __typename?: 'Mutation', sendBroadcast: number };

export type UpsertCustomerMutationVariables = Exact<{
  where: CustomerWhereUniqueInput;
  create: CustomerCreateInput;
  update: CustomerUpdateInput;
}>;


export type UpsertCustomerMutation = { __typename?: 'Mutation', upsertCustomer: { __typename?: 'Customer', id: string, pageId: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, updatedAt: Date | string } };

export type LiveDetailsHeaderQueryVariables = Exact<{
  liveId: Scalars['String']['input'];
}>;


export type LiveDetailsHeaderQuery = { __typename?: 'Query', live?: { __typename?: 'Live', id: string, active: boolean, name: string, description?: string | null, date: Date | string, _count: { __typename?: 'LiveCount', orders: number, products: number }, orders?: Array<{ __typename?: 'Order', id: string, total: number }> | null } | null };

export type LiveUnpackedLinesDocumentQueryVariables = Exact<{
  live: LiveWhereInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LiveUnpackedLinesDocumentQuery = { __typename?: 'Query', liveUnpackedLines: { __typename?: 'LiveUnpackedLinesResponse', total: number, lines: Array<{ __typename?: 'OrderLine', id: string, code: string, name: string, description?: string | null, price: number, productVariant?: { __typename?: 'ProductVariant', id: string, attributes?: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> | null } | null, order: { __typename?: 'Order', id: string, package: number, customer: { __typename?: 'Customer', id: string, name: string } } }> } };

export type LiveUnprintedLabelsDocumentQueryVariables = Exact<{
  live: LiveWhereInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LiveUnprintedLabelsDocumentQuery = { __typename?: 'Query', liveUnprintedLabels: { __typename?: 'LiveUnprintedLabelsResponse', total: number, orders: Array<{ __typename?: 'Order', id: string, package: number, customer: { __typename?: 'Customer', id: string, name: string } }> } };

export type ToggleLiveActiveMutationVariables = Exact<{
  where: LiveWhereUniqueInput;
}>;


export type ToggleLiveActiveMutation = { __typename?: 'Mutation', toggleLiveActive: { __typename?: 'Live', id: string, active: boolean } };

export type DeleteLiveMutationVariables = Exact<{
  where: LiveWhereUniqueInput;
}>;


export type DeleteLiveMutation = { __typename?: 'Mutation', deleteLive: { __typename?: 'Live', id: string } };

export type UpsertLiveMutationVariables = Exact<{
  where: LiveWhereUniqueInput;
  create: LiveCreateInput;
  update: LiveUpdateInput;
}>;


export type UpsertLiveMutation = { __typename?: 'Mutation', upsertLive: { __typename?: 'Live', id: string } };

export type SendCheckoutLinksMutationVariables = Exact<{
  where: LiveWhereUniqueInput;
}>;


export type SendCheckoutLinksMutation = { __typename?: 'Mutation', sendCheckoutLinks: number };

export type LivesQueryVariables = Exact<{
  where?: InputMaybe<LiveWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiveOrderByWithRelationInput> | LiveOrderByWithRelationInput>;
}>;


export type LivesQuery = { __typename?: 'Query', lives: Array<{ __typename?: 'Live', id: string, name: string, description?: string | null, date: Date | string, active: boolean, createdAt: Date | string, updatedAt: Date | string, _count: { __typename?: 'LiveCount', orders: number, products: number } }> };

export type CountLivesQueryVariables = Exact<{
  where: LiveWhereInput;
}>;


export type CountLivesQuery = { __typename?: 'Query', countLives: number };

export type LiveMottoQueryVariables = Exact<{ [key: string]: never; }>;


export type LiveMottoQuery = { __typename?: 'Query', liveMotto: string };

export type LivesIdQueryVariables = Exact<{
  where?: InputMaybe<LiveWhereInput>;
  orderBy?: InputMaybe<Array<LiveOrderByWithRelationInput> | LiveOrderByWithRelationInput>;
}>;


export type LivesIdQuery = { __typename?: 'Query', lives: Array<{ __typename?: 'Live', id: string, name: string }> };

export type OrderAddressDetailsFragment = { __typename?: 'OrderAddress', name: string, streetLine: string, streetDescription?: string | null, city: string, postCode: string, country: string, phone: string, addressId?: string | null } & { ' $fragmentName'?: 'OrderAddressDetailsFragment' };

export type OrderCustomerDetailsFragment = { __typename?: 'Customer', id: string, pageId: string, name: string, email?: string | null, avatar?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, reason?: string | null, addresses?: Array<{ __typename?: 'Address', id: string, name: string, streetLine: string, streetDescription?: string | null, city: string, postCode: string, country: string, phone: string }> | null, _count: { __typename?: 'CustomerCount', orders: number, addresses: number } } & { ' $fragmentName'?: 'OrderCustomerDetailsFragment' };

export type OrderDetailsFragment = { __typename?: 'Order', id: string, package: number, status: OrderStatus, total: number, createdAt: Date | string, trackingNumber?: string | null, packedBy?: string | null, customer: { __typename?: 'Customer', id: string, name: string }, shippingMethod?: { __typename?: 'ShippingMethod', id: string, name: string } | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string } | null, payments: Array<{ __typename?: 'Payment', id: string, method: string, amount: number, status: PaymentStatus, referenceId?: string | null, createdAt: Date | string, updatedAt: Date | string }> } & { ' $fragmentName'?: 'OrderDetailsFragment' };

export type OrderLineDetailsFragment = { __typename?: 'OrderLine', id: string, type: OrderLineType, status: OrderLineStatus, code: string, name: string, description?: string | null, price: number, productVariantId?: string | null, shippingMethodId?: string | null, paymentMethodId?: string | null } & { ' $fragmentName'?: 'OrderLineDetailsFragment' };

export type OrderCancellationDetailsFragment = { __typename?: 'OrderLineCancellation', id: string, lineCode: string, lineName: string, linePrice: number, source: CancellationSource, reason?: string | null, cancelledAt: Date | string } & { ' $fragmentName'?: 'OrderCancellationDetailsFragment' };

export type UpdateOrderMutationVariables = Exact<{
  where: OrderWhereUniqueInput;
  data: OrderUpdateInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder: { __typename?: 'Order', id: string } };

export type UpsertOrderAddressMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  input: OrderAddressCreateWithoutOrderInput;
}>;


export type UpsertOrderAddressMutation = { __typename?: 'Mutation', upsertOrderAddress: { __typename?: 'Order', id: string, address?: (
      { __typename?: 'OrderAddress' }
      & { ' $fragmentRefs'?: { 'OrderAddressDetailsFragment': OrderAddressDetailsFragment } }
    ) | null } };

export type UpdateOrderCustomerMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  input: CustomerCreateInput;
}>;


export type UpdateOrderCustomerMutation = { __typename?: 'Mutation', updateOrderCustomer: { __typename?: 'Order', id: string, customer: (
      { __typename?: 'Customer' }
      & { ' $fragmentRefs'?: { 'OrderCustomerDetailsFragment': OrderCustomerDetailsFragment } }
    ) } };

export type UpdateLineOnOrderMutationVariables = Exact<{
  lineId: Scalars['String']['input'];
  input: OrderLineUpdateWithoutOrderInput;
}>;


export type UpdateLineOnOrderMutation = { __typename?: 'Mutation', updateLineOnOrder: (
    { __typename?: 'OrderLine' }
    & { ' $fragmentRefs'?: { 'OrderLineDetailsFragment': OrderLineDetailsFragment } }
  ) };

export type UpsertLineOnOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  input: OrderLineCreateManyOrderInput;
}>;


export type UpsertLineOnOrderMutation = { __typename?: 'Mutation', upsertLineOnOrder: { __typename?: 'Order', id: string, lines?: Array<(
      { __typename?: 'OrderLine' }
      & { ' $fragmentRefs'?: { 'OrderLineDetailsFragment': OrderLineDetailsFragment } }
    )> | null } };

export type RemoveLineFromOrderMutationVariables = Exact<{
  lineId: Scalars['String']['input'];
  reason: Scalars['String']['input'];
}>;


export type RemoveLineFromOrderMutation = { __typename?: 'Mutation', removeLineFromOrder: { __typename?: 'Order', id: string, total: number, lines?: Array<(
      { __typename?: 'OrderLine' }
      & { ' $fragmentRefs'?: { 'OrderLineDetailsFragment': OrderLineDetailsFragment } }
    )> | null, cancellations: Array<(
      { __typename?: 'OrderLineCancellation' }
      & { ' $fragmentRefs'?: { 'OrderCancellationDetailsFragment': OrderCancellationDetailsFragment } }
    )> } };

export type RecalculateOrderTotalMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type RecalculateOrderTotalMutation = { __typename?: 'Mutation', recalculateOrderTotal: { __typename?: 'Order', id: string, total: number } };

export type ProcessOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type ProcessOrderMutation = { __typename?: 'Mutation', processOrder: { __typename?: 'Order', id: string, status: OrderStatus } };

export type CreateShipmentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateShipmentMutation = { __typename?: 'Mutation', createShipment: (
    { __typename?: 'Order' }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type CreateShipmentDpdMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateShipmentDpdMutation = { __typename?: 'Mutation', createShipmentDPD: (
    { __typename?: 'Order' }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type DeleteShipmentMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type DeleteShipmentMutation = { __typename?: 'Mutation', deleteShipment: (
    { __typename?: 'Order' }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type SetIbanTypeMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  ibanType: Scalars['String']['input'];
}>;


export type SetIbanTypeMutation = { __typename?: 'Mutation', setIbanType: (
    { __typename?: 'Order' }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type SetShippingMethodOnOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  shippingMethodId: Scalars['String']['input'];
}>;


export type SetShippingMethodOnOrderMutation = { __typename?: 'Mutation', setShippingMethodOnOrder: (
    { __typename?: 'Order' }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type SetPaymentMethodOnOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
}>;


export type SetPaymentMethodOnOrderMutation = { __typename?: 'Mutation', setPaymentMethodOnOrder: (
    { __typename?: 'Order' }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: (
    { __typename?: 'Order', id: string }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) };

export type SendMessageMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: boolean };

export type SendMessagesMutationVariables = Exact<{
  orderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SendMessagesMutation = { __typename?: 'Mutation', sendMessages: boolean };

export type IssueInvoiceMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
  shouldSend: Scalars['Boolean']['input'];
}>;


export type IssueInvoiceMutation = { __typename?: 'Mutation', issueInvoice: { __typename?: 'Invoice', id: string, number: string, url?: string | null, createdAt: Date | string, sent: boolean } };

export type IssueInvoicesMutationVariables = Exact<{
  orderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type IssueInvoicesMutation = { __typename?: 'Mutation', issueInvoices: number };

export type ShippingOrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type ShippingOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, package: number, status: OrderStatus, total: number, createdAt: Date | string, updatedAt: Date | string, packedBy?: string | null, shipment?: { __typename?: 'Shipment', id: string, externalId: string, createdAt: Date | string, updatedAt: Date | string, parcels?: Array<{ __typename?: 'Parcel', id: string, externalId: string, trackingNumber: string, weight?: number | null, createdAt: Date | string, updatedAt: Date | string, statuses?: Array<{ __typename?: 'ParcelStatus', id: string, statusCode: string, statusDate: Date | string, statusDescription?: string | null, statusInfo?: string | null, depotCity?: string | null, depotNumber?: string | null, createdAt: Date | string, updatedAt: Date | string }> | null }> | null } | null, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null }, shippingMethod?: { __typename?: 'ShippingMethod', id: string, name: string } | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string } | null, payments: Array<{ __typename?: 'Payment', id: string, method: string, amount: number, status: PaymentStatus, referenceId?: string | null, createdAt: Date | string, updatedAt: Date | string }>, address?: { __typename?: 'OrderAddress', name: string, streetLine: string, streetDescription?: string | null, city: string, postCode: string, country: string, phone: string } | null, lines?: Array<{ __typename?: 'OrderLine', id: string, type: OrderLineType, status: OrderLineStatus, code: string, name: string, description?: string | null, price: number, productVariantId?: string | null, shippingMethodId?: string | null, paymentMethodId?: string | null }> | null } | null };

export type OrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type OrderQuery = { __typename?: 'Query', order?: (
    { __typename?: 'Order', id: string, status: OrderStatus, shippingMethod?: { __typename?: 'ShippingMethod', id: string, name: string } | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string } | null, address?: (
      { __typename?: 'OrderAddress' }
      & { ' $fragmentRefs'?: { 'OrderAddressDetailsFragment': OrderAddressDetailsFragment } }
    ) | null, customer: (
      { __typename?: 'Customer', metadata?: any | null, messages?: Array<{ __typename?: 'Message', id: string, body: string, isEcho: boolean, createdAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null } }> | null }
      & { ' $fragmentRefs'?: { 'OrderCustomerDetailsFragment': OrderCustomerDetailsFragment } }
    ), lines?: Array<(
      { __typename?: 'OrderLine' }
      & { ' $fragmentRefs'?: { 'OrderLineDetailsFragment': OrderLineDetailsFragment } }
    )> | null, cancellations: Array<(
      { __typename?: 'OrderLineCancellation' }
      & { ' $fragmentRefs'?: { 'OrderCancellationDetailsFragment': OrderCancellationDetailsFragment } }
    )> }
    & { ' $fragmentRefs'?: { 'OrderDetailsFragment': OrderDetailsFragment } }
  ) | null };

export type CountOrdersQueryVariables = Exact<{
  where: OrderWhereInput;
}>;


export type CountOrdersQuery = { __typename?: 'Query', countOrders: number };

export type LiveOrdersSummaryQueryVariables = Exact<{
  where: OrderWhereInput;
}>;


export type LiveOrdersSummaryQuery = { __typename?: 'Query', liveOrdersSummary: { __typename?: 'LiveOrdersSummary', all: { __typename?: 'OrderBucket', count: number, total: number }, bank: { __typename?: 'OrderBucket', count: number, total: number }, card: { __typename?: 'OrderBucket', count: number, total: number }, cod: { __typename?: 'OrderBucket', count: number, total: number }, cash: { __typename?: 'OrderBucket', count: number, total: number }, created: { __typename?: 'OrderBucket', count: number, total: number }, confirmed: { __typename?: 'OrderBucket', count: number, total: number }, processed: { __typename?: 'OrderBucket', count: number, total: number }, shipped: { __typename?: 'OrderBucket', count: number, total: number }, reviewing: { __typename?: 'OrderBucket', count: number, total: number }, delivered: { __typename?: 'OrderBucket', count: number, total: number }, reserved: { __typename?: 'OrderBucket', count: number, total: number }, packed: { __typename?: 'OrderBucket', count: number, total: number }, leftCods: { __typename?: 'OrderBucket', count: number, total: number }, leftPersonal: { __typename?: 'OrderBucket', count: number, total: number }, leftBank: { __typename?: 'OrderBucket', count: number, total: number }, leftCard: { __typename?: 'OrderBucket', count: number, total: number }, unpaidBank: { __typename?: 'OrderBucket', count: number, total: number }, unpaidCard: { __typename?: 'OrderBucket', count: number, total: number }, unpaidCods: { __typename?: 'OrderBucket', count: number, total: number }, paymentProblems: { __typename?: 'OrderBucket', count: number, total: number } } };

export type OrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, package: number, status: OrderStatus, total: number, createdAt: Date | string, updatedAt: Date | string, packedBy?: string | null, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null, metadata?: any | null }, address?: { __typename?: 'OrderAddress', phone: string } | null, live: { __typename?: 'Live', id: string, name: string, description?: string | null }, shippingMethod?: { __typename?: 'ShippingMethod', id: string, name: string } | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string } | null, payments: Array<{ __typename?: 'Payment', id: string, status: PaymentStatus, amount: number, method: string, createdAt: Date | string, updatedAt: Date | string, metadata?: any | null }>, invoice?: { __typename?: 'Invoice', id: string, number: string, url?: string | null, sent: boolean } | null }> };

export type OrdersTabletQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
}>;


export type OrdersTabletQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, package: number, total: number, packedBy?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null }, address?: { __typename?: 'OrderAddress', phone: string } | null, live: { __typename?: 'Live', id: string, name: string } }> };

export type OrdersTabletSummaryQueryVariables = Exact<{
  where: OrderWhereInput;
}>;


export type OrdersTabletSummaryQuery = { __typename?: 'Query', ordersTabletSummary: { __typename?: 'OrdersTabletSummary', total: number, count: number } };

export type PersonalPickupOrdersQueryVariables = Exact<{
  search?: InputMaybe<PersonalPickupSearch>;
}>;


export type PersonalPickupOrdersQuery = { __typename?: 'Query', personalPickupOrders: { __typename?: 'PersonalPickupOrders', count: number, total: number, orders: Array<{ __typename?: 'Order', id: string, package: number, total: number, packedBy?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null }, address?: { __typename?: 'OrderAddress', phone: string } | null, live: { __typename?: 'Live', id: string, name: string } }> } };

export type PersonalPickupDeliveredOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type PersonalPickupDeliveredOrdersQuery = { __typename?: 'Query', personalPickupDeliveredOrders: { __typename?: 'PersonalPickupOrders', count: number, total: number, orders: Array<{ __typename?: 'Order', id: string, package: number, total: number, packedBy?: string | null, createdAt: Date | string, updatedAt: Date | string, customer: { __typename?: 'Customer', id: string, name: string, avatar?: string | null }, address?: { __typename?: 'OrderAddress', phone: string } | null, live: { __typename?: 'Live', id: string, name: string } }> } };

export type ParcelsQueryVariables = Exact<{
  where?: InputMaybe<ParcelWhereInput>;
  orderBy?: InputMaybe<Array<ParcelOrderByWithRelationInput> | ParcelOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ParcelsQuery = { __typename?: 'Query', parcels: Array<{ __typename?: 'Parcel', id: string, externalId: string, trackingNumber: string, createdAt: Date | string, updatedAt: Date | string, statuses?: Array<{ __typename?: 'ParcelStatus', id: string, statusCode: string, statusDate: Date | string, statusDescription?: string | null, statusInfo?: string | null, depotCity?: string | null, depotNumber?: string | null }> | null, shipment: { __typename?: 'Shipment', id: string, order: { __typename?: 'Order', id: string, package: number, total: number, customer: { __typename?: 'Customer', id: string, name: string } } } }> };

export type CountParcelsQueryVariables = Exact<{
  where: ParcelWhereInput;
}>;


export type CountParcelsQuery = { __typename?: 'Query', countParcels: number };

export type ParcelStatusGroupByQueryVariables = Exact<{
  by: Array<ParcelStatusScalarFieldEnum> | ParcelStatusScalarFieldEnum;
  where?: InputMaybe<ParcelStatusWhereInput>;
  orderBy?: InputMaybe<Array<ParcelStatusOrderByWithAggregationInput> | ParcelStatusOrderByWithAggregationInput>;
}>;


export type ParcelStatusGroupByQuery = { __typename?: 'Query', parcelStatusGroupBy: Array<{ __typename?: 'ParcelStatusGroupBy', statusCode: string, statusDescription?: string | null, _count?: { __typename?: 'ParcelStatusCountAggregate', statusCode: number } | null }> };

export type PaymentsQueryVariables = Exact<{
  where?: InputMaybe<PaymentWhereInput>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput> | PaymentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PaymentsQuery = { __typename?: 'Query', payments: Array<{ __typename?: 'Payment', id: string, method: string, amount: number, referenceId?: string | null, status: PaymentStatus, createdAt: Date | string, updatedAt: Date | string, metadata?: any | null, order?: { __typename?: 'Order', id: string, total: number, package: number, customer: { __typename?: 'Customer', id: string, name: string } } | null }> };

export type UpdatePaymentMutationVariables = Exact<{
  where: PaymentWhereUniqueInput;
  data: PaymentUpdateInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment: { __typename?: 'Payment', id: string, method: string, amount: number, referenceId?: string | null, status: PaymentStatus, createdAt: Date | string, updatedAt: Date | string, order?: { __typename?: 'Order', id: string, total: number, package: number, customer: { __typename?: 'Customer', id: string, name: string } } | null } };

export type DeletePaymentMutationVariables = Exact<{
  where: PaymentWhereUniqueInput;
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deletePayment: { __typename?: 'Payment', id: string } };

export type CountProductsQueryVariables = Exact<{
  where: ProductWhereInput;
}>;


export type CountProductsQuery = { __typename?: 'Query', countProducts: number };

export type DeleteProductMutationVariables = Exact<{
  where: ProductWhereUniqueInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct: { __typename?: 'Product', id: string } };

export type ProductVariantQueryVariables = Exact<{
  where: ProductVariantWhereUniqueInput;
}>;


export type ProductVariantQuery = { __typename?: 'Query', productVariant: { __typename?: 'ProductVariant', id: string, lines?: Array<{ __typename?: 'OrderLine', id: string, price: number, createdAt: Date | string, order: { __typename?: 'Order', id: string, package: number, total: number, customer: { __typename?: 'Customer', id: string, name: string } } }> | null } };

export type ProductModalQueryVariables = Exact<{
  where: ProductWhereUniqueInput;
}>;


export type ProductModalQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, code: string, name: string, description?: string | null, price: number, location?: string | null, image?: string | null, active: boolean, canRemove: boolean, liveId: string, variants?: Array<{ __typename?: 'ProductVariant', id: string, stock: number, attributes?: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> | null, _count: { __typename?: 'ProductVariantCount', lines: number } }> | null } | null };

export type ProductQueryVariables = Exact<{
  where: ProductWhereUniqueInput;
  variantsOrdersBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput> | ProductVariantOrderByWithRelationInput>;
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, code: string, description?: string | null, location?: string | null, image?: string | null, price: number, active: boolean, canRemove: boolean, reservations: Array<{ __typename?: 'Customer', id: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, stock: number, attributes?: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> | null, lines?: Array<{ __typename?: 'OrderLine', id: string, price: number }> | null, reservations: Array<{ __typename?: 'Customer', id: string, name: string }> }> | null, live: { __typename?: 'Live', id: string, description?: string | null } } | null };

export type ProductListQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput> | ProductOrderByWithRelationInput>;
}>;


export type ProductListQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, code: string, name: string, description?: string | null, price: number, active: boolean, canRemove: boolean, createdAt: Date | string, updatedAt: Date | string }> };

export type ProductLivesQueryVariables = Exact<{
  where?: InputMaybe<LiveWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiveOrderByWithRelationInput> | LiveOrderByWithRelationInput>;
}>;


export type ProductLivesQuery = { __typename?: 'Query', lives: Array<{ __typename?: 'Live', id: string, name: string }> };

export type ProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput> | ProductOrderByWithRelationInput>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, code: string, name: string, description?: string | null, price: number, active: boolean, canRemove: boolean, createdAt: Date | string, updatedAt: Date | string, live: { __typename?: 'Live', id: string, name: string, description?: string | null }, reservations: Array<{ __typename?: 'Customer', id: string, name: string }>, _count: { __typename?: 'ProductCount', variants: number } }> };

export type ProductsCodeQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
}>;


export type ProductsCodeQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, code: string, active: boolean, price: number }> };

export type ProductsTabletQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput> | ProductOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductsTabletQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, code: string, name: string, description?: string | null, price: number }> };

export type ProductTabletQueryVariables = Exact<{
  where: ProductWhereUniqueInput;
  variantsOrdersBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput> | ProductVariantOrderByWithRelationInput>;
}>;


export type ProductTabletQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, reservations: Array<{ __typename?: 'Customer', id: string }>, variants?: Array<{ __typename?: 'ProductVariant', id: string, stock: number, attributes?: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> | null, lines?: Array<{ __typename?: 'OrderLine', id: string, price: number }> | null, reservations: Array<{ __typename?: 'Customer', id: string }> }> | null } | null };

export type ProductTabletSummaryQueryVariables = Exact<{
  where: ProductWhereUniqueInput;
  variantsOrderBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput> | ProductVariantOrderByWithRelationInput>;
}>;


export type ProductTabletSummaryQuery = { __typename?: 'Query', productTabletSummary?: { __typename?: 'TabletProductStat', reservationsCount: number, recentLinesCount: number, prevLinesCount: number, secondsSinceLastSale?: number | null, variants: Array<{ __typename?: 'TabletVariantStat', id: string, stock: number, linesCount: number, linesSum: number, reservationsCount: number, attributes: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> }> } | null };

export type SetProductActiveMutationVariables = Exact<{
  id: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type SetProductActiveMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, active: boolean } };

export type SetProductCanRemoveMutationVariables = Exact<{
  id: Scalars['String']['input'];
  canRemove: Scalars['Boolean']['input'];
}>;


export type SetProductCanRemoveMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, canRemove: boolean } };

export type IncrementProductVariantStockMutationVariables = Exact<{
  productVariantId: Scalars['String']['input'];
  increment: Scalars['Int']['input'];
}>;


export type IncrementProductVariantStockMutation = { __typename?: 'Mutation', incrementVariantStock: { __typename?: 'ProductVariant', id: string, stock: number } };

export type DecrementProductVariantStockMutationVariables = Exact<{
  productVariantId: Scalars['String']['input'];
  decrement: Scalars['Int']['input'];
}>;


export type DecrementProductVariantStockMutation = { __typename?: 'Mutation', decrementVariantStock: { __typename?: 'ProductVariant', id: string, stock: number } };

export type RemoveProductVariantFromOrdersMutationVariables = Exact<{
  productVariantId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type RemoveProductVariantFromOrdersMutation = { __typename?: 'Mutation', removeProductVariantFromOrders: boolean };

export type RemoveProductVariantOrderLineMutationVariables = Exact<{
  lineId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type RemoveProductVariantOrderLineMutation = { __typename?: 'Mutation', removeProductVariantOrderLine: boolean };

export type AddVariantToProductMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  stock: Scalars['Int']['input'];
  attributes: Array<ProductVariantAttributeCreateWithoutVariantInput> | ProductVariantAttributeCreateWithoutVariantInput;
}>;


export type AddVariantToProductMutation = { __typename?: 'Mutation', addVariantToProduct: { __typename?: 'ProductVariant', id: string, stock: number, attributes?: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> | null } };

export type BulkUpdateProductPriceMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  newPrice: Scalars['Int']['input'];
  message: Scalars['String']['input'];
}>;


export type BulkUpdateProductPriceMutation = { __typename?: 'Mutation', bulkUpdateProductPrice: number };

export type BulkUpdateProductDetailsMutationVariables = Exact<{
  productId: Scalars['String']['input'];
  newName: Scalars['String']['input'];
  newDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type BulkUpdateProductDetailsMutation = { __typename?: 'Mutation', bulkUpdateProductDetails: number };

export type CountActiveCartsForProductQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type CountActiveCartsForProductQuery = { __typename?: 'Query', countOrders: number };

export type UpsertProductMutationVariables = Exact<{
  where: ProductWhereUniqueInput;
  create: ProductCreateInput;
  update: ProductUpdateInput;
}>;


export type UpsertProductMutation = { __typename?: 'Mutation', upsertProduct: { __typename?: 'Product', id: string } };

export type DeleteRefundMutationVariables = Exact<{
  where: RefundWhereUniqueInput;
}>;


export type DeleteRefundMutation = { __typename?: 'Mutation', deleteRefund: { __typename?: 'Refund', id: string } };

export type RefundCustomerSearchQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RefundCustomerSearchQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', id: string, name: string, avatar?: string | null, createdAt: Date | string, updatedAt: Date | string, active: boolean, reason?: string | null, _count: { __typename?: 'CustomerCount', orders: number, refunds: number } }> };

export type RefundCustomerOrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RefundCustomerOrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, package: number, status: OrderStatus, total: number, createdAt: Date | string, updatedAt: Date | string, shippingMethod?: { __typename?: 'ShippingMethod', id: string, name: string } | null, paymentMethod?: { __typename?: 'PaymentMethod', id: string, name: string } | null, lines?: Array<{ __typename?: 'OrderLine', id: string, type: OrderLineType, code: string, name: string, status: OrderLineStatus, price: number, description?: string | null }> | null }> };

export type RefundStatisticsQueryVariables = Exact<{
  where: RefundWhereInput;
}>;


export type RefundStatisticsQuery = { __typename?: 'Query', refunds: Array<{ __typename?: 'Refund', id: string, status: RefundStatus, iban?: string | null, reason: string, amount: number, createdAt: Date | string }> };

export type CountRefundsQueryVariables = Exact<{
  where: RefundWhereInput;
}>;


export type CountRefundsQuery = { __typename?: 'Query', countRefunds: number };

export type RefundsQueryVariables = Exact<{
  where?: InputMaybe<RefundWhereInput>;
  orderBy?: InputMaybe<Array<RefundOrderByWithRelationInput> | RefundOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RefundsQuery = { __typename?: 'Query', refunds: Array<{ __typename?: 'Refund', id: string, status: RefundStatus, reason: string, note?: string | null, amount: number, iban?: string | null, customerId: string, createdAt: Date | string, updatedAt: Date | string, exportedAt?: Date | string | null, processedAt?: Date | string | null, lines?: Array<{ __typename?: 'OrderLine', id: string, type: OrderLineType, code: string, name: string, status: OrderLineStatus, price: number, description?: string | null, order: { __typename?: 'Order', id: string, package: number } }> | null, customer: { __typename?: 'Customer', id: string, avatar?: string | null, name: string }, _count: { __typename?: 'RefundCount', lines: number } }> };

export type RefundQueryVariables = Exact<{
  where: RefundWhereUniqueInput;
}>;


export type RefundQuery = { __typename?: 'Query', refund?: { __typename?: 'Refund', id: string, status: RefundStatus, reason: string, note?: string | null, amount: number, iban?: string | null, customerId: string, createdAt: Date | string, updatedAt: Date | string, exportedAt?: Date | string | null, processedAt?: Date | string | null, customer: { __typename?: 'Customer', id: string, name: string, email?: string | null, iban?: string | null }, lines?: Array<{ __typename?: 'OrderLine', id: string, name: string, code: string, price: number, order: { __typename?: 'Order', id: string, package: number } }> | null } | null };

export type UpsertRefundMutationVariables = Exact<{
  where: RefundWhereUniqueInput;
  create: RefundCreateInput;
  update: RefundUpdateInput;
}>;


export type UpsertRefundMutation = { __typename?: 'Mutation', upsertRefund: { __typename?: 'Refund', id: string, status: RefundStatus, reason: string, note?: string | null, amount: number, iban?: string | null, customerId: string, createdAt: Date | string, updatedAt: Date | string } };

export type UpdateRefundMutationVariables = Exact<{
  where: RefundWhereUniqueInput;
  data: RefundUpdateInput;
}>;


export type UpdateRefundMutation = { __typename?: 'Mutation', updateRefund: { __typename?: 'Refund', id: string, status: RefundStatus, reason: string, note?: string | null, amount: number, iban?: string | null, customerId: string, createdAt: Date | string, updatedAt: Date | string } };

export type ShippingMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShippingMethodsQuery = { __typename?: 'Query', shippingMethods: Array<{ __typename?: 'ShippingMethod', id: string, name: string, country?: string | null, description?: string | null, fee: number, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, name: string, country?: string | null, description?: string | null, fee: number }> | null }> };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<{ __typename?: 'PaymentMethod', id: string, name: string, country?: string | null, description?: string | null, fee: number }> };

export type UpdateShippingMethodMutationVariables = Exact<{
  where: ShippingMethodWhereUniqueInput;
  data: ShippingMethodUpdateInput;
}>;


export type UpdateShippingMethodMutation = { __typename?: 'Mutation', updateShippingMethod: { __typename?: 'ShippingMethod', id: string, name: string, country?: string | null, description?: string | null, fee: number, paymentMethods?: Array<{ __typename?: 'PaymentMethod', id: string, name: string, country?: string | null, description?: string | null, fee: number }> | null } };

export type LiveStatisticsQueryVariables = Exact<{
  liveId?: InputMaybe<Scalars['String']['input']>;
}>;


export type LiveStatisticsQuery = { __typename?: 'Query', liveStatistics: { __typename?: 'LiveStatisticsResult', cancelledTotal: number, cancelledCount: number, realLostTotal: number, realLostCustomerCount: number, swapTotal: number, swapCustomerCount: number, adminCancelledTotal: number, adminCancelledCustomerCount: number, intervals: Array<{ __typename?: 'LiveStatisticsInterval', interval: string, total: number, count: number, cancelledTotal: number, cancelledCount: number }>, products: Array<{ __typename?: 'LiveStatisticsProduct', productId: string, productName: string, total: number, cancelledTotal: number, cancelledCount: number }> } };

export type RevenueStatisticsQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
}>;


export type RevenueStatisticsQuery = { __typename?: 'Query', revenueStatistics: { __typename?: 'RevenueStatisticsResult', productRevenue: number, shippingRevenue: number, paymentRevenue: number, customRevenue: number, grossInflow: number, refundsTotal: number, orderCount: number, unitsSold: number, uniqueCustomerCount: number, newCustomerCount: number, paidTotal: number, unpaidTotal: number, paidOrderCount: number, unpaidOrderCount: number, byPaymentMethod: Array<{ __typename?: 'PaymentMethodBreakdown', method: string, orderCount: number, total: number, paidTotal: number, unpaidTotal: number, paidOrderCount: number, unpaidOrderCount: number }>, byLive: Array<{ __typename?: 'LiveBreakdown', liveId: string, liveName: string, liveDate?: Date | string | null, total: number, productRevenue: number, orderCount: number }>, topProducts: Array<{ __typename?: 'ProductBreakdown', productId: string, productName: string, total: number, units: number }>, days: Array<{ __typename?: 'RevenueStatisticsDay', date: string, total: number, productRevenue: number, paidTotal: number }> } };

export type ExpensesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExpensesQuery = { __typename?: 'Query', expenses: Array<{ __typename?: 'Expense', id: string, name: string, amount: number, type: ExpenseType, date?: Date | string | null }> };

export type CreateExpenseMutationVariables = Exact<{
  name: Scalars['String']['input'];
  amount: Scalars['Int']['input'];
  type: ExpenseType;
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateExpenseMutation = { __typename?: 'Mutation', createExpense: { __typename?: 'Expense', id: string, name: string, amount: number, type: ExpenseType, date?: Date | string | null } };

export type UpdateExpenseMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateExpenseMutation = { __typename?: 'Mutation', updateExpense: { __typename?: 'Expense', id: string, name: string, amount: number, type: ExpenseType, date?: Date | string | null } };

export type DeleteExpenseMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteExpenseMutation = { __typename?: 'Mutation', deleteExpense: { __typename?: 'Expense', id: string } };

export type SettingQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type SettingQuery = { __typename?: 'Query', setting?: { __typename?: 'Setting', key: string, value: string } | null };

export type UpsertSettingMutationVariables = Exact<{
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type UpsertSettingMutation = { __typename?: 'Mutation', upsertSetting: { __typename?: 'Setting', key: string, value: string } };

export type ActiveProductsStockQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveProductsStockQuery = { __typename?: 'Query', activeProductsStock: Array<{ __typename?: 'Product', id: string, code: string, name: string, price: number, variants?: Array<{ __typename?: 'ProductVariant', id: string, stock: number, attributes?: Array<{ __typename?: 'ProductVariantAttribute', id: string, name: string, value: string }> | null }> | null }> };

export type UpsertUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  create: UserCreateInput;
  update: UserUpdateInput;
}>;


export type UpsertUserMutation = { __typename?: 'Mutation', upsertUser: { __typename?: 'User', id: string } };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email: string, role: Role, createdAt: Date | string, updatedAt: Date | string }> };

export type LatestActiveProductQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestActiveProductQuery = { __typename?: 'Query', latestActiveProduct?: { __typename?: 'Product', id: string, code: string, name: string, price: number, variants?: Array<{ __typename?: 'ProductVariant', id: string, stock: number }> | null } | null };

export const OrderAddressDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}}]} as unknown as DocumentNode<OrderAddressDetailsFragment, unknown>;
export const OrderCustomerDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}}]}}]}}]} as unknown as DocumentNode<OrderCustomerDetailsFragment, unknown>;
export const OrderDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<OrderDetailsFragment, unknown>;
export const OrderLineDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]} as unknown as DocumentNode<OrderLineDetailsFragment, unknown>;
export const OrderCancellationDetailsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCancellationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineCancellation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineCode"}},{"kind":"Field","name":{"kind":"Name","value":"lineName"}},{"kind":"Field","name":{"kind":"Name","value":"linePrice"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]} as unknown as DocumentNode<OrderCancellationDetailsFragment, unknown>;
export const ReplyCommentToDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReplyCommentTo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"replyCommentTo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"objectId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<ReplyCommentToMutation, ReplyCommentToMutationVariables>;
export const CommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Comments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentWhereUniqueInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"CREATED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentsQuery, CommentsQueryVariables>;
export const CommentCreatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CommentCreated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentCreated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"CREATED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentCreatedSubscription, CommentCreatedSubscriptionVariables>;
export const SignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignInInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignInMutation, SignInMutationVariables>;
export const SignOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SignOutMutation, SignOutMutationVariables>;
export const BroadcastQueueStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BroadcastQueueStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastQueueStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"waiting"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"completed"}},{"kind":"Field","name":{"kind":"Name","value":"failed"}},{"kind":"Field","name":{"kind":"Name","value":"delayed"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}}]}}]}}]} as unknown as DocumentNode<BroadcastQueueStatusQuery, BroadcastQueueStatusQueryVariables>;
export const BroadcastFailedJobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BroadcastFailedJobs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastFailedJobs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"failedAt"}}]}}]}}]} as unknown as DocumentNode<BroadcastFailedJobsQuery, BroadcastFailedJobsQueryVariables>;
export const RemoveLineFromCheckoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveLineFromCheckout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeLineFromCheckout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveLineFromCheckoutMutation, RemoveLineFromCheckoutMutationVariables>;
export const ClearShippingAndPaymentMethodOnCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ClearShippingAndPaymentMethodOnCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clearShippingAndPaymentMethodOnCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ClearShippingAndPaymentMethodOnCheckoutOrderMutation, ClearShippingAndPaymentMethodOnCheckoutOrderMutationVariables>;
export const SetShippingMethodOnCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetShippingMethodOnCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shippingMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPersonal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setShippingMethodOnCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shippingMethodId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isPersonal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPersonal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetShippingMethodOnCheckoutOrderMutation, SetShippingMethodOnCheckoutOrderMutationVariables>;
export const SetPaymentMethodOnCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPaymentMethodOnCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPersonal"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPaymentMethodOnCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isPersonal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPersonal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetPaymentMethodOnCheckoutOrderMutation, SetPaymentMethodOnCheckoutOrderMutationVariables>;
export const SetAddressOnCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetAddressOnCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setAddressOnCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"addressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetAddressOnCheckoutOrderMutation, SetAddressOnCheckoutOrderMutationVariables>;
export const UpsertAddressOnCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertAddressOnCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressCreateWithoutCustomerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertAddressOnCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertAddressOnCheckoutOrderMutation, UpsertAddressOnCheckoutOrderMutationVariables>;
export const ConfirmCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isPersonal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isPersonal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isPersonal"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<ConfirmCheckoutOrderMutation, ConfirmCheckoutOrderMutationVariables>;
export const SetNoteOnCheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetNoteOnCheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"note"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setNoteOnCheckoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"note"},"value":{"kind":"Variable","name":{"kind":"Name","value":"note"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SetNoteOnCheckoutOrderMutation, SetNoteOnCheckoutOrderMutationVariables>;
export const CheckoutOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckoutOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableShippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availablePaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]}}]} as unknown as DocumentNode<CheckoutOrderQuery, CheckoutOrderQueryVariables>;
export const SumUpOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SumUpOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sumupOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}}]}}]}}]}}]} as unknown as DocumentNode<SumUpOrderQuery, SumUpOrderQueryVariables>;
export const CommentListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"postId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentListQuery, CommentListQueryVariables>;
export const CommentsListPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentsListPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentsListPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"postId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentsListPageQuery, CommentsListPageQueryVariables>;
export const CommentsByLastKrajPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CommentsByLastKrajPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterKraj"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortByKraj"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"commentsByLastKrajPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}},{"kind":"Argument","name":{"kind":"Name","value":"filterKraj"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterKraj"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortByKraj"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortByKraj"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commentId"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"postId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CommentsByLastKrajPageQuery, CommentsByLastKrajPageQueryVariables>;
export const CountCommentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountComments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CommentWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countComments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountCommentsQuery, CountCommentsQueryVariables>;
export const CustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Customer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"isEcho"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CustomerQuery, CustomerQueryVariables>;
export const DeleteCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const CustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Customers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"messages"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"}}]}}]}}]}}]} as unknown as DocumentNode<CustomersQuery, CustomersQueryVariables>;
export const CountCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountCustomersQuery, CountCustomersQueryVariables>;
export const BroadcastCustomersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BroadcastCustomers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"countCustomers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<BroadcastCustomersQuery, BroadcastCustomersQueryVariables>;
export const SendBroadcastDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendBroadcast"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendBroadcast"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}]}]}}]} as unknown as DocumentNode<SendBroadcastMutation, SendBroadcastMutationVariables>;
export const UpsertCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertCustomerMutation, UpsertCustomerMutationVariables>;
export const LiveDetailsHeaderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveDetailsHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liveId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"live"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liveId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"products"}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<LiveDetailsHeaderQuery, LiveDetailsHeaderQueryVariables>;
export const LiveUnpackedLinesDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveUnpackedLinesDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"live"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveUnpackedLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"live"},"value":{"kind":"Variable","name":{"kind":"Name","value":"live"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiveUnpackedLinesDocumentQuery, LiveUnpackedLinesDocumentQueryVariables>;
export const LiveUnprintedLabelsDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveUnprintedLabelsDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"live"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveUnprintedLabels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"live"},"value":{"kind":"Variable","name":{"kind":"Name","value":"live"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiveUnprintedLabelsDocumentQuery, LiveUnprintedLabelsDocumentQueryVariables>;
export const ToggleLiveActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleLiveActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleLiveActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<ToggleLiveActiveMutation, ToggleLiveActiveMutationVariables>;
export const DeleteLiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteLiveMutation, DeleteLiveMutationVariables>;
export const UpsertLiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertLive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertLive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertLiveMutation, UpsertLiveMutationVariables>;
export const SendCheckoutLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendCheckoutLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendCheckoutLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<SendCheckoutLinksMutation, SendCheckoutLinksMutationVariables>;
export const LivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Lives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"products"}}]}}]}}]}}]} as unknown as DocumentNode<LivesQuery, LivesQueryVariables>;
export const CountLivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountLives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countLives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountLivesQuery, CountLivesQueryVariables>;
export const LiveMottoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveMotto"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveMotto"}}]}}]} as unknown as DocumentNode<LiveMottoQuery, LiveMottoQueryVariables>;
export const LivesIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LivesId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<LivesIdQuery, LivesIdQueryVariables>;
export const UpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const UpsertOrderAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertOrderAddress"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddressCreateWithoutOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOrderAddress"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}}]} as unknown as DocumentNode<UpsertOrderAddressMutation, UpsertOrderAddressMutationVariables>;
export const UpdateOrderCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderCustomerMutation, UpdateOrderCustomerMutationVariables>;
export const UpdateLineOnOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLineOnOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineUpdateWithoutOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLineOnOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderLineDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]} as unknown as DocumentNode<UpdateLineOnOrderMutation, UpdateLineOnOrderMutationVariables>;
export const UpsertLineOnOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertLineOnOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineCreateManyOrderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertLineOnOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderLineDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]} as unknown as DocumentNode<UpsertLineOnOrderMutation, UpsertLineOnOrderMutationVariables>;
export const RemoveLineFromOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveLineFromOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeLineFromOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderLineDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCancellationDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCancellationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineCancellation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineCode"}},{"kind":"Field","name":{"kind":"Name","value":"lineName"}},{"kind":"Field","name":{"kind":"Name","value":"linePrice"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]} as unknown as DocumentNode<RemoveLineFromOrderMutation, RemoveLineFromOrderMutationVariables>;
export const RecalculateOrderTotalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecalculateOrderTotal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recalculateOrderTotal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<RecalculateOrderTotalMutation, RecalculateOrderTotalMutationVariables>;
export const ProcessOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProcessOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ProcessOrderMutation, ProcessOrderMutationVariables>;
export const CreateShipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateShipmentMutation, CreateShipmentMutationVariables>;
export const CreateShipmentDpdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateShipmentDPD"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"count"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createShipmentDPD"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"count"},"value":{"kind":"Variable","name":{"kind":"Name","value":"count"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateShipmentDpdMutation, CreateShipmentDpdMutationVariables>;
export const DeleteShipmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteShipment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteShipment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<DeleteShipmentMutation, DeleteShipmentMutationVariables>;
export const SetIbanTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetIbanType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ibanType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setIbanType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ibanType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ibanType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<SetIbanTypeMutation, SetIbanTypeMutationVariables>;
export const SetShippingMethodOnOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetShippingMethodOnOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shippingMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setShippingMethodOnOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shippingMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shippingMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<SetShippingMethodOnOrderMutation, SetShippingMethodOnOrderMutationVariables>;
export const SetPaymentMethodOnOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPaymentMethodOnOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPaymentMethodOnOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"paymentMethodId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentMethodId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<SetPaymentMethodOnOrderMutation, SetPaymentMethodOnOrderMutationVariables>;
export const CancelOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CancelOrderMutation, CancelOrderMutationVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const SendMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<SendMessagesMutation, SendMessagesMutationVariables>;
export const IssueInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssueInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldSend"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shouldSend"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldSend"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}}]}}]}}]} as unknown as DocumentNode<IssueInvoiceMutation, IssueInvoiceMutationVariables>;
export const IssueInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssueInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderIds"}}}]}]}}]} as unknown as DocumentNode<IssueInvoicesMutation, IssueInvoicesMutationVariables>;
export const ShippingOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShippingOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"parcels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"statuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusDate"}},{"kind":"Field","name":{"kind":"Name","value":"statusDescription"}},{"kind":"Field","name":{"kind":"Name","value":"statusInfo"}},{"kind":"Field","name":{"kind":"Name","value":"depotCity"}},{"kind":"Field","name":{"kind":"Name","value":"depotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}}]}}]}}]} as unknown as DocumentNode<ShippingOrderQuery, ShippingOrderQueryVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderDetails"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderAddressDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCustomerDetails"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"isEcho"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderLineDetails"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cancellations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OrderCancellationDetails"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Order"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderAddressDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderAddress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"addressId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCustomerDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Customer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"pageId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"streetLine"}},{"kind":"Field","name":{"kind":"Name","value":"streetDescription"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderLineDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLine"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"productVariantId"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OrderCancellationDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineCancellation"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lineCode"}},{"kind":"Field","name":{"kind":"Name","value":"lineName"}},{"kind":"Field","name":{"kind":"Name","value":"linePrice"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const CountOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountOrdersQuery, CountOrdersQueryVariables>;
export const LiveOrdersSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveOrdersSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveOrdersSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"all"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cash"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"processed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipped"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delivered"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reserved"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"packed"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leftCods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leftPersonal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leftBank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"leftCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unpaidBank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unpaidCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unpaidCods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentProblems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]}}]} as unknown as DocumentNode<LiveOrdersSummaryQuery, LiveOrdersSummaryQueryVariables>;
export const OrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}}]}}]}}]}}]} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const OrdersTabletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersTablet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<OrdersTabletQuery, OrdersTabletQueryVariables>;
export const OrdersTabletSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrdersTabletSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ordersTabletSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<OrdersTabletSummaryQuery, OrdersTabletSummaryQueryVariables>;
export const PersonalPickupOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonalPickupOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PersonalPickupSearch"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalPickupOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<PersonalPickupOrdersQuery, PersonalPickupOrdersQueryVariables>;
export const PersonalPickupDeliveredOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonalPickupDeliveredOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personalPickupDeliveredOrders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"packedBy"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<PersonalPickupDeliveredOrdersQuery, PersonalPickupDeliveredOrdersQueryVariables>;
export const ParcelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Parcels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParcelWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParcelOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parcels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"trackingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"statuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusDate"}},{"kind":"Field","name":{"kind":"Name","value":"statusDescription"}},{"kind":"Field","name":{"kind":"Name","value":"statusInfo"}},{"kind":"Field","name":{"kind":"Name","value":"depotCity"}},{"kind":"Field","name":{"kind":"Name","value":"depotNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParcelsQuery, ParcelsQueryVariables>;
export const CountParcelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountParcels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParcelWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countParcels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountParcelsQuery, CountParcelsQueryVariables>;
export const ParcelStatusGroupByDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParcelStatusGroupBy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"by"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParcelStatusScalarFieldEnum"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ParcelStatusWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ParcelStatusOrderByWithAggregationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"parcelStatusGroupBy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"by"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusCode"}},{"kind":"Field","name":{"kind":"Name","value":"statusDescription"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusCode"}}]}}]}}]}}]} as unknown as DocumentNode<ParcelStatusGroupByQuery, ParcelStatusGroupByQueryVariables>;
export const PaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Payments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<PaymentsQuery, PaymentsQueryVariables>;
export const UpdatePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const DeletePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const CountProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countProducts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountProductsQuery, CountProductsQueryVariables>;
export const DeleteProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProductMutation, DeleteProductMutationVariables>;
export const ProductVariantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductVariant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productVariant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductVariantQuery, ProductVariantQueryVariables>;
export const ProductModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductModal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"canRemove"}},{"kind":"Field","name":{"kind":"Name","value":"liveId"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductModalQuery, ProductModalQueryVariables>;
export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantsOrdersBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"canRemove"}},{"kind":"Field","name":{"kind":"Name","value":"reservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantsOrdersBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const ProductListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"canRemove"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<ProductListQuery, ProductListQueryVariables>;
export const ProductLivesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductLives"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiveOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lives"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProductLivesQuery, ProductLivesQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"canRemove"}},{"kind":"Field","name":{"kind":"Name","value":"live"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variants"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const ProductsCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<ProductsCodeQuery, ProductsCodeQueryVariables>;
export const ProductsTabletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsTablet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<ProductsTabletQuery, ProductsTabletQueryVariables>;
export const ProductTabletDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTablet"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantsOrdersBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantsOrdersBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductTabletQuery, ProductTabletQueryVariables>;
export const ProductTabletSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductTabletSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantsOrderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantOrderByWithRelationInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productTabletSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"variantsOrderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantsOrderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"recentLinesCount"}},{"kind":"Field","name":{"kind":"Name","value":"prevLinesCount"}},{"kind":"Field","name":{"kind":"Name","value":"secondsSinceLastSale"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linesCount"}},{"kind":"Field","name":{"kind":"Name","value":"linesSum"}},{"kind":"Field","name":{"kind":"Name","value":"reservationsCount"}}]}}]}}]}}]} as unknown as DocumentNode<ProductTabletSummaryQuery, ProductTabletSummaryQueryVariables>;
export const SetProductActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetProductActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"active"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"active"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<SetProductActiveMutation, SetProductActiveMutationVariables>;
export const SetProductCanRemoveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetProductCanRemove"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"canRemove"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"canRemove"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"set"},"value":{"kind":"Variable","name":{"kind":"Name","value":"canRemove"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canRemove"}}]}}]}}]} as unknown as DocumentNode<SetProductCanRemoveMutation, SetProductCanRemoveMutationVariables>;
export const IncrementProductVariantStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncrementProductVariantStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productVariantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"increment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"incrementVariantStock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productVariantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"increment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"increment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}}]}}]}}]} as unknown as DocumentNode<IncrementProductVariantStockMutation, IncrementProductVariantStockMutationVariables>;
export const DecrementProductVariantStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DecrementProductVariantStock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productVariantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"decrement"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decrementVariantStock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productVariantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productVariantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"decrement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"decrement"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}}]}}]}}]} as unknown as DocumentNode<DecrementProductVariantStockMutation, DecrementProductVariantStockMutationVariables>;
export const RemoveProductVariantFromOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProductVariantFromOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productVariantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProductVariantFromOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productVarianId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productVariantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<RemoveProductVariantFromOrdersMutation, RemoveProductVariantFromOrdersMutationVariables>;
export const RemoveProductVariantOrderLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveProductVariantOrderLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProductVariantOrderLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<RemoveProductVariantOrderLineMutation, RemoveProductVariantOrderLineMutationVariables>;
export const AddVariantToProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddVariantToProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stock"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductVariantAttributeCreateWithoutVariantInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addVariantToProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"stock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stock"}}},{"kind":"Argument","name":{"kind":"Name","value":"attributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]} as unknown as DocumentNode<AddVariantToProductMutation, AddVariantToProductMutationVariables>;
export const BulkUpdateProductPriceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateProductPrice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPrice"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateProductPrice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newPrice"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPrice"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<BulkUpdateProductPriceMutation, BulkUpdateProductPriceMutationVariables>;
export const BulkUpdateProductDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkUpdateProductDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newDescription"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateProductDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"productId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}},{"kind":"Argument","name":{"kind":"Name","value":"newName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newName"}}},{"kind":"Argument","name":{"kind":"Name","value":"newDescription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newDescription"}}}]}]}}]} as unknown as DocumentNode<BulkUpdateProductDetailsMutation, BulkUpdateProductDetailsMutationVariables>;
export const CountActiveCartsForProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountActiveCartsForProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countOrders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"EnumValue","value":"CREATED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lines"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productVariant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"is"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"productId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}]}}]}}]}}]}}]}}]}}]}]}}]} as unknown as DocumentNode<CountActiveCartsForProductQuery, CountActiveCartsForProductQueryVariables>;
export const UpsertProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertProduct"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProductUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertProduct"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertProductMutation, UpsertProductMutationVariables>;
export const DeleteRefundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRefund"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteRefund"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteRefundMutation, DeleteRefundMutationVariables>;
export const RefundCustomerSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefundCustomerSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"refunds"}}]}}]}}]}}]} as unknown as DocumentNode<RefundCustomerSearchQuery, RefundCustomerSearchQueryVariables>;
export const RefundCustomerOrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefundCustomerOrders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<RefundCustomerOrdersQuery, RefundCustomerOrdersQueryVariables>;
export const RefundStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RefundStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refunds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RefundStatisticsQuery, RefundStatisticsQueryVariables>;
export const CountRefundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CountRefunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countRefunds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<CountRefundsQuery, CountRefundsQueryVariables>;
export const RefundsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Refunds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refunds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"exportedAt"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lines"}}]}}]}}]}}]} as unknown as DocumentNode<RefundsQuery, RefundsQueryVariables>;
export const RefundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Refund"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refund"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"exportedAt"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"package"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RefundQuery, RefundQueryVariables>;
export const UpsertRefundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertRefund"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertRefund"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpsertRefundMutation, UpsertRefundMutationVariables>;
export const UpdateRefundDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRefund"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RefundUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRefund"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateRefundMutation, UpdateRefundMutationVariables>;
export const ShippingMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shippingMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]}}]} as unknown as DocumentNode<ShippingMethodsQuery, ShippingMethodsQueryVariables>;
export const PaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const UpdateShippingMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShippingMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethodWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShippingMethodUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShippingMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateShippingMethodMutation, UpdateShippingMethodMutationVariables>;
export const LiveStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LiveStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liveId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveStatistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"liveId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liveId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelledTotal"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledCount"}},{"kind":"Field","name":{"kind":"Name","value":"realLostTotal"}},{"kind":"Field","name":{"kind":"Name","value":"realLostCustomerCount"}},{"kind":"Field","name":{"kind":"Name","value":"swapTotal"}},{"kind":"Field","name":{"kind":"Name","value":"swapCustomerCount"}},{"kind":"Field","name":{"kind":"Name","value":"adminCancelledTotal"}},{"kind":"Field","name":{"kind":"Name","value":"adminCancelledCustomerCount"}},{"kind":"Field","name":{"kind":"Name","value":"intervals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledTotal"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledTotal"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledCount"}}]}}]}}]}}]} as unknown as DocumentNode<LiveStatisticsQuery, LiveStatisticsQueryVariables>;
export const RevenueStatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RevenueStatistics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"from"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"to"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revenueStatistics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"from"},"value":{"kind":"Variable","name":{"kind":"Name","value":"from"}}},{"kind":"Argument","name":{"kind":"Name","value":"to"},"value":{"kind":"Variable","name":{"kind":"Name","value":"to"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"shippingRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"paymentRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"customRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"grossInflow"}},{"kind":"Field","name":{"kind":"Name","value":"refundsTotal"}},{"kind":"Field","name":{"kind":"Name","value":"orderCount"}},{"kind":"Field","name":{"kind":"Name","value":"unitsSold"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueCustomerCount"}},{"kind":"Field","name":{"kind":"Name","value":"newCustomerCount"}},{"kind":"Field","name":{"kind":"Name","value":"paidTotal"}},{"kind":"Field","name":{"kind":"Name","value":"unpaidTotal"}},{"kind":"Field","name":{"kind":"Name","value":"paidOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"unpaidOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"byPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"orderCount"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"paidTotal"}},{"kind":"Field","name":{"kind":"Name","value":"unpaidTotal"}},{"kind":"Field","name":{"kind":"Name","value":"paidOrderCount"}},{"kind":"Field","name":{"kind":"Name","value":"unpaidOrderCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byLive"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"liveId"}},{"kind":"Field","name":{"kind":"Name","value":"liveName"}},{"kind":"Field","name":{"kind":"Name","value":"liveDate"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"productRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"orderCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"units"}}]}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"productRevenue"}},{"kind":"Field","name":{"kind":"Name","value":"paidTotal"}}]}}]}}]}}]} as unknown as DocumentNode<RevenueStatisticsQuery, RevenueStatisticsQueryVariables>;
export const ExpensesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Expenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<ExpensesQuery, ExpensesQueryVariables>;
export const CreateExpenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateExpense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExpenseType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExpense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<CreateExpenseMutation, CreateExpenseMutationVariables>;
export const UpdateExpenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateExpense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateExpense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]} as unknown as DocumentNode<UpdateExpenseMutation, UpdateExpenseMutationVariables>;
export const DeleteExpenseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteExpense"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExpense"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteExpenseMutation, DeleteExpenseMutationVariables>;
export const SettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Setting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<SettingQuery, SettingQueryVariables>;
export const UpsertSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<UpsertSettingMutation, UpsertSettingMutationVariables>;
export const ActiveProductsStockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveProductsStock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeProductsStock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}},{"kind":"Field","name":{"kind":"Name","value":"attributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ActiveProductsStockQuery, ActiveProductsStockQueryVariables>;
export const UpsertUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"create"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"update"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"create"},"value":{"kind":"Variable","name":{"kind":"Name","value":"create"}}},{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"Variable","name":{"kind":"Name","value":"update"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertUserMutation, UpsertUserMutationVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const LatestActiveProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestActiveProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestActiveProduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stock"}}]}}]}}]}}]} as unknown as DocumentNode<LatestActiveProductQuery, LatestActiveProductQueryVariables>;